var Ur = Object.defineProperty;
var Hr = (e, t, n) => t in e ? Ur(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Jt = (e, t, n) => Hr(e, typeof t != "symbol" ? t + "" : t, n);
import { jsx as s, jsxs as d, Fragment as re } from "react/jsx-runtime";
import { QueryClient as Gr, QueryClientProvider as qr, useMutation as qe, useQueryClient as An, useQuery as zn } from "@tanstack/react-query";
import { useState as z, useCallback as V, useMemo as Q, useContext as Ee, createContext as je, useRef as P, useEffect as K, useReducer as Vr, useLayoutEffect as lt, Fragment as Jr, memo as Ye } from "react";
import Xr from "ky";
import { useReducedMotion as Yr, motion as Xt, AnimatePresence as Qr } from "framer-motion";
import Pn from "react-markdown";
import Dn from "remark-gfm";
import { createPortal as Pt } from "react-dom";
const Zr = "agt_formant_chat", En = "console.incidentsSeenRunIds", ei = 500, ti = 1440 * 60 * 1e3;
function ni() {
  try {
    const e = localStorage.getItem(En);
    if (!e) return /* @__PURE__ */ new Set();
    const t = JSON.parse(e);
    return Array.isArray(t) ? new Set(t.filter((n) => typeof n == "string")) : /* @__PURE__ */ new Set();
  } catch {
    return /* @__PURE__ */ new Set();
  }
}
function ri(e) {
  try {
    const t = [...e].slice(-ei);
    localStorage.setItem(En, JSON.stringify(t));
  } catch {
  }
}
function Yt(e, t) {
  if (t.has(e.id)) return !1;
  const n = e.startedAt ?? e.createdAt, r = n ? new Date(n).getTime() : 0;
  return Date.now() - r <= ti;
}
const jn = je(null), et = [];
function ii({ children: e }) {
  const [t, n] = z({}), [r, i] = z({}), [a, o] = z(() => ni()), l = V((g) => {
    g && o((k) => {
      if (k.has(g)) return k;
      const x = new Set(k);
      return x.add(g), ri(x), x;
    });
  }, []), c = V(
    (g, k) => {
      !g || !k || (n((x) => {
        const b = x[g] ?? et;
        return b.includes(k) ? x : { ...x, [g]: [...b, k] };
      }), l(k));
    },
    [l]
  ), u = V((g, k) => {
    n((x) => {
      const b = x[g];
      return !b || !b.includes(k) ? x : { ...x, [g]: b.filter((M) => M !== k) };
    });
  }, []), h = V((g, k) => {
    !g || !k || (n((x) => {
      const b = x[g];
      return !b || !b.includes(k) ? x : { ...x, [g]: b.filter((M) => M !== k) };
    }), i((x) => {
      const b = x[g] ?? et;
      return b.includes(k) ? x : { ...x, [g]: [...b, k] };
    }));
  }, []), f = V(
    (g) => t[g] ?? et,
    [t]
  ), m = V(
    (g) => r[g] ?? et,
    [r]
  ), y = Q(
    () => ({ injectionsFor: f, inject: c, remove: u, detach: h, detachedFor: m, seenIds: a, markSeen: l }),
    [f, c, u, h, m, a, l]
  );
  return /* @__PURE__ */ s(jn.Provider, { value: y, children: e });
}
function Dt() {
  const e = Ee(jn);
  if (!e)
    throw new Error("useIncidentInjections must be used inside <IncidentInjectionProvider>");
  return e;
}
class ai {
  constructor(t) {
    Jt(this, "http");
    this.http = Xr.create({
      prefixUrl: t.baseUrl.replace(/\/$/, ""),
      timeout: t.timeout ?? 3e4,
      hooks: {
        beforeRequest: [
          (n) => {
            t.jwt && n.headers.set("Authorization", `Bearer ${t.jwt}`);
          }
        ],
        afterResponse: [
          (n, r, i) => {
            var a;
            i.status === 401 && ((a = t.onUnauthorized) == null || a.call(t));
          }
        ]
      }
    });
  }
}
const Ln = je(null), si = Ln.Provider;
function mt() {
  const e = Ee(Ln);
  if (!e)
    throw new Error("useCortexClient must be used within a <ChatProvider>.");
  return e;
}
function oi(e) {
  return e.startsWith("mcp_") ? e.slice(4) : e;
}
const Qt = 200;
let ve = Object.freeze([]);
const it = /* @__PURE__ */ new Set();
function li() {
  for (const e of it)
    try {
      e();
    } catch (t) {
      console.error("mcp-activity-bus listener threw", t);
    }
}
function Zt(e) {
  const t = e.length > Qt ? e.slice(e.length - Qt) : e;
  ve = Object.freeze(t), li();
}
const ct = {
  publishCall(e) {
    if (ve.some((n) => n.id === e.toolCallId)) return;
    const t = {
      id: e.toolCallId,
      ts: Date.now(),
      source: e.source ?? "chat",
      threadId: e.threadId,
      name: oi(e.name),
      qualifiedName: e.name,
      args: e.args,
      status: "pending"
    };
    Zt([...ve, t]);
  },
  publishResult(e) {
    const t = ve.findIndex((a) => a.id === e.toolCallId);
    if (t === -1)
      return;
    const n = ve[t];
    if (!n) return;
    const r = {
      id: n.id,
      ts: n.ts,
      source: n.source,
      threadId: n.threadId,
      name: n.name,
      qualifiedName: n.qualifiedName,
      args: n.args,
      status: e.error ? "error" : "ok",
      result: e.result,
      durationMs: e.durationMs,
      error: e.error
    }, i = ve.slice();
    i[t] = r, Zt(i);
  },
  subscribe(e) {
    return it.add(e), () => {
      it.delete(e);
    };
  },
  getSnapshot() {
    return ve;
  },
  /** Test-only. Drops every record and listener. */
  _reset() {
    ve = Object.freeze([]), it.clear();
  }
};
let Et = "";
function bl() {
  return Et;
}
function ci(e) {
  Et = (e ?? "").replace(/\/$/, "");
}
function On() {
  return `${Et}/api`;
}
async function ui(e, t, n) {
  const r = { "Content-Type": t };
  n && (r.Authorization = `Bearer ${n}`);
  const i = await fetch(`${On()}/transcribe`, {
    method: "POST",
    headers: r,
    body: e
  });
  if (!i.ok) {
    let o = "";
    try {
      o = await i.text();
    } catch {
    }
    throw new Error(`transcribe failed: ${i.status} ${o}`.trim());
  }
  return (await i.json()).text;
}
async function di(e, t, n = "leo") {
  const r = { "Content-Type": "application/json" };
  t && (r.Authorization = `Bearer ${t}`);
  const i = { text: e, voice: n }, a = await fetch(`${On()}/tts`, {
    method: "POST",
    headers: r,
    body: JSON.stringify(i)
  });
  if (!a.ok)
    throw new Error(`tts failed: ${a.status}`);
  return (await a.json()).audioUrl;
}
const Fn = je(null);
function Qe() {
  const e = Ee(Fn);
  if (!e)
    throw new Error(
      "useChatConfig must be used within a <ChatProvider>. Wrap your app (or the chat mount) in <ChatProvider>."
    );
  return e;
}
function fi(e) {
  if (!e) return "anon";
  try {
    const t = e.split(".")[1];
    if (!t) return "anon";
    const n = t.replace(/-/g, "+").replace(/_/g, "/"), r = n.padEnd(Math.ceil(n.length / 4) * 4, "="), i = JSON.parse(atob(r)), a = i.sub ?? i.org ?? i.orgId;
    return typeof a == "string" && a.length > 0 ? a : "anon";
  } catch {
    return "anon";
  }
}
function vl({
  cortexApiBaseUrl: e,
  token: t,
  ready: n,
  onNavigate: r,
  pageCatalog: i,
  groupId: a,
  theopolisBaseUrl: o,
  onUnauthorized: l,
  onToolCall: c,
  onToolResult: u,
  queryClient: h,
  incidentsAdapter: f,
  onNotify: m,
  children: y
}) {
  ci(o);
  const [g] = z(
    () => new Gr({
      defaultOptions: {
        queries: { staleTime: 3e4, retry: 1, refetchOnWindowFocus: !1 }
      }
    })
  ), k = h ?? g, x = Q(() => fi(t), [t]), b = Q(
    () => new ai({ baseUrl: e, jwt: t, onUnauthorized: l }),
    [e, t, l]
  ), M = Q(
    () => ({
      token: t,
      ready: n,
      cortexApiBaseUrl: e.replace(/\/$/, ""),
      groupId: a ?? Zr,
      identityKey: x,
      pageCatalog: i ?? [],
      // Passed through as null when absent — a no-op stub here would make the
      // chat mark navigate_to_page tool calls handled while nothing happened.
      onNavigate: r ?? null,
      voiceEnabled: !!o,
      incidentsAdapter: f ?? null,
      onNotify: m ?? null
    }),
    [
      t,
      n,
      e,
      a,
      x,
      i,
      r,
      o,
      f,
      m
    ]
  ), $ = P(c), N = P(u);
  K(() => {
    $.current = c, N.current = u;
  }, [c, u]);
  const E = P(/* @__PURE__ */ new Set()), j = P(/* @__PURE__ */ new Set());
  return K(() => {
    const S = () => {
      var _, I;
      for (const p of ct.getSnapshot())
        E.current.has(p.id) || (E.current.add(p.id), (_ = $.current) == null || _.call($, p)), p.status !== "pending" && !j.current.has(p.id) && (j.current.add(p.id), (I = N.current) == null || I.call(N, p));
    };
    return S(), ct.subscribe(S);
  }, []), /* @__PURE__ */ s(qr, { client: k, children: /* @__PURE__ */ s(si, { value: b, children: /* @__PURE__ */ s(Fn.Provider, { value: M, children: /* @__PURE__ */ s(ii, { children: y }) }) }) });
}
const hi = 300 * 1e3;
function mi(e, t) {
  const { token: n } = Qe(), [r, i] = z("idle"), [a, o] = z(null), l = P(null), c = P(null), u = P([]), h = P("audio/webm"), f = P(null), m = P(!1);
  function y() {
    f.current !== null && (clearTimeout(f.current), f.current = null);
  }
  function g() {
    var N;
    (N = c.current) == null || N.getTracks().forEach((E) => E.stop()), c.current = null, l.current = null;
  }
  async function k() {
    if (r === "idle") {
      o(null), t == null || t();
      try {
        const N = await navigator.mediaDevices.getUserMedia({ audio: !0 });
        c.current = N;
        const E = pi();
        h.current = E;
        const j = new MediaRecorder(N, E ? { mimeType: E } : void 0);
        l.current = j, u.current = [], m.current = !1, j.addEventListener("dataavailable", (S) => {
          S.data && S.data.size > 0 && u.current.push(S.data);
        }), j.addEventListener("stop", () => {
          if (y(), m.current) {
            m.current = !1, u.current = [], g(), i("idle");
            return;
          }
          M();
        }), j.start(200), i("recording"), f.current = window.setTimeout(() => {
          var S;
          ((S = l.current) == null ? void 0 : S.state) === "recording" && l.current.stop();
        }, hi);
      } catch (N) {
        console.error("useDictation: getUserMedia failed", N), o("Microphone unavailable."), i("idle"), g();
      }
    }
  }
  function x() {
    var N;
    if (r === "recording") {
      i("transcribing");
      try {
        (N = l.current) == null || N.stop();
      } catch (E) {
        console.error("useDictation: recorder.stop failed", E);
      }
    }
  }
  function b() {
    var N;
    if (r === "recording") {
      m.current = !0, y();
      try {
        (N = l.current) == null || N.stop();
      } catch (E) {
        console.error("useDictation: recorder.stop (cancel) failed", E);
      }
    }
  }
  async function M() {
    const N = u.current;
    u.current = [];
    const E = h.current || "audio/webm";
    if (g(), N.length === 0) {
      i("idle");
      return;
    }
    const j = new Blob(N, { type: E });
    try {
      const S = await ui(j, E, n);
      S.trim() && e(S.trim());
    } catch (S) {
      console.error("useDictation: transcribe failed", S), o("Could not transcribe audio — try again"), setTimeout(() => o(null), 4e3);
    } finally {
      i("idle");
    }
  }
  function $() {
    r === "recording" ? x() : r === "idle" && (k(), void 0);
  }
  return K(() => () => {
    var N;
    y();
    try {
      ((N = l.current) == null ? void 0 : N.state) === "recording" && l.current.stop();
    } catch {
    }
    g();
  }, []), { state: r, error: a, toggle: $, start: () => (k(), void 0), stop: x, cancel: b };
}
function pi() {
  const e = ["audio/webm;codecs=opus", "audio/webm", "audio/ogg;codecs=opus", "audio/mp4"];
  for (const t of e)
    if (typeof MediaRecorder < "u" && MediaRecorder.isTypeSupported(t)) return t;
  return "";
}
const gi = { w: 720, h: 640 }, en = 360, tn = 320, nn = 24, Wn = "console.chatPanelSize", Bn = "console.chatPanelPos", Kn = "console.chatRailCollapsed";
function St(e, t) {
  const n = Math.max(en, t.w - nn), r = Math.max(tn, t.h - nn);
  return {
    w: ut(e.w, en, n),
    h: ut(e.h, tn, r)
  };
}
function rn(e, t, n) {
  return {
    x: ut(e.x, 0, Math.max(0, n.w - t.w)),
    y: ut(e.y, 0, Math.max(0, n.h - t.h))
  };
}
function yi(e) {
  const t = Vn(Wn), n = xi(t) ? { w: t.w, h: t.h } : gi;
  return St(n, e);
}
function bi(e) {
  Jn(Wn, { w: Math.round(e.w), h: Math.round(e.h) });
}
function vi() {
  const e = Vn(Bn);
  return Si(e) ? { x: e.x, y: e.y } : null;
}
function wi(e) {
  Jn(Bn, { x: Math.round(e.x), y: Math.round(e.y) });
}
function ki() {
  try {
    return localStorage.getItem(Kn) === "1";
  } catch {
    return !1;
  }
}
function an(e) {
  try {
    localStorage.setItem(Kn, e ? "1" : "0");
  } catch {
  }
}
const Un = "console.incidentsRailOpen", Hn = "console.launcherIncidentsRailOpen";
function wl() {
  try {
    return localStorage.getItem(Un) === "1";
  } catch {
    return !1;
  }
}
function kl(e) {
  try {
    localStorage.setItem(Un, e ? "1" : "0");
  } catch {
  }
}
function _i() {
  try {
    return localStorage.getItem(Hn) === "1";
  } catch {
    return !1;
  }
}
function Ni(e) {
  try {
    localStorage.setItem(Hn, e ? "1" : "0");
  } catch {
  }
}
function Gn(e, t) {
  try {
    const n = localStorage.getItem(`console.${e}`), r = n === null ? NaN : Number(n);
    return Number.isFinite(r) && r > 0 ? r : t;
  } catch {
    return t;
  }
}
function qn(e, t) {
  try {
    localStorage.setItem(`console.${e}`, String(Math.round(t)));
  } catch {
  }
}
function ut(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function xi(e) {
  return typeof e == "object" && e !== null && Number.isFinite(e.w) && Number.isFinite(e.h);
}
function Si(e) {
  return typeof e == "object" && e !== null && Number.isFinite(e.x) && Number.isFinite(e.y);
}
function Vn(e) {
  try {
    const t = localStorage.getItem(e);
    return t ? JSON.parse(t) : null;
  } catch {
    return null;
  }
}
function Jn(e, t) {
  try {
    localStorage.setItem(e, JSON.stringify(t));
  } catch {
  }
}
function Ci(e, t, n, r, i, a) {
  const o = `${e.replace(/\/$/, "")}/v1/persistent-agent-groups/${t}/agents/${n}/stream`;
  let l = null, c = !1, u = null, h = null;
  const f = (b) => {
    try {
      i(JSON.parse(b.data));
    } catch (M) {
      console.info("console/sse:pa-watch-parse", M);
    }
  }, m = () => {
    var b, M;
    (b = a == null ? void 0 : a.onReconnect) == null || b.call(a), (M = a == null ? void 0 : a.onConnectionChange) == null || M.call(a, "live");
  }, y = () => {
    l && (l.removeEventListener("message", f), l.removeEventListener("open", m), l.removeEventListener("error", k), l.close(), l = null);
  }, g = () => {
    c || u !== null || (u = window.setTimeout(() => {
      u = null, x();
    }, 1500));
  }, k = () => {
    var b;
    l && l.readyState === EventSource.CLOSED && ((b = a == null ? void 0 : a.onConnectionChange) == null || b.call(a, "reconnecting"), y(), g());
  }, x = () => {
    var N;
    if (c) return;
    h !== null && (window.clearTimeout(h), h = null);
    const b = new URL(o), M = r();
    M && b.searchParams.set("access_token", M);
    const $ = Mi(M);
    if ($ !== null) {
      const E = $ * 1e3 - Date.now() - 6e4;
      E > 0 && (h = window.setTimeout(() => {
        h = null, y(), x();
      }, E));
    }
    try {
      l = new EventSource(b.toString(), { withCredentials: !0 });
    } catch (E) {
      console.warn("console/sse:pa-watch", E), (N = a == null ? void 0 : a.onConnectionChange) == null || N.call(a, "reconnecting"), g();
      return;
    }
    l.addEventListener("message", f), l.addEventListener("open", m), l.addEventListener("error", k);
  };
  return x(), () => {
    c = !0, u !== null && (window.clearTimeout(u), u = null), h !== null && (window.clearTimeout(h), h = null), y();
  };
}
function Mi(e) {
  if (!e) return null;
  try {
    const t = e.split(".")[1];
    if (!t) return null;
    const n = JSON.parse(atob(t.replace(/-/g, "+").replace(/_/g, "/")));
    if (typeof n != "object" || n === null) return null;
    const r = n.exp;
    return typeof r == "number" ? r : null;
  } catch {
    return null;
  }
}
const $i = 200, Ti = 1200, sn = 200, Ii = 2e3, Xn = {
  status: null,
  activity: null,
  facts: {},
  events: [],
  transcript: [],
  turns: {}
};
function Yn(e, t) {
  switch (t.kind) {
    case "fact":
      return {
        ...e,
        facts: {
          ...e.facts,
          [t.laneId]: {
            laneId: t.laneId,
            factType: t.factType,
            summary: t.summary,
            data: t.data,
            date: t.date
          }
        }
      };
    case "event":
      return {
        ...e,
        events: [
          {
            eventKind: t.eventKind,
            content: t.content,
            source: t.source,
            wokeFromIdle: t.wokeFromIdle,
            interrupted: t.interrupted,
            runId: t.runId,
            at: t.at
          },
          ...e.events
        ].slice(0, $i)
      };
    case "status":
      return { ...e, status: t.status };
    case "activity":
      return { ...e, activity: { text: t.text, at: t.at } };
    case "chunk":
      return { ...e, transcript: [...e.transcript, t.part] };
    case "chunk-batch":
      return { ...e, transcript: [...e.transcript, ...t.parts] };
    case "turn":
      return { ...e, turns: { ...e.turns, [t.turn.id]: t.turn } };
    case "replay":
      return t.frames.reduce(Yn, Xn);
    default:
      return e;
  }
}
function Ri(e, t) {
  const { token: n, cortexApiBaseUrl: r } = Qe(), i = P(n);
  i.current = n;
  const [a, o] = Vr(Yn, Xn), [l, c] = z("live"), [u, h] = z(!1), f = P([]), m = P(null), y = P(!1), g = P([]), k = P(null), x = P(null), b = P(null);
  return K(() => {
    o({ kind: "replay", frames: [] }), h(!1);
    const M = 80, $ = () => {
      if (m.current !== null && (window.clearTimeout(m.current), m.current = null), f.current.length > 0) {
        const _ = f.current;
        f.current = [], o({ kind: "chunk-batch", parts: _ });
      }
    }, N = () => {
      if (!y.current) return;
      y.current = !1, k.current !== null && (window.clearTimeout(k.current), k.current = null), x.current !== null && (window.clearTimeout(x.current), x.current = null);
      const _ = g.current;
      g.current = [], o({ kind: "replay", frames: _ }), h(!0);
    }, E = (_) => {
      if (_ === "live") {
        b.current !== null && (window.clearTimeout(b.current), b.current = null), c("live");
        return;
      }
      b.current === null && (b.current = window.setTimeout(() => {
        b.current = null, c("reconnecting");
      }, Ti));
    }, j = r.replace(/\/$/, ""), S = Ci(
      j,
      e,
      t,
      () => i.current,
      (_) => {
        const I = _;
        if (y.current) {
          g.current.push(I), k.current !== null && window.clearTimeout(k.current), k.current = window.setTimeout(N, sn);
          return;
        }
        if (I.kind === "chunk") {
          f.current.push(I.part), m.current === null && (m.current = window.setTimeout($, M));
          return;
        }
        $(), o(I);
      },
      {
        onConnectionChange: E,
        onReconnect: () => {
          f.current = [], m.current !== null && (clearTimeout(m.current), m.current = null), y.current = !0, g.current = [], k.current !== null && window.clearTimeout(k.current), k.current = window.setTimeout(N, sn), x.current !== null && window.clearTimeout(x.current), x.current = window.setTimeout(N, Ii);
        }
      }
    );
    return () => {
      $(), S(), b.current !== null && (window.clearTimeout(b.current), b.current = null), k.current !== null && (window.clearTimeout(k.current), k.current = null), x.current !== null && (window.clearTimeout(x.current), x.current = null);
    };
  }, [e, t, r]), { ...a, connection: l, hasLoaded: u };
}
function Qn({ tone: e = "agent" }) {
  return /* @__PURE__ */ d("span", { className: `pa-chat-dots pa-chat-dots--${e}`, "aria-hidden": "true", children: [
    /* @__PURE__ */ s("span", {}),
    /* @__PURE__ */ s("span", {}),
    /* @__PURE__ */ s("span", {})
  ] });
}
function dt({ inline: e = !1 }) {
  const t = e ? 14 : 32, n = {
    width: t,
    height: t,
    borderRadius: "50%",
    border: `${e ? 1.5 : 3}px solid var(--border)`,
    borderTopColor: "var(--horizon-glow)"
  };
  return e ? /* @__PURE__ */ s("span", { className: "pa-chat-spinner", style: { ...n, display: "inline-block" } }) : /* @__PURE__ */ s("div", { style: { display: "grid", placeItems: "center", padding: "var(--sp-9) 0" }, children: /* @__PURE__ */ s("div", { className: "pa-chat-spinner", style: n }) });
}
const Ai = new Intl.DateTimeFormat(void 0, {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit"
}), Ct = new Intl.DateTimeFormat(void 0, {
  hour: "numeric",
  minute: "2-digit"
}), Ve = "—", Zn = new Intl.DateTimeFormat(void 0, { weekday: "short" }), er = new Intl.DateTimeFormat(void 0, { month: "short", day: "numeric" });
function Je(e) {
  if (!e) return null;
  if (e instanceof Date) return Number.isNaN(e.getTime()) ? null : e;
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? null : t;
}
function jt(e, t) {
  let n = null;
  if (typeof e == "number")
    n = e;
  else {
    const l = Je(e), c = Je(t ?? null);
    if (!l) return Ve;
    n = ((c == null ? void 0 : c.getTime()) ?? Date.now()) - l.getTime();
  }
  if (n === null || n < 0 || !Number.isFinite(n)) return Ve;
  if (n < 1e3) return `${n.toFixed(0)} ms`;
  const r = Math.floor(n / 1e3);
  if (r < 60) return `${r}s`;
  const i = Math.floor(r / 60), a = r % 60;
  return i < 60 ? a ? `${i}m ${a}s` : `${i}m` : `${Math.floor(i / 60)}h ${i % 60}m`;
}
function tr(e) {
  const t = Je(e);
  if (!t) return Ve;
  const n = t.getTime() - Date.now(), r = Math.abs(n), i = Math.round(r / 1e3);
  let a, o;
  return i < 60 ? (a = i, o = "s") : i < 3600 ? (a = Math.round(i / 60), o = "m") : i < 86400 ? (a = Math.round(i / 3600), o = "h") : (a = Math.round(i / 86400), o = "d"), n < 0 ? `${a}${o} ago` : `in ${a}${o}`;
}
function zi(e) {
  const t = Je(e);
  if (!t) return Ve;
  const n = /* @__PURE__ */ new Date(), r = n.getTime() - t.getTime(), i = Math.round(r / 1e3);
  if (i < 60) return "just now";
  if (i < 3600) return `${Math.round(i / 60)}m ago`;
  const a = new Date(n.getFullYear(), n.getMonth(), n.getDate()), o = new Date(a.getTime() - 864e5), l = new Date(a.getTime() - 6 * 864e5);
  return t >= a ? Ct.format(t) : t >= o ? "Yesterday" : t >= l ? Zn.format(t) : er.format(t);
}
function nr(e) {
  const t = Je(e);
  if (!t) return Ve;
  const n = /* @__PURE__ */ new Date(), r = new Date(n.getFullYear(), n.getMonth(), n.getDate());
  if (t >= r) return Ct.format(t);
  const i = Ct.format(t), a = new Date(r.getTime() - 864e5);
  if (t >= a) return `Yesterday ${i}`;
  const o = new Date(r.getTime() - 6 * 864e5);
  return t >= o ? `${Zn.format(t)} ${i}` : t.getFullYear() === n.getFullYear() ? `${er.format(t)}, ${i}` : Ai.format(t);
}
function rr({
  images: e,
  index: t,
  onClose: n,
  onNavigate: r
}) {
  const i = P(null);
  return K(() => {
    var l, c;
    const a = document.activeElement, o = (l = i.current) == null ? void 0 : l.querySelectorAll("button");
    return (c = o == null ? void 0 : o[o.length - 1]) == null || c.focus(), () => {
      var u;
      return (u = a == null ? void 0 : a.focus) == null ? void 0 : u.call(a);
    };
  }, []), K(() => {
    function a(o) {
      if (o.key === "Escape") {
        n();
        return;
      }
      if (o.key === "ArrowLeft" && t > 0) {
        r(t - 1);
        return;
      }
      if (o.key === "ArrowRight" && t < e.length - 1) {
        r(t + 1);
        return;
      }
      if (o.key !== "Tab") return;
      const l = i.current;
      if (!l) return;
      const c = Array.from(l.querySelectorAll("button:not([disabled])")), u = c[0], h = c[c.length - 1];
      if (!u || !h) {
        o.preventDefault();
        return;
      }
      const f = document.activeElement;
      l.contains(f) ? o.shiftKey && f === u ? (o.preventDefault(), h.focus()) : !o.shiftKey && f === h && (o.preventDefault(), u.focus()) : (o.preventDefault(), u.focus());
    }
    return document.addEventListener("keydown", a), () => document.removeEventListener("keydown", a);
  }, [t, e.length, n, r]), Pt(
    /* @__PURE__ */ d(
      "div",
      {
        ref: i,
        className: "pa-chat-lightbox",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": `Image ${t + 1} of ${e.length}`,
        onClick: n,
        children: [
          /* @__PURE__ */ s(
            "img",
            {
              src: e[t],
              alt: `Image ${t + 1} of ${e.length}`,
              className: "pa-chat-lightbox-img",
              onClick: (a) => a.stopPropagation()
            }
          ),
          e.length > 1 && /* @__PURE__ */ d("div", { className: "pa-chat-lightbox-nav", onClick: (a) => a.stopPropagation(), children: [
            /* @__PURE__ */ s(
              "button",
              {
                type: "button",
                disabled: t === 0,
                onClick: () => r(t - 1),
                "aria-label": "Previous image",
                children: "←"
              }
            ),
            /* @__PURE__ */ d("span", { children: [
              t + 1,
              " / ",
              e.length
            ] }),
            /* @__PURE__ */ s(
              "button",
              {
                type: "button",
                disabled: t === e.length - 1,
                onClick: () => r(t + 1),
                "aria-label": "Next image",
                children: "→"
              }
            )
          ] }),
          /* @__PURE__ */ s("button", { type: "button", className: "pa-chat-lightbox-close", onClick: n, "aria-label": "Close", children: "✕" })
        ]
      }
    ),
    document.body
  );
}
function Lt({ images: e }) {
  const [t, n] = z(null);
  return e.length === 0 ? null : /* @__PURE__ */ d(re, { children: [
    /* @__PURE__ */ s("div", { className: "pa-chat-tool-images", children: e.map((r, i) => /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        className: "pa-chat-tool-image-link",
        onClick: () => n(i),
        title: "View image",
        children: /* @__PURE__ */ s(
          "img",
          {
            src: r,
            alt: `tool image ${i + 1}`,
            className: "pa-chat-tool-image",
            loading: "lazy",
            decoding: "async"
          }
        )
      },
      `${i}-${r.slice(0, 32)}`
    )) }),
    t !== null && /* @__PURE__ */ s(
      rr,
      {
        images: e,
        index: t,
        onClose: () => n(null),
        onNavigate: n
      }
    )
  ] });
}
function Pi({
  src: e,
  alt: t,
  className: n
}) {
  const [r, i] = z(!1);
  return /* @__PURE__ */ d(re, { children: [
    /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        className: "pa-chat-img-zoom",
        onClick: () => i(!0),
        title: "Expand image",
        children: /* @__PURE__ */ s("img", { src: e, alt: t ?? "", className: n, loading: "lazy", decoding: "async" })
      }
    ),
    r && /* @__PURE__ */ s(
      rr,
      {
        images: [e],
        index: 0,
        onClose: () => i(!1),
        onNavigate: () => {
        }
      }
    )
  ] });
}
function Di(e) {
  const t = [], n = (i, a) => {
    if (!a) return;
    const o = t[t.length - 1];
    o && o.kind === i ? o.text += a : t.push({ kind: i, text: a });
  }, r = (i) => i ? t.find(
    (a) => a.kind === "tool" && a.toolCallId === i
  ) ?? null : null;
  for (const i of e)
    switch (i.type) {
      case "user":
        t.push({
          kind: "user",
          text: i.text,
          source: i.source,
          eventKind: i.eventKind
        });
        break;
      case "text":
        n("text", i.text);
        break;
      case "reasoning":
        n("reasoning", i.text);
        break;
      case "tool-call": {
        const a = r(i.toolCallId);
        a ? (a.name = i.name || a.name, i.args !== void 0 && (a.args = i.args), i.mcpName && (a.mcpName = i.mcpName)) : t.push({
          kind: "tool",
          toolCallId: i.toolCallId,
          name: i.name,
          args: i.args,
          ...i.mcpName ? { mcpName: i.mcpName } : {},
          hasResult: !1
        });
        break;
      }
      case "tool-result": {
        const a = r(i.toolCallId);
        a ? (a.result = i.result, a.durationMs = i.durationMs, a.hasResult = !0, i.isError && (a.isError = !0)) : t.push({
          kind: "tool",
          toolCallId: i.toolCallId,
          name: i.name ?? "tool",
          args: void 0,
          result: i.result,
          durationMs: i.durationMs,
          hasResult: !0,
          ...i.isError ? { isError: !0 } : {}
        });
        break;
      }
      case "goal": {
        const a = t[t.length - 1];
        a && a.kind === "goal" ? (a.objective = i.objective ?? a.objective, a.passed = i.passed ?? a.passed, a.status = i.status ?? a.status, a.reason = i.reason ?? a.reason, a.iteration = i.iteration ?? a.iteration, a.maxRuns = i.maxRuns ?? a.maxRuns) : t.push({
          kind: "goal",
          objective: i.objective,
          passed: i.passed,
          status: i.status,
          reason: i.reason,
          iteration: i.iteration,
          maxRuns: i.maxRuns
        });
        break;
      }
      case "error":
        t.push({
          kind: "error",
          message: i.message,
          kindCode: i.kind
        });
        break;
    }
  return t;
}
function Ei(e) {
  const t = Di(e.transcript), n = [];
  let r = null, i = null, a = "head", o = 0;
  const l = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map(), u = (m) => {
    r && r.length > 0 && i && n.push({
      kind: "turn",
      key: i,
      streaming: (m == null ? void 0 : m.streaming) === !0,
      blocks: r
    }), r = null, i = null;
  }, h = (m) => {
    r === null && (r = [], o += 1, i = `turn-${a}-${o}`);
    const y = r[r.length - 1];
    m.type === "tools" && (y == null ? void 0 : y.type) === "tools" ? y.calls.push(...m.calls) : r.push(m);
  }, f = /* @__PURE__ */ new Map();
  for (const m of t)
    switch (m.kind) {
      case "user": {
        u();
        const y = `${m.source ?? "system"}\0${m.text}`, g = (f.get(y) ?? 0) + 1;
        f.set(y, g);
        const k = `user-${bt(y)}-${g}`;
        a = k, o = 0, n.push({
          kind: "user",
          key: k,
          text: m.text,
          source: m.source ?? "system",
          eventKind: m.eventKind,
          state: "delivered",
          wokeFromIdle: !1,
          interrupted: !1
        });
        break;
      }
      case "text":
        h({ type: "text", text: m.text });
        break;
      case "reasoning":
        h({ type: "reasoning", text: m.text });
        break;
      case "tool":
        h({
          type: "tools",
          calls: [
            {
              toolCallId: m.toolCallId,
              name: m.name,
              args: m.args,
              ...m.mcpName ? { mcpName: m.mcpName } : {},
              result: m.result,
              durationMs: m.durationMs,
              hasResult: m.hasResult,
              ...m.isError ? { isError: !0 } : {}
            }
          ]
        });
        break;
      case "goal":
        u();
        {
          const y = `${m.objective ?? ""}\0${m.status ?? ""}\0${m.iteration ?? ""}`, g = (l.get(y) ?? 0) + 1;
          l.set(y, g), n.push({
            kind: "goal",
            key: `goal-${bt(y)}-${g}`,
            objective: m.objective,
            passed: m.passed,
            status: m.status,
            reason: m.reason,
            iteration: m.iteration,
            maxRuns: m.maxRuns
          });
        }
        break;
      case "error":
        u();
        {
          const y = m.message, g = (c.get(y) ?? 0) + 1;
          c.set(y, g), n.push({
            kind: "error",
            key: `error-${bt(y)}-${g}`,
            message: m.message,
            kindCode: m.kindCode
          });
        }
        break;
    }
  return u({ streaming: e.status === "WORKING" }), Wi(n, e.optimistic), Fi(n, e.events ?? []), Oi(n, e.queued ?? []), Li(n, e.incidents ?? []), ji(n, e.compactions ?? []), n;
}
function ji(e, t) {
  const n = [...t].sort((r, i) => Date.parse(r.at) - Date.parse(i.at));
  for (const r of n) {
    const i = {
      kind: "compaction",
      // Version is unique per thread (the write is CAS-guarded), so it is a
      // stable React key with no occurrence counting needed.
      key: `compaction-v${r.version}`,
      version: r.version,
      msgCount: r.msgCount,
      summarizedCount: r.summarizedCount,
      forced: r.forced,
      summary: r.summary,
      at: r.at
    };
    let a = e.length;
    const o = Date.parse(r.at);
    if (!Number.isNaN(o))
      for (let l = 0; l < e.length; l += 1) {
        const c = e[l];
        if ((c == null ? void 0 : c.kind) === "user" && c.at && Date.parse(c.at) > o) {
          a = l;
          break;
        }
      }
    e.splice(a, 0, i);
  }
}
function Li(e, t) {
  for (const n of t) {
    const r = {
      kind: "incident",
      key: `incident-${n.runId}`,
      runId: n.runId,
      ...n.at ? { at: n.at } : {}
    };
    let i = e.length;
    if (n.at) {
      const a = Date.parse(n.at);
      if (!Number.isNaN(a))
        for (let o = 0; o < e.length; o += 1) {
          const l = e[o];
          if ((l == null ? void 0 : l.kind) === "user" && l.at && Date.parse(l.at) > a) {
            i = o;
            break;
          }
        }
    }
    e.splice(i, 0, r);
  }
}
function Ze(e, t) {
  return e === t || JSON.stringify(e) === JSON.stringify(t);
}
function Oi(e, t) {
  for (const n of t) {
    const r = n.trim();
    for (let i = e.length - 1; i >= 0; i -= 1) {
      const a = e[i];
      if (a && a.kind === "user" && a.state === "delivered" && a.text.trim() === r) {
        e.splice(i, 1);
        break;
      }
    }
  }
}
function Fi(e, t) {
  if (t.length === 0) return;
  const n = [...t].reverse(), r = /* @__PURE__ */ new Set();
  for (const i of e) {
    if (i.kind !== "user" || i.state !== "delivered") continue;
    let a = -1;
    for (let l = 0; l < n.length; l += 1) {
      const c = n[l];
      if (!r.has(l) && c && c.content.trim() === i.text.trim() && c.source === i.source) {
        a = l;
        break;
      }
    }
    if (a < 0) continue;
    const o = n[a];
    o && (r.add(a), i.wokeFromIdle = o.wokeFromIdle, o.interrupted && (i.interrupted = !0), i.at = o.at);
  }
}
function Wi(e, t) {
  const n = /* @__PURE__ */ new Set(), r = (i) => {
    const a = e.findIndex(
      (l, c) => !n.has(c) && l.kind === "user" && l.state === "delivered" && l.text.trim() === i.text.trim()
    );
    if (a < 0) return !1;
    n.add(a);
    const o = e[a];
    return (o == null ? void 0 : o.kind) === "user" && (o.key = `optimistic-${i.localId}`, o.delivery = i.delivery, o.eventKind = i.kind, o.interrupted = i.delivery === "interrupt" && i.wasWorking), !0;
  };
  for (const i of t) {
    if (i.failed) {
      if (r(i)) continue;
      e.push(Ki(i));
      continue;
    }
    r(i) || e.push({
      kind: "user",
      key: `optimistic-${i.localId}`,
      text: i.text,
      source: "user:me",
      eventKind: i.kind,
      delivery: i.delivery,
      state: "pending",
      wokeFromIdle: !1,
      interrupted: i.delivery === "interrupt" && i.wasWorking
    });
  }
}
function Bi(e, t, n, r, i) {
  let a = !1, o = null;
  const l = e.map((c) => {
    if (c.failed || t.has(c.text.trim())) return c;
    const u = n.get(c.localId);
    if (u == null) return c;
    const h = r - u;
    if (h >= i)
      return a = !0, { ...c, failed: !0 };
    const f = i - h;
    return o = o == null ? f : Math.min(o, f), c;
  });
  return { changed: a, next: l, nextDeadlineMs: o };
}
function Ki(e) {
  return {
    kind: "user",
    key: `optimistic-${e.localId}`,
    text: e.text,
    source: "user:me",
    eventKind: e.kind,
    delivery: e.delivery,
    state: "failed",
    wokeFromIdle: !1,
    interrupted: !1
  };
}
function bt(e) {
  let t = 2166136261;
  for (let n = 0; n < e.length; n += 1)
    t ^= e.charCodeAt(n), t = Math.imul(t, 16777619);
  return (t >>> 0).toString(36);
}
function ir(e, t) {
  try {
    const n = Ui(e);
    if (!n || typeof n != "object") return null;
    const r = n;
    return r.geometry && typeof r.geometry == "object" ? Vi(r) : Array.isArray(r.buckets) ? Zi(r) : Array.isArray(r.datapoints) ? Xi(r) : Array.isArray(r.items) ? cn(r.items, ha) : Array.isArray(r.values) ? cn(r.values, ma) : aa(r.columns) && Array.isArray(r.rows) ? ln(oa(r.columns, r.rows)) : Array.isArray(r.rows) && sa(t == null ? void 0 : t.toolName) ? ln(la(r.rows)) : null;
  } catch {
    return null;
  }
}
function Ui(e) {
  let t = e;
  for (let n = 0; n < 4; n += 1) {
    if (!t || typeof t != "object") return t;
    const r = t;
    if (r.isError === !0) return null;
    if (r.structuredContent && typeof r.structuredContent == "object") {
      t = r.structuredContent;
      continue;
    }
    if (Array.isArray(r.content)) {
      const i = r.content.map((a) => {
        if (!a || typeof a != "object") return null;
        const o = a;
        return o.type === "text" && typeof o.text == "string" ? o.text : null;
      }).find((a) => a !== null);
      if (i === void 0) return null;
      try {
        t = JSON.parse(i);
        continue;
      } catch {
        return null;
      }
    }
    if (typeof r.success == "boolean") {
      if (!r.success) return null;
      t = r.data;
      continue;
    }
    return t;
  }
  return t;
}
const Hi = 5e4, Gi = 500, qi = /* @__PURE__ */ new Set(["scan", "cloud", "path", "tf"]);
function Vi(e) {
  const t = e.geometry, n = t.kind;
  if (!qi.has(n)) return null;
  const r = [];
  if (Array.isArray(t.points))
    for (const l of t.points.slice(0, Hi)) {
      const c = on(l);
      c && r.push(c);
    }
  const i = [];
  if (Array.isArray(t.frames))
    for (const l of t.frames.slice(0, Gi)) {
      if (!l || typeof l != "object") continue;
      const c = l, u = on(c.position), h = Ji(c.rotation);
      typeof c.name != "string" || !c.name || !u || !h || i.push({
        name: c.name,
        parent: typeof c.parent == "string" && c.parent ? c.parent : null,
        position: u,
        rotation: h
      });
    }
  if (n === "tf" ? i.length === 0 : r.length < 2) return null;
  const a = typeof e.deviceName == "string" ? e.deviceName : null, o = typeof e.streamName == "string" ? e.streamName : null;
  return {
    kind: "geometry",
    title: Ft(a, o),
    geometry: { kind: n, points: r, frames: i }
  };
}
function Ce(e) {
  return typeof e == "number" && Number.isFinite(e);
}
function on(e) {
  if (!Array.isArray(e) || e.length < 3) return null;
  const [t, n, r] = e;
  return !Ce(t) || !Ce(n) || !Ce(r) ? null : [t, n, r];
}
function Ji(e) {
  if (!Array.isArray(e) || e.length !== 4) return null;
  const [t, n, r, i] = e;
  if (!Ce(t) || !Ce(n) || !Ce(r) || !Ce(i))
    return null;
  const a = Math.hypot(t, n, r, i);
  return a < 1e-9 ? null : [t / a, n / a, r / a, i / a];
}
function Xi(e) {
  var o;
  const t = typeof e.deviceName == "string" ? e.deviceName : null, n = typeof e.streamName == "string" ? e.streamName : null, r = Ft(t, n), i = e.datapoints.map((l) => {
    if (!l || typeof l != "object") return null;
    const c = l;
    return { t: $e(c.time ?? c.timestamp), value: c.value };
  }).filter((l) => l !== null && l.value !== void 0);
  if (i.length === 0) return null;
  switch (e.streamType === "json" ? "json" : sr((o = i[0]) == null ? void 0 : o.value)) {
    case "numeric": {
      const l = Yi(i, r ?? "value");
      if (!l) return null;
      const c = l.points.length === 1 ? l.points[0] : void 0;
      return c ? {
        kind: "values",
        title: null,
        tiles: [
          {
            label: n ?? "value",
            ...t ? { sublabel: t } : {},
            t: c.t,
            value: { type: "numeric", value: c.v }
          }
        ]
      } : { kind: "timeseries", title: r === l.label ? null : r, series: [l] };
    }
    case "battery": {
      const l = i.map((u) => {
        const h = u.value.percentage;
        return typeof h == "number" && u.t !== null ? { t: u.t, v: h } : null;
      }).filter((u) => u !== null);
      if (l.length === 0) return null;
      const c = r ?? "battery";
      return {
        kind: "timeseries",
        title: r === c ? null : r,
        series: [{ label: c, unit: "%", points: Le(l) }]
      };
    }
    case "numeric-set":
      return Qi(i, r);
    case "location": {
      const l = i.map((c) => {
        const u = c.value;
        return or(u.latitude, u.longitude) ? { latitude: u.latitude, longitude: u.longitude, t: c.t } : null;
      }).filter((c) => c !== null);
      return l.length === 0 ? null : { kind: "map", title: r, points: ba(l), variant: "trail" };
    }
    case "image": {
      const l = i.map((c) => {
        const u = c.value;
        return ft(u.url) ? { url: u.url, t: c.t } : null;
      }).filter((c) => c !== null);
      return l.length === 0 ? null : { kind: "images", title: r, items: l };
    }
    case "video": {
      const l = i.map((c) => {
        const u = c.value;
        return ft(u.url) ? {
          url: u.url,
          t: c.t,
          durationMs: typeof u.duration == "number" ? u.duration : null,
          mimeType: typeof u.mimeType == "string" ? u.mimeType : "video/mp4"
        } : null;
      }).filter((c) => c !== null);
      return l.length === 0 ? null : { kind: "videos", title: r, items: l };
    }
    case "json": {
      const l = i.map((c) => ({ t: c.t, value: Ot(c.value) })).filter((c) => c.value !== null);
      return l.length === 0 ? null : {
        kind: "record",
        title: r,
        field: typeof e.field == "string" && e.field ? e.field : null,
        samples: [...l].sort((c, u) => (c.t ?? 0) - (u.t ?? 0))
      };
    }
    default:
      return null;
  }
}
function Yi(e, t) {
  const n = e.map((r) => typeof r.value == "number" && r.t !== null ? { t: r.t, v: r.value } : null).filter((r) => r !== null);
  return n.length === 0 ? null : { label: t, points: Le(n) };
}
function Qi(e, t) {
  const n = /* @__PURE__ */ new Map();
  for (const i of e)
    if (!(i.t === null || !Array.isArray(i.value)))
      for (const a of i.value) {
        if (!a || typeof a != "object") continue;
        const o = a;
        if (typeof o.value != "number") continue;
        const l = typeof o.label == "string" && o.label ? o.label : "value";
        let c = n.get(l);
        c || (c = {
          label: l,
          unit: typeof o.unit == "string" ? o.unit : void 0,
          points: []
        }, n.set(l, c)), c.points.push({ t: i.t, v: o.value });
      }
  const r = [...n.values()].map((i) => ({ ...i, points: Le(i.points) }));
  return r.length === 0 ? null : { kind: "timeseries", title: t, series: r };
}
function Zi(e) {
  const t = typeof e.stream_name == "string" ? e.stream_name : null, n = [], r = [];
  for (const i of e.buckets) {
    if (!i || typeof i != "object") continue;
    const a = i, o = $e(a.bucket_start);
    o !== null && (typeof a.avg == "number" && n.push({ t: o, v: a.avg }), typeof a.min == "number" && typeof a.max == "number" && r.push({ t: o, min: a.min, max: a.max }));
  }
  return n.length === 0 ? null : {
    kind: "timeseries",
    title: t,
    series: [
      {
        label: t ?? "avg",
        points: Le(n),
        band: r.length > 0 ? r : void 0
      }
    ]
  };
}
const ea = 2e3, ta = 200, na = /^\d{4}-\d{2}-\d{2}$/, ra = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(:\d{2}(\.\d+)?)?(Z|[+-]\d{2}:?\d{2})?$/, ia = /^-?\d+(\.\d+)?$/;
function aa(e) {
  return Array.isArray(e) && e.every((t) => typeof t == "string");
}
function sa(e) {
  return typeof e == "string" && /analytics|query/i.test(e);
}
function oa(e, t) {
  const n = [];
  for (const r of t) {
    if (!Array.isArray(r)) continue;
    const i = {};
    e.forEach((a, o) => {
      i[a] = r[o];
    }), n.push(i);
  }
  return { columns: e, rows: n };
}
function la(e) {
  const t = [];
  for (const r of e) {
    if (!r || typeof r != "object" || Array.isArray(r)) return null;
    t.push(r);
  }
  const n = t[0];
  return n ? { columns: Object.keys(n), rows: t } : null;
}
function ca(e) {
  return typeof e != "string" || !na.test(e) && !ra.test(e) ? !1 : $e(e) !== null;
}
function pt(e) {
  return typeof e == "number" ? Number.isFinite(e) ? e : null : typeof e == "string" && ia.test(e) ? Number(e) : null;
}
function ln(e) {
  if (!e) return null;
  const { columns: t, rows: n } = e;
  if (n.length === 0 || n.length > ea) return null;
  const r = n.slice(0, ta), i = [];
  for (const h of t) {
    const f = r.map((k) => k[h]).filter((k) => k != null);
    if (f.length < r.length * 0.5) continue;
    const m = f.length * 0.95, y = f.filter(ca).length, g = f.filter((k) => pt(k) !== null).length;
    y >= m ? i.push({ name: h, kind: "time", distinct: 0, nonNull: f.length }) : g >= m ? i.push({ name: h, kind: "numeric", distinct: 0, nonNull: f.length }) : f.every((k) => typeof k == "string") ? i.push({
      name: h,
      kind: "categorical",
      distinct: new Set(f).size,
      nonNull: f.length
    }) : i.push({ name: h, kind: "other", distinct: 0, nonNull: f.length });
  }
  if (i.some((h) => h.kind === "other")) return null;
  const a = i.filter((h) => h.kind === "time"), o = i.filter((h) => h.kind === "numeric"), l = i.filter((h) => h.kind === "categorical"), c = a[0], u = l[0];
  if (a.length === 1 && c) {
    if (o.length === 1 && l.length === 1 && u && u.distinct >= 2 && u.distinct <= 8) {
      const h = o[0];
      return h ? ua(n, c.name, h.name, u.name) : null;
    }
    return o.length >= 1 && o.length <= 8 && n.length >= 2 && l.every((h) => h.distinct <= 1) ? da(n, c.name, o) : null;
  }
  return a.length === 0 && l.length === 1 && u && u.distinct >= u.nonNull * 0.9 && o.length >= 1 && o.length <= 4 && n.length <= 30 ? fa(n, u.name, o) : null;
}
function ua(e, t, n, r) {
  const i = /* @__PURE__ */ new Map();
  for (const o of e) {
    const l = $e(o[t]), c = pt(o[n]), u = o[r];
    if (l === null || c === null || typeof u != "string") continue;
    let h = i.get(u);
    h || (h = [], i.set(u, h)), h.push({ t: l, v: c });
  }
  const a = [...i.entries()].map(([o, l]) => ({
    label: o,
    points: Le(l)
  }));
  return ar(a) ? { kind: "timeseries", title: null, series: a } : null;
}
function da(e, t, n) {
  const r = [];
  for (const i of n) {
    const a = [];
    for (const o of e) {
      const l = $e(o[t]), c = pt(o[i.name]);
      l !== null && c !== null && a.push({ t: l, v: c });
    }
    a.length > 0 && r.push({ label: i.name, points: Le(a) });
  }
  return ar(r) ? { kind: "timeseries", title: null, series: r } : null;
}
function ar(e) {
  return e.reduce((t, n) => t + n.points.length, 0) >= 2;
}
function fa(e, t, n) {
  const r = [];
  for (const a of e) {
    const o = a[t];
    typeof o == "string" && r.push({ category: o, row: a });
  }
  if (r.length === 0) return null;
  const i = n.map((a) => ({
    label: a.name,
    values: r.map(({ row: o }) => pt(o[a.name]))
  }));
  return i.some((a) => a.values.some((o) => o !== null)) ? {
    kind: "bars",
    title: null,
    categories: r.map(({ category: a }) => a),
    series: i
  } : null;
}
function ha(e) {
  if (!e || typeof e != "object") return null;
  const t = e;
  return "currentValue" in t ? {
    deviceName: typeof t.deviceName == "string" ? t.deviceName : null,
    streamName: typeof t.streamName == "string" ? t.streamName : null,
    streamType: typeof t.streamType == "string" ? t.streamType : null,
    t: $e(t.currentValueTime),
    value: t.currentValue
  } : null;
}
function ma(e) {
  if (!e || typeof e != "object") return null;
  const t = e;
  return !("value" in t) || !("streamName" in t) ? null : {
    deviceName: typeof t.deviceName == "string" ? t.deviceName : null,
    streamName: typeof t.streamName == "string" ? t.streamName : null,
    streamType: null,
    t: $e(t.timestamp),
    value: t.value
  };
}
function cn(e, t) {
  var h;
  const n = e.map(t).filter((f) => f !== null);
  if (n.length === 0) return null;
  const i = n.map((f) => ({
    ...f,
    tile: pa(f.value, f.streamType)
  })).filter(
    (f) => f.tile !== null
  );
  if (i.length === 0) return null;
  const [a] = i;
  if (i.length === 1 && (a == null ? void 0 : a.tile.type) === "json")
    return {
      kind: "record",
      title: Ft(a.deviceName, a.streamName),
      field: null,
      samples: [{ t: a.t, value: a.tile.value }]
    };
  if (i.every((f) => f.tile.type === "location"))
    return { kind: "map", title: null, points: i.map((m) => {
      const y = m.tile;
      return {
        latitude: y.latitude,
        longitude: y.longitude,
        t: m.t,
        label: m.deviceName ?? m.streamName ?? void 0
      };
    }), variant: "markers" };
  const o = new Set(i.map((f) => f.deviceName)).size > 1, l = i.map((f) => ({
    label: f.streamName ?? "value",
    sublabel: o ? f.deviceName ?? void 0 : void 0,
    t: f.t,
    value: f.tile
  }));
  return { kind: "values", title: new Set(i.map((f) => f.deviceName)).size === 1 ? ((h = i[0]) == null ? void 0 : h.deviceName) ?? null : null, tiles: l };
}
function sr(e) {
  if (typeof e == "number") return "numeric";
  if (typeof e == "string") return Ot(e) ? "json" : "text";
  if (Array.isArray(e)) {
    const n = e[0];
    return n && typeof n == "object" && typeof n.value == "number" ? "numeric-set" : "unknown";
  }
  if (!e || typeof e != "object") return "unknown";
  const t = e;
  return typeof t.latitude == "number" && typeof t.longitude == "number" ? "location" : Array.isArray(t.keys) && Array.isArray(t.values) ? "bitset" : typeof t.percentage == "number" ? "battery" : typeof t.status == "string" && Object.keys(t).length <= 2 ? "health" : typeof t.url == "string" ? typeof t.duration == "number" || typeof t.mimeType == "string" ? "video" : typeof t.filename == "string" || "worldToLocal" in t ? "unknown" : "image" : "unknown";
}
function pa(e, t) {
  switch (ga(t) ?? sr(e)) {
    case "numeric":
      return typeof e == "number" ? { type: "numeric", value: e } : null;
    case "text":
      return typeof e == "string" ? { type: "text", value: e } : null;
    case "battery": {
      const r = e;
      return typeof (r == null ? void 0 : r.percentage) == "number" ? {
        type: "battery",
        percentage: r.percentage,
        voltage: typeof r.voltage == "number" ? r.voltage : void 0
      } : null;
    }
    case "health": {
      const r = e;
      return typeof (r == null ? void 0 : r.status) == "string" ? { type: "health", status: r.status } : null;
    }
    case "bitset": {
      const r = e, i = Array.isArray(r == null ? void 0 : r.keys) ? r.keys : null, a = Array.isArray(r == null ? void 0 : r.values) ? r.values : null;
      if (!i || !a) return null;
      const o = i.map(
        (l, c) => typeof l == "string" && typeof a[c] == "boolean" ? { key: l, value: a[c] === !0 } : null
      ).filter((l) => l !== null);
      return o.length > 0 ? { type: "bitset", entries: o } : null;
    }
    case "numeric-set": {
      if (!Array.isArray(e)) return null;
      const r = [];
      for (const i of e) {
        if (!i || typeof i != "object") continue;
        const a = i;
        typeof a.value == "number" && r.push({
          label: typeof a.label == "string" ? a.label : "value",
          value: a.value,
          unit: typeof a.unit == "string" ? a.unit : void 0
        });
      }
      return r.length > 0 ? { type: "numeric-set", entries: r } : null;
    }
    case "location": {
      const r = e;
      return or(r == null ? void 0 : r.latitude, r == null ? void 0 : r.longitude) ? { type: "location", latitude: r.latitude, longitude: r.longitude } : null;
    }
    case "image": {
      const r = e;
      return ft(r == null ? void 0 : r.url) ? { type: "image", url: r.url } : null;
    }
    case "video": {
      const r = e;
      return ft(r == null ? void 0 : r.url) ? {
        type: "video",
        url: r.url,
        durationMs: typeof r.duration == "number" ? r.duration : null,
        mimeType: typeof r.mimeType == "string" ? r.mimeType : "video/mp4"
      } : null;
    }
    case "json": {
      const r = Ot(e);
      return r ? { type: "json", value: r } : null;
    }
    default:
      return null;
  }
}
function ga(e) {
  switch (e) {
    case "numeric":
      return "numeric";
    case "numeric set":
      return "numeric-set";
    case "location":
      return "location";
    case "image":
      return "image";
    case "video":
      return "video";
    case "bitset":
      return "bitset";
    case "battery":
      return "battery";
    case "health":
      return "health";
    case "text":
      return "text";
    case "json":
      return "json";
    default:
      return e === null ? null : "unknown";
  }
}
function Ot(e) {
  if (e !== null && typeof e == "object") return e;
  if (typeof e != "string") return null;
  const t = e.trim();
  if (!t.startsWith("{") && !t.startsWith("[")) return null;
  try {
    const n = JSON.parse(t);
    return n !== null && typeof n == "object" ? n : null;
  } catch {
    return null;
  }
}
function ft(e) {
  return typeof e == "string" && (e.startsWith("https://") || e.startsWith("http://"));
}
function or(e, t) {
  return typeof e == "number" && typeof t == "number" && Number.isFinite(e) && Number.isFinite(t) && Math.abs(e) <= 90 && Math.abs(t) <= 180;
}
const ya = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/;
function $e(e) {
  if (typeof e == "number" && Number.isFinite(e)) return e;
  if (typeof e != "string" || !e) return null;
  const t = ya.test(e) ? `${e.replace(" ", "T")}Z` : e, n = Date.parse(t);
  return Number.isNaN(n) ? null : n;
}
function Le(e) {
  return [...e].sort((t, n) => t.t - n.t);
}
function ba(e) {
  return [...e].sort((t, n) => (t.t ?? 0) - (n.t ?? 0));
}
function Ft(e, t) {
  return e && t ? `${e} · ${t}` : e ?? t;
}
const lr = "Rejected — do not proceed.";
function va({
  options: e,
  capabilities: t
}) {
  if (e.length > 0)
    return t.accept ? e.map((r, i) => ({
      key: r.id,
      label: r.label,
      description: r.description,
      primary: i === 0,
      body: { action: "accept", optionId: r.id }
    })) : [];
  const n = [];
  return t.accept && n.push({ key: "approve", label: "Approve", primary: !0, body: { action: "accept" } }), t.respond && n.push({
    key: "reject",
    label: "Reject",
    primary: !1,
    body: { action: "respond", text: lr }
  }), n;
}
const cr = je(null), wa = cr.Provider;
function ka() {
  return Ee(cr);
}
function Be(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e) ? e : null;
}
function _a(e) {
  const t = Be(e);
  if (!t) return {};
  const n = Be(t.input) ?? Be(t.context);
  return n && (typeof n.question == "string" || Array.isArray(n.options)) ? n : t;
}
function Na(e) {
  let t = e;
  for (let n = 0; n < 6; n += 1) {
    if (typeof t == "string") {
      const i = t.trim();
      if (!i) return null;
      try {
        t = JSON.parse(i);
        continue;
      } catch {
        return null;
      }
    }
    const r = Be(t);
    if (!r) return null;
    if (typeof r.elicitationId == "string" && r.elicitationId.length > 0)
      return r.elicitationId;
    if ((r.type === "json" || r.type === "text") && r.value !== void 0) {
      t = r.value;
      continue;
    }
    if (r.output !== void 0 && r.output !== r) {
      t = r.output;
      continue;
    }
    if (r.result !== void 0 && r.result !== r && r.elicitationId === void 0) {
      t = r.result;
      continue;
    }
    return null;
  }
  return null;
}
function xa(e) {
  return Array.isArray(e) ? e.filter((t) => t && typeof t.id == "string" && typeof t.label == "string").map((t) => ({
    id: t.id,
    label: t.label,
    description: typeof t.description == "string" ? t.description : void 0
  })) : [];
}
function Sa(e) {
  if (e.name !== "request_human_input" || e.isError) return null;
  const t = _a(e.args), n = typeof t.question == "string" ? t.question : "", r = Na(e.result) ?? "";
  return !r && !n ? null : { elicitationId: r, question: n, options: xa(t.options) };
}
const Ca = { accept: !0, respond: !0 };
function Ma(e) {
  var n;
  if (Array.isArray(e)) return e;
  const t = (n = Be(e)) == null ? void 0 : n.items;
  return Array.isArray(t) ? t : [];
}
const $a = 8, ur = (e) => e.type === "text" ? e.value ?? "" : (e.children ?? []).map(ur).join("");
function Ta({ node: e, children: t, ...n }) {
  var h, f, m;
  const [r, i] = z(!1), a = (h = e == null ? void 0 : e.children) == null ? void 0 : h.find((y) => y.tagName === "code"), o = a ? ur(a).replace(/\n$/, "") : "", l = o ? o.split(`
`).length : 0;
  if (l <= $a) return /* @__PURE__ */ s("pre", { ...n, children: t });
  const c = (f = a == null ? void 0 : a.properties) == null ? void 0 : f.className, u = (m = (Array.isArray(c) ? c : []).map(String).find((y) => y.startsWith("language-"))) == null ? void 0 : m.slice(9);
  return /* @__PURE__ */ d("div", { className: "pa-elicitation-card__script", "data-open": r, children: [
    /* @__PURE__ */ d("div", { className: "pa-elicitation-card__script-head", children: [
      /* @__PURE__ */ d("span", { className: "pa-elicitation-card__script-summary", children: [
        u ?? "script",
        " · ",
        l,
        " lines"
      ] }),
      /* @__PURE__ */ s(
        "button",
        {
          type: "button",
          className: "pa-elicitation-card__script-toggle",
          "aria-expanded": r,
          onClick: () => i((y) => !y),
          children: r ? "Hide script" : "Show script"
        }
      )
    ] }),
    r ? /* @__PURE__ */ s("pre", { ...n, children: t }) : null
  ] });
}
const Ia = { pre: Ta }, Ra = /<<-?[ \t]*(['"]?)(\w+)\1[ \t]*\n([\s\S]*?)\n\2(?=\s|$)/g, Aa = (e) => e.includes("```") ? e : e.replace(
  Ra,
  (t, n, r, i) => `<<${n}${r}${n}

\`\`\`${/^py/i.test(r) ? "python" : ""}
${i}
\`\`\`

${r}`
);
function za({ elicitationId: e, question: t, options: n }) {
  var T;
  const r = mt(), i = ka(), [a, o] = z("PENDING"), [l, c] = z(null), [u, h] = z(null), [f, m] = z(null), [y, g] = z([]), [k, x] = z(Ca), b = i ? `v1/persistent-agent-groups/${i.groupId}/agents/${i.threadId}/elicitations` : null, [M, $] = z(e);
  K(() => {
    e && $(e);
  }, [e]);
  const N = V(async () => {
    if (b)
      try {
        const R = Ma(await r.http.get(b).json()), v = (M ? R.find((w) => w.id === M) : void 0) ?? R.find((w) => w.status === "PENDING" && w.question === t) ?? R.find((w) => w.status === "PENDING");
        v && ($(v.id), o(v.status), c(v.decision ?? null), v.options && g(v.options), v.capabilities && x(v.capabilities));
      } catch {
      }
  }, [r, b, M, t]);
  K(() => {
    N().catch(() => {
    });
  }, [N]);
  const E = n.length > 0 ? n : y, j = va({ options: E, capabilities: k }), S = async (R) => {
    if (!(!b || u || !M)) {
      h(R.key), m(null);
      try {
        await r.http.post(`${b}/${M}/answer`, { json: R.body }), o("ANSWERED"), c(R.body);
      } catch (v) {
        m(v instanceof Error ? v.message : "Could not record the decision");
      } finally {
        h(null);
      }
    }
  }, _ = (l == null ? void 0 : l.text) === lr || !!(l != null && l.optionId) && /reject|keep|no|discard/i.test(l.optionId), I = a === "ANSWERED" ? ((T = E.find((R) => R.id === (l == null ? void 0 : l.optionId))) == null ? void 0 : T.label) ?? (_ ? "Rejected" : null) ?? ((l == null ? void 0 : l.action) === "accept" ? "Approved" : null) ?? (l == null ? void 0 : l.text) ?? "Answered" : null;
  return /* @__PURE__ */ d(
    "div",
    {
      className: "pa-elicitation-card",
      "data-status": a === "ANSWERED" ? _ ? "REJECTED" : "APPROVED" : a,
      role: "group",
      "aria-label": "Decision requested",
      children: [
        /* @__PURE__ */ s("div", { className: "pa-elicitation-card__head", children: /* @__PURE__ */ s("span", { className: "pa-elicitation-card__badge", children: a === "PENDING" ? "Awaiting your decision" : a === "ANSWERED" ? `Decided · ${I}` : a.toLowerCase() }) }),
        /* @__PURE__ */ s("div", { className: "pa-elicitation-card__body", children: /* @__PURE__ */ s(Pn, { remarkPlugins: [Dn], components: Ia, children: Aa(t) }) }),
        a === "PENDING" && j.length > 0 ? /* @__PURE__ */ s("div", { className: "pa-elicitation-card__actions", children: j.map((R) => /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            className: R.primary ? "btn btn--primary btn--sm" : "btn btn--ghost btn--sm",
            disabled: !b || !M || u !== null,
            title: R.description,
            onClick: () => {
              S(R).catch(() => {
              });
            },
            children: u === R.key ? "Recording…" : R.label
          },
          R.key
        )) }) : null,
        f ? /* @__PURE__ */ s("div", { className: "pa-elicitation-card__error", children: f }) : null
      ]
    }
  );
}
const dr = je(null), Pa = dr.Provider;
function Da() {
  return Ee(dr);
}
function fr({ refs: e }) {
  const t = Da(), n = e.join(`
`), r = Q(() => n ? n.split(`
`) : [], [n]), [i, a] = z(null);
  return K(() => {
    if (a(null), !t || r.length === 0) return;
    let o = !1;
    const l = [];
    return Promise.all(r.map((c) => t.fetchImage(c).catch(() => null))).then((c) => {
      const u = [];
      for (const h of c)
        h && u.push(URL.createObjectURL(h));
      if (o) {
        for (const h of u) URL.revokeObjectURL(h);
        return;
      }
      l.push(...u), a(u);
    }).catch(() => {
    }), () => {
      o = !0;
      for (const c of l) URL.revokeObjectURL(c);
    };
  }, [t, r]), !t || r.length === 0 ? null : i === null ? /* @__PURE__ */ s("div", { className: "pa-chat-tool-images", "aria-hidden": "true", children: r.map((o) => /* @__PURE__ */ s("span", { className: "pa-chat-tool-image-placeholder" }, o)) }) : i.length === 0 ? null : /* @__PURE__ */ s(Lt, { images: i });
}
const Ea = 8, un = 864e5;
function at(e) {
  return `var(--chart-${e % Ea + 1})`;
}
function hr(e, t) {
  const n = Math.abs(e), r = n >= 100 ? 0 : n >= 1 ? 1 : 3;
  return `${e.toFixed(r)}${t ? ` ${t}` : ""}`;
}
function mr(e, t) {
  const n = Math.abs(e);
  if (n >= 1e4) return `${(e / 1e3).toFixed(0)}k`;
  if (n >= 1e3) return `${(e / 1e3).toFixed(1)}k`;
  if (Number.isInteger(e)) return String(e);
  const r = t ? Math.max(0, Math.ceil(-Math.log10(t) - 1e-9)) : n >= 1 ? 1 : 2;
  return String(parseFloat(e.toFixed(r)));
}
function pr(e, t, n, r) {
  const i = new Date(e);
  return n !== void 0 && n >= un && e % un === 0 ? i.toLocaleString(void 0, { timeZone: "UTC", month: "short", day: "numeric" }) : t > 24 * 36e5 ? i.toLocaleString(void 0, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZone: r
  }) : i.toLocaleTimeString(void 0, { hour: "numeric", minute: "2-digit", timeZone: r });
}
function Mt(e, t, n = 3) {
  if (t === e) return { ticks: [e, e + 1], top: e + 1 };
  const i = (t - e) / n, a = 10 ** Math.floor(Math.log10(i)), o = i / a, l = (o < 1.5 ? 1 : o < 3.5 ? 2 : o < 7.5 ? 5 : 10) * a, c = Math.ceil(e / l) * l, u = Math.ceil(t / l) * l, h = [];
  for (let f = c; f <= u + l / 2; f += l)
    h.push(parseFloat(f.toPrecision(12)));
  return { ticks: h, top: u };
}
const We = 132, ja = 18, dn = We + ja, La = 560, Ie = 6, Oa = 12;
function Fa({ model: e }) {
  var I;
  const t = P(null), [n, r] = z(La), [i, a] = z(null);
  K(() => {
    const p = t.current;
    if (!p) return;
    const T = new ResizeObserver((R) => {
      var w;
      const v = (w = R[0]) == null ? void 0 : w.contentRect.width;
      v && v > 0 && r(Math.round(v));
    });
    return T.observe(p), () => T.disconnect();
  }, []);
  const { categories: o } = e, l = e.series.filter((p) => p.values.some((T) => T !== null));
  if (o.length === 0 || l.length === 0) return null;
  const c = l.flatMap((p) => p.values).filter((p) => p !== null), u = Math.min(...c, 0), { ticks: h, top: f } = Mt(u, Math.max(...c, 0)), m = (h[1] ?? 0) - (h[0] ?? 0) || void 0, y = (p) => {
    const T = (p - u) / (f - u || 1);
    return We - T * (We - Oa);
  }, g = y(0), k = (n - 2 * Ie) / o.length, x = k * 0.7, b = x / l.length, M = Math.max(4, Math.floor(k / 6.5)), N = new Set(l.map((p) => p.unit ?? "")).size === 1 ? ((I = l[0]) == null ? void 0 : I.unit) ?? "" : "", E = i === null ? null : o[i] ?? null, j = 200, S = i === null ? null : Ie + i * k + k / 2, _ = S === null ? null : S + 12 + j > n ? Math.max(0, S - 12 - j) : S + 12;
  return /* @__PURE__ */ d("div", { className: "fleet-viz__chart", children: [
    /* @__PURE__ */ s("div", { className: "fleet-viz__legend", children: l.map((p, T) => /* @__PURE__ */ d("span", { className: "fleet-viz__legend-item", children: [
      /* @__PURE__ */ s("span", { className: "fleet-viz__legend-swatch", style: { background: at(T) } }),
      p.label,
      p.unit ? ` (${p.unit})` : ""
    ] }, p.label)) }),
    /* @__PURE__ */ d("div", { ref: t, style: { position: "relative" }, children: [
      /* @__PURE__ */ d(
        "svg",
        {
          width: n,
          height: dn,
          viewBox: `0 0 ${n} ${dn}`,
          style: { display: "block" },
          role: "img",
          "aria-label": `Bar chart: ${l.map((p) => p.label).join(", ")} by ${o.length} categories`,
          onMouseLeave: () => a(null),
          onMouseMove: (p) => {
            const T = p.currentTarget.getBoundingClientRect(), R = p.clientX - T.left, v = Math.floor((R - Ie) / k);
            a(Math.min(Math.max(v, 0), o.length - 1));
          },
          children: [
            h.map((p, T) => {
              const R = y(p), v = T === 0 && p === 0;
              return /* @__PURE__ */ d("g", { children: [
                /* @__PURE__ */ s(
                  "line",
                  {
                    x1: 0,
                    x2: n,
                    y1: R,
                    y2: R,
                    stroke: "var(--border-subtle)",
                    strokeWidth: 1,
                    strokeOpacity: v ? 0.9 : 0.35,
                    vectorEffect: "non-scaling-stroke"
                  }
                ),
                v ? null : /* @__PURE__ */ d("text", { x: 4, y: R - 3, className: "fleet-viz__axis-label", children: [
                  mr(p, m),
                  T === h.length - 1 && N ? ` ${N}` : ""
                ] })
              ] }, `y-${p}`);
            }),
            i !== null ? /* @__PURE__ */ s(
              "rect",
              {
                x: Ie + i * k,
                y: 0,
                width: k,
                height: We,
                fill: "var(--text-secondary)",
                opacity: 0.08
              }
            ) : null,
            o.map((p, T) => {
              const R = Ie + T * k + (k - x) / 2;
              return /* @__PURE__ */ d("g", { children: [
                l.map((v, w) => {
                  const O = v.values[T];
                  if (O == null) return null;
                  const B = y(O);
                  return /* @__PURE__ */ s(
                    "rect",
                    {
                      x: R + w * b,
                      y: Math.min(B, g),
                      width: Math.max(b - 1, 1),
                      height: Math.abs(B - g),
                      fill: at(w)
                    },
                    v.label
                  );
                }),
                /* @__PURE__ */ d(
                  "text",
                  {
                    x: Ie + T * k + k / 2,
                    y: We + 13,
                    textAnchor: "middle",
                    className: "fleet-viz__axis-label",
                    children: [
                      /* @__PURE__ */ s("title", { children: p }),
                      p.length > M ? `${p.slice(0, M - 1)}…` : p
                    ]
                  }
                )
              ] }, `bars-${p}-${T}`);
            })
          ]
        }
      ),
      i !== null && E !== null && _ !== null ? /* @__PURE__ */ d(
        "div",
        {
          className: "fleet-viz__hover-pane",
          role: "tooltip",
          style: { left: _, width: j },
          children: [
            /* @__PURE__ */ s("div", { className: "fleet-viz__hover-time", children: E }),
            l.map((p, T) => {
              const R = p.values[i];
              return /* @__PURE__ */ d("div", { className: "fleet-viz__hover-row", children: [
                /* @__PURE__ */ d("span", { className: "fleet-viz__hover-label", children: [
                  /* @__PURE__ */ s(
                    "span",
                    {
                      className: "fleet-viz__legend-swatch",
                      style: { background: at(T) }
                    }
                  ),
                  p.label
                ] }),
                /* @__PURE__ */ s("span", { className: "fleet-viz__hover-value", children: R != null ? hr(R, p.unit) : "—" })
              ] }, p.label);
            })
          ]
        }
      ) : null
    ] })
  ] });
}
const fn = { yaw: 0, pitch: Math.PI / 2 }, hn = { yaw: -Math.PI / 5, pitch: Math.PI / 5 }, Wa = 5 * Math.PI / 180, Ba = Math.PI / 2;
function gr([e, t, n], r) {
  const i = Math.cos(r.yaw), a = Math.sin(r.yaw), o = e * i - t * a, l = e * a + t * i, c = Math.sin(r.pitch), u = Math.cos(r.pitch);
  return { sx: -l, sy: o * c + n * u, depth: -o * u + n * c };
}
function Ka([e, t, n, r], [i, a, o]) {
  const l = 2 * (t * o - n * a), c = 2 * (n * i - e * o), u = 2 * (e * a - t * i);
  return [
    i + r * l + (t * u - n * c),
    a + r * c + (n * l - e * u),
    o + r * u + (e * c - t * l)
  ];
}
function Ua(e, t, n, r, i = 24) {
  if (e.length === 0) return { scale: 100, cx: 0, cy: 0 };
  let a = 1 / 0, o = -1 / 0, l = 1 / 0, c = -1 / 0;
  for (const m of e) {
    const { sx: y, sy: g } = gr(m, t);
    y < a && (a = y), y > o && (o = y), g < l && (l = g), g > c && (c = g);
  }
  const u = Math.max(o - a, 0.2), h = Math.max(c - l, 0.2);
  return { scale: Math.min((n - 2 * i) / u, (r - 2 * i) / h), cx: (a + o) / 2, cy: (l + c) / 2 };
}
function Ha(e, t, n, r) {
  return [n / 2 + (e.sx - t.cx) * t.scale, r / 2 - (e.sy - t.cy) * t.scale];
}
function Wt(e) {
  if (e.length === 0) return { x: 0, y: 0, z: 0 };
  let [t, n, r] = [1 / 0, 1 / 0, 1 / 0], [i, a, o] = [-1 / 0, -1 / 0, -1 / 0];
  for (const [l, c, u] of e)
    t = Math.min(t, l), n = Math.min(n, c), r = Math.min(r, u), i = Math.max(i, l), a = Math.max(a, c), o = Math.max(o, u);
  return { x: i - t, y: a - n, z: o - r };
}
function mn(e) {
  const t = Math.min(1, Math.max(0, e)), n = 55 + t * 175, r = 58 - t * 8;
  return `hsl(${n.toFixed(0)} 80% ${r.toFixed(0)}%)`;
}
function Ga(e) {
  return [0.1, 0.25, 0.5, 1, 2, 5, 10, 25, 50, 100].find((n) => e / n <= 10) ?? 100;
}
function yr(e, t = 0.6) {
  if (e.length <= 2) return e;
  const n = /* @__PURE__ */ new Map();
  for (const f of e) n.set(f.parent, [...n.get(f.parent) ?? [], f]);
  const r = /* @__PURE__ */ new Map(), i = (f, m) => {
    if (m.has(f.name)) return 0;
    m.add(f.name);
    const y = 1 + (n.get(f.name) ?? []).reduce((g, k) => g + i(k, m), 0);
    return r.set(f.name, y), y;
  }, a = n.get(null) ?? [];
  for (const f of a) i(f, /* @__PURE__ */ new Set());
  const o = (f, m) => (r.get(m.name) ?? 0) - (r.get(f.name) ?? 0), l = [...a].sort(o)[0];
  if (!l) return e;
  let c = l;
  for (; ; ) {
    const f = [...n.get(c.name) ?? []].sort(o)[0];
    if (!f || (r.get(f.name) ?? 0) < t * e.length) break;
    c = f;
  }
  const u = [], h = (f, m) => {
    if (!m.has(f.name)) {
      m.add(f.name), u.push(f);
      for (const y of n.get(f.name) ?? []) h(y, m);
    }
  };
  return h(c, /* @__PURE__ */ new Set()), u.length >= 2 ? u : e;
}
const Ke = 320, qa = 560, vt = ["#e5484d", "#30a46c", "#3e63dd"];
function Va({ geometry: e }) {
  const t = P(null), n = P(null), [r, i] = z(qa), a = e.kind === "scan" || e.kind === "path" ? fn : hn, [o, l] = z(a), [c, u] = z(1), [h, f] = z(e.frames.length > 0 && e.frames.length <= 24), m = P(null);
  K(() => {
    const b = t.current;
    if (!b) return;
    const M = new ResizeObserver(($) => {
      var E;
      const N = (E = $[0]) == null ? void 0 : E.contentRect.width;
      N && N > 0 && i(Math.round(N));
    });
    return M.observe(b), () => M.disconnect();
  }, []);
  const y = Q(() => Ja(e), [e]);
  K(() => {
    const b = n.current;
    if (!b) return;
    const M = window.devicePixelRatio || 1;
    b.width = Math.round(r * M), b.height = Math.round(Ke * M);
    const $ = b.getContext("2d");
    $ && ($.setTransform(M, 0, 0, M, 0, 0), Ya($, y, e, o, c, h, r, Xa(t.current)));
  }, [y, e, o, c, h, r]);
  const g = (b) => {
    b.currentTarget.setPointerCapture(b.pointerId), m.current = { x: b.clientX, y: b.clientY, view: o };
  }, k = (b) => {
    const M = m.current;
    if (!M) return;
    const $ = M.view.yaw - (b.clientX - M.x) * 0.01, N = Math.min(Ba, Math.max(Wa, M.view.pitch + (b.clientY - M.y) * 0.01));
    l({ yaw: $, pitch: N });
  }, x = () => {
    m.current = null;
  };
  return /* @__PURE__ */ d("div", { className: "fleet-viz__geometry", ref: t, children: [
    /* @__PURE__ */ s(
      "canvas",
      {
        ref: n,
        className: "fleet-viz__geometry-canvas",
        style: { width: r, height: Ke },
        role: "img",
        "aria-label": pn(e),
        onPointerDown: g,
        onPointerMove: k,
        onPointerUp: x,
        onPointerCancel: x,
        onDoubleClick: () => {
          l(a), u(1);
        }
      }
    ),
    /* @__PURE__ */ d("div", { className: "fleet-viz__geometry-bar", children: [
      /* @__PURE__ */ s("span", { className: "fleet-viz__geometry-caption", children: pn(e) }),
      /* @__PURE__ */ d("span", { className: "fleet-viz__geometry-controls", children: [
        /* @__PURE__ */ s("button", { type: "button", onClick: () => l(fn), children: "Top" }),
        /* @__PURE__ */ s("button", { type: "button", onClick: () => l(hn), children: "3D" }),
        /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            "aria-label": "Zoom out",
            onClick: () => u((b) => Math.max(0.25, b / 1.5)),
            children: "−"
          }
        ),
        /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            "aria-label": "Zoom in",
            onClick: () => u((b) => Math.min(20, b * 1.5)),
            children: "+"
          }
        ),
        e.kind === "tf" ? /* @__PURE__ */ s("button", { type: "button", "aria-pressed": h, onClick: () => f((b) => !b), children: "Labels" }) : null
      ] })
    ] })
  ] });
}
function Ja(e) {
  if (e.kind === "tf") {
    const n = yr(e.frames), r = Wt(n.map((o) => o.position)), i = Math.min(0.5, Math.max(0.02, Math.max(r.x, r.y, r.z) * 0.15)), a = [];
    for (const o of n) {
      a.push(o.position);
      for (const l of br(o, i)) a.push(l);
    }
    return { bounds: a, shade: [], axis: i };
  }
  let t;
  if (e.kind === "scan") {
    const n = e.points.map(([i, a]) => Math.hypot(i, a)), r = Math.max(...n, 1e-6);
    t = n.map((i) => i / r);
  } else if (e.kind === "cloud") {
    const n = e.points.map((a) => a[2]), r = Math.min(...n), i = Math.max(...n) - r || 1;
    t = n.map((a) => (a - r) / i);
  } else
    t = e.points.map((n, r) => r / Math.max(1, e.points.length - 1));
  return { bounds: [...e.points, [0, 0, 0]], shade: t, axis: 0 };
}
function br(e, t) {
  return [
    [t, 0, 0],
    [0, t, 0],
    [0, 0, t]
  ].map((n) => {
    const r = Ka(e.rotation, n);
    return [e.position[0] + r[0], e.position[1] + r[1], e.position[2] + r[2]];
  });
}
function Xa(e) {
  const t = e ? getComputedStyle(e) : null, n = (r, i) => (t == null ? void 0 : t.getPropertyValue(r).trim()) || i;
  return {
    grid: n("--border-subtle", "rgba(128,128,128,0.25)"),
    text: n("--text-secondary", "#8a8f98"),
    muted: n("--text-muted", "#6b7079"),
    link: n("--text-muted", "#6b7079")
  };
}
function Ya(e, t, n, r, i, a, o, l) {
  e.clearRect(0, 0, o, Ke);
  const c = Ua(t.bounds, r, o, Ke), u = { ...c, scale: c.scale * i }, h = (m) => Ha(gr(m, r), u, o, Ke);
  if (Qa(e, t.bounds, h, l), n.kind === "tf") {
    ts(e, n.frames, t.axis, h, a, l);
    return;
  }
  const f = n.points.length > 4e3 ? 1.2 : n.points.length > 800 ? 1.8 : 2.6;
  n.kind === "path" ? (e.lineWidth = 2, n.points.forEach((m, y) => {
    const g = n.points[y - 1];
    if (!g) return;
    const [k, x] = h(g), [b, M] = h(m);
    e.strokeStyle = mn(t.shade[y] ?? 0), e.beginPath(), e.moveTo(k, x), e.lineTo(b, M), e.stroke();
  }), es(e, n.points, h, l)) : n.points.forEach((m, y) => {
    const [g, k] = h(m);
    e.fillStyle = mn(t.shade[y] ?? 0), e.fillRect(g - f / 2, k - f / 2, f, f);
  }), Za(e, n.kind, h, l);
}
function Qa(e, t, n, r) {
  const i = Wt(t), a = Math.max(i.x, i.y, 0.2), o = Ga(a);
  let l = 1 / 0, c = -1 / 0, u = 1 / 0, h = -1 / 0;
  for (const [b, M] of t)
    l = Math.min(l, b), c = Math.max(c, b), u = Math.min(u, M), h = Math.max(h, M);
  const f = Math.floor(l / o) * o, m = Math.ceil(c / o) * o, y = Math.floor(u / o) * o, g = Math.ceil(h / o) * o;
  e.strokeStyle = r.grid, e.lineWidth = 1, e.beginPath();
  for (let b = f; b <= m + 1e-9; b += o) {
    const [M, $] = n([b, y, 0]), [N, E] = n([b, g, 0]);
    e.moveTo(M, $), e.lineTo(N, E);
  }
  for (let b = y; b <= g + 1e-9; b += o) {
    const [M, $] = n([f, b, 0]), [N, E] = n([m, b, 0]);
    e.moveTo(M, $), e.lineTo(N, E);
  }
  e.stroke(), e.fillStyle = r.muted, e.font = "10px ui-monospace, SFMono-Regular, Menlo, monospace";
  const [k, x] = n([f, y, 0]);
  e.fillText(
    `grid ${o < 1 ? `${o * 100} cm` : `${o} m`}`,
    Math.min(k, 8) + 6,
    Math.max(x, 16)
  );
}
function Za(e, t, n, r) {
  const [i, a] = n([0, 0, 0]), [o, l] = n([0.25, 0, 0]), c = Math.atan2(l - a, o - i), u = 7;
  e.fillStyle = r.text, e.beginPath(), e.moveTo(i + Math.cos(c) * u * 1.6, a + Math.sin(c) * u * 1.6), e.lineTo(i + Math.cos(c + 2.5) * u, a + Math.sin(c + 2.5) * u), e.lineTo(i + Math.cos(c - 2.5) * u, a + Math.sin(c - 2.5) * u), e.closePath(), e.fill(), e.font = "10px ui-monospace, SFMono-Regular, Menlo, monospace", e.fillText(t === "path" ? "origin" : "sensor", i + 10, a + 14);
}
function es(e, t, n, r) {
  const i = t[0], a = t[t.length - 1];
  if (!i || !a) return;
  if (e.font = "10px ui-monospace, SFMono-Regular, Menlo, monospace", Math.hypot(a[0] - i[0], a[1] - i[1], a[2] - i[2]) < 0.01) {
    const [h, f] = n(a);
    e.fillStyle = r.text, e.beginPath(), e.arc(h, f, 5, 0, Math.PI * 2), e.fill(), e.fillText("robot", h + 8, f - 6);
    return;
  }
  const [o, l] = n(i);
  e.strokeStyle = r.text, e.lineWidth = 1.5, e.beginPath(), e.arc(o, l, 5, 0, Math.PI * 2), e.stroke();
  const [c, u] = n(a);
  e.fillStyle = r.text, e.beginPath(), e.arc(c, u, 5, 0, Math.PI * 2), e.fill(), e.font = "10px ui-monospace, SFMono-Regular, Menlo, monospace", e.fillText("start", o + 8, l - 6), e.fillText("now", c + 8, u - 6);
}
function ts(e, t, n, r, i, a) {
  const o = new Map(t.map((c) => [c.name, c]));
  e.strokeStyle = a.link, e.lineWidth = 1, e.setLineDash([3, 3]), e.beginPath();
  for (const c of t) {
    const u = c.parent ? o.get(c.parent) : void 0;
    if (!u) continue;
    const [h, f] = r(u.position), [m, y] = r(c.position);
    e.moveTo(h, f), e.lineTo(m, y);
  }
  e.stroke(), e.setLineDash([]), e.lineWidth = 2;
  for (const c of t) {
    const [u, h] = r(c.position);
    br(c, n).forEach((f, m) => {
      const [y, g] = r(f);
      e.strokeStyle = vt[m] ?? vt[0], e.beginPath(), e.moveTo(u, h), e.lineTo(y, g), e.stroke();
    }), e.fillStyle = c.parent ? a.text : vt[0], e.beginPath(), e.arc(u, h, c.parent ? 2.5 : 4, 0, Math.PI * 2), e.fill();
  }
  if (!i) return;
  e.fillStyle = a.text, e.font = "10px ui-monospace, SFMono-Regular, Menlo, monospace";
  const l = /* @__PURE__ */ new Map();
  for (const c of t) {
    const [u, h] = r(c.position), f = `${Math.round(u / 6)}:${Math.round(h / 6)}`, m = l.get(f) ?? 0;
    l.set(f, m + 1), e.fillText(c.name, u + 6, h - 4 + m * 11);
  }
}
function pn(e) {
  if (e.kind === "tf") {
    const r = e.frames.find((o) => !o.parent), i = yr(e.frames)[0];
    let a = "";
    if (r && i && i.name !== r.name) {
      const [o, l, c] = r.position, [u, h, f] = i.position, m = Math.hypot(u - o, h - l, f - c);
      a = ` · framed on ${i.name}, ${m.toFixed(2)} m from ${r.name}`;
    }
    return `${e.frames.length} frames · root ${(r == null ? void 0 : r.name) ?? "?"}${a} · drag to orbit`;
  }
  const t = Wt(e.points), n = `${t.x.toFixed(1)} × ${t.y.toFixed(1)}${e.kind === "cloud" ? ` × ${t.z.toFixed(1)}` : ""} m`;
  if (e.kind === "path") {
    let r = 0;
    e.points.forEach((a, o) => {
      const l = e.points[o - 1];
      l && (r += Math.hypot(a[0] - l[0], a[1] - l[1], a[2] - l[2]));
    });
    const i = e.points[e.points.length - 1];
    return r < 0.01 && i ? `${e.points.length} poses · stationary at (${i[0].toFixed(2)}, ${i[1].toFixed(2)}) m` : `${e.points.length} poses · travelled ${r.toFixed(2)} m · ${n}`;
  }
  return `${e.points.length} ${e.kind === "scan" ? "returns" : "points"} · ${n} · drag to orbit`;
}
const ns = 8;
function rs({ items: e }) {
  const [t, n] = z(null), r = [...e].sort((o, l) => (l.t ?? 0) - (o.t ?? 0)), i = r.slice(0, ns), a = r.length - i.length;
  return /* @__PURE__ */ d("div", { className: "fleet-viz__images", children: [
    i.map((o, l) => /* @__PURE__ */ d(
      "button",
      {
        type: "button",
        className: `fleet-viz__image-thumb ${l === 0 ? "is-primary" : ""}`,
        onClick: () => n(l),
        title: o.t ? new Date(o.t).toLocaleString() : void 0,
        children: [
          /* @__PURE__ */ s("img", { src: o.url, alt: o.label ?? "Device camera frame", loading: "lazy" }),
          l === 0 && o.t ? /* @__PURE__ */ s("span", { className: "fleet-viz__image-time", children: new Date(o.t).toLocaleTimeString() }) : null
        ]
      },
      `${o.url}-${l}`
    )),
    a > 0 ? /* @__PURE__ */ d("span", { className: "fleet-viz__image-more", children: [
      "+",
      a,
      " more"
    ] }) : null,
    t !== null ? /* @__PURE__ */ s(is, { items: i, index: t, onIndex: n }) : null
  ] });
}
function is({
  items: e,
  index: t,
  onIndex: n
}) {
  const r = e[t];
  return K(() => {
    function i(a) {
      if (a.key === "Escape") {
        a.stopPropagation(), a.preventDefault(), n(null);
        return;
      }
      a.key === "ArrowLeft" && t > 0 && (a.stopPropagation(), n(t - 1)), a.key === "ArrowRight" && t < e.length - 1 && (a.stopPropagation(), n(t + 1));
    }
    return document.addEventListener("keydown", i, !0), () => document.removeEventListener("keydown", i, !0);
  }, [t, e.length, n]), r ? Pt(
    /* @__PURE__ */ d(
      "div",
      {
        className: "fleet-viz__lightbox",
        role: "dialog",
        "aria-label": "Image viewer",
        onClick: () => n(null),
        children: [
          /* @__PURE__ */ s(
            "img",
            {
              src: r.url,
              alt: r.label ?? "Device camera frame",
              onClick: (i) => i.stopPropagation()
            }
          ),
          /* @__PURE__ */ d("div", { className: "fleet-viz__lightbox-caption", onClick: (i) => i.stopPropagation(), children: [
            r.t ? /* @__PURE__ */ s("span", { children: new Date(r.t).toLocaleString() }) : null,
            e.length > 1 ? /* @__PURE__ */ d("span", { className: "fleet-viz__lightbox-nav", children: [
              /* @__PURE__ */ s(
                "button",
                {
                  type: "button",
                  disabled: t === 0,
                  onClick: () => n(t - 1),
                  "aria-label": "Previous image",
                  children: "‹"
                }
              ),
              t + 1,
              " / ",
              e.length,
              /* @__PURE__ */ s(
                "button",
                {
                  type: "button",
                  disabled: t === e.length - 1,
                  onClick: () => n(t + 1),
                  "aria-label": "Next image",
                  children: "›"
                }
              )
            ] }) : null,
            /* @__PURE__ */ s("a", { href: r.url, target: "_blank", rel: "noreferrer", children: "Open original ↗" })
          ] }),
          /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              className: "fleet-viz__lightbox-close",
              "aria-label": "Close image viewer",
              onClick: () => n(null),
              children: "✕"
            }
          )
        ]
      }
    ),
    document.body
  ) : null;
}
const oe = 132, as = 18, gn = oe + as, ss = 560, tt = 6, wt = 12, kt = 500;
function os(e) {
  if (e.length <= kt) return e;
  const t = e.length / kt, n = [];
  for (let a = 0; a < kt; a += 1) {
    const o = e[Math.floor(a * t)];
    o && n.push(o);
  }
  const r = e[e.length - 1], i = n[n.length - 1];
  return r && i && i.t !== r.t && n.push(r), n;
}
function ls(e, t, n = 5) {
  const r = t - e, i = [
    15e3,
    3e4,
    6e4,
    12e4,
    3e5,
    6e5,
    9e5,
    18e5,
    36e5,
    72e5,
    108e5,
    216e5,
    432e5,
    864e5,
    1728e5,
    6048e5
  ], a = i.find((l) => r / l <= n) ?? i[i.length - 1] ?? 6048e5, o = [];
  for (let l = Math.ceil(e / a) * a; l <= t; l += a) o.push(l);
  return { ticks: o, step: a };
}
function vr({ series: e }) {
  var R;
  const t = P(null), [n, r] = z(ss), [i, a] = z(null);
  K(() => {
    const v = t.current;
    if (!v) return;
    const w = new ResizeObserver((O) => {
      var W;
      const B = (W = O[0]) == null ? void 0 : W.contentRect.width;
      B && B > 0 && r(Math.round(B));
    });
    return w.observe(v), () => w.disconnect();
  }, []);
  const o = e.filter((v) => v.points.length > 0);
  if (o.length === 0) return null;
  const l = o.flatMap((v) => v.points.map((w) => w.t)), c = Math.min(...l), u = Math.max(...l), h = Math.max(u - c, 1), f = (v) => tt + (v - c) / h * (n - 2 * tt), m = new Set(o.map((v) => v.unit ?? "")), y = o.length === 1 || m.size === 1, g = (v) => {
    const w = v.flatMap((D) => D.points.map((F) => F.v)), O = Math.max(
      ...v.map((D) => D.band ? Math.max(...D.band.map((F) => F.max)) : -1 / 0)
    ), B = Math.min(
      ...v.map((D) => D.band ? Math.min(...D.band.map((F) => F.min)) : 1 / 0)
    ), W = Math.max(...w, O === -1 / 0 ? 0 : O, 0);
    return { min: Math.min(...w, B === 1 / 0 ? 0 : B, 0), max: W };
  }, k = g(o), x = Mt(k.min, k.max), b = (v, w) => (O) => {
    const B = (O - w) / (v - w || 1);
    return oe - B * (oe - wt);
  }, M = b(x.top, Math.min(k.min, 0)), $ = o.map((v, w) => {
    const O = os(v.points);
    let B = M;
    if (!y) {
      const W = g([v]), G = Mt(Math.min(W.min, 0), W.max).top;
      B = b(G, Math.min(W.min, 0));
    }
    return { label: v.label, unit: v.unit, color: at(w), points: O, yAt: B, band: v.band };
  }), N = y ? x.ticks : [], E = (N[1] ?? 0) - (N[0] ?? 0) || void 0, j = y ? [] : [0.25, 0.5, 0.75].map((v) => oe - v * (oe - wt)), { ticks: S, step: _ } = ls(c, u), I = y ? ((R = o[0]) == null ? void 0 : R.unit) ?? "" : "", p = i === null ? null : $.map((v) => {
    let w = null;
    for (const O of v.points)
      (w === null || Math.abs(O.t - i) < Math.abs(w.t - i)) && (w = O);
    return { series: v, point: w };
  }), T = i === null ? null : f(i);
  return /* @__PURE__ */ d("div", { className: "fleet-viz__chart", children: [
    /* @__PURE__ */ s("div", { className: "fleet-viz__legend", children: $.map((v) => /* @__PURE__ */ d("span", { className: "fleet-viz__legend-item", children: [
      /* @__PURE__ */ s("span", { className: "fleet-viz__legend-swatch", style: { background: v.color } }),
      v.label,
      v.unit ? ` (${v.unit})` : ""
    ] }, v.label)) }),
    /* @__PURE__ */ d("div", { ref: t, style: { position: "relative" }, children: [
      /* @__PURE__ */ d(
        "svg",
        {
          width: n,
          height: gn,
          viewBox: `0 0 ${n} ${gn}`,
          style: { display: "block" },
          role: "img",
          "aria-label": `Time series chart: ${$.map((v) => v.label).join(", ")}`,
          onMouseLeave: () => a(null),
          onMouseMove: (v) => {
            const w = v.currentTarget.getBoundingClientRect(), O = v.clientX - w.left, B = Math.min(Math.max((O - tt) / (n - 2 * tt), 0), 1);
            a(c + B * h);
          },
          children: [
            N.map((v, w) => {
              const O = M(v), B = w === 0 && v === 0;
              return /* @__PURE__ */ d("g", { children: [
                /* @__PURE__ */ s(
                  "line",
                  {
                    x1: 0,
                    x2: n,
                    y1: O,
                    y2: O,
                    stroke: "var(--border-subtle)",
                    strokeWidth: 1,
                    strokeOpacity: B ? 0.9 : 0.35,
                    vectorEffect: "non-scaling-stroke"
                  }
                ),
                B ? null : /* @__PURE__ */ d("text", { x: 4, y: O - 3, className: "fleet-viz__axis-label", children: [
                  mr(v, E),
                  w === N.length - 1 && I ? ` ${I}` : ""
                ] })
              ] }, `y-${v}`);
            }),
            j.map((v) => /* @__PURE__ */ s(
              "line",
              {
                x1: 0,
                x2: n,
                y1: v,
                y2: v,
                stroke: "var(--border-subtle)",
                strokeWidth: 1,
                strokeOpacity: 0.25,
                vectorEffect: "non-scaling-stroke"
              },
              `fg-${v}`
            )),
            y ? null : /* @__PURE__ */ s(
              "line",
              {
                x1: 0,
                x2: n,
                y1: oe,
                y2: oe,
                stroke: "var(--border-subtle)",
                strokeWidth: 1,
                strokeOpacity: 0.9,
                vectorEffect: "non-scaling-stroke"
              }
            ),
            S.map((v) => {
              const w = f(v), O = w < 40 ? "start" : w > n - 40 ? "end" : "middle";
              return /* @__PURE__ */ d("g", { children: [
                /* @__PURE__ */ s(
                  "line",
                  {
                    x1: w,
                    x2: w,
                    y1: wt / 2,
                    y2: oe,
                    stroke: "var(--border-subtle)",
                    strokeWidth: 1,
                    strokeOpacity: 0.18,
                    vectorEffect: "non-scaling-stroke"
                  }
                ),
                /* @__PURE__ */ s(
                  "line",
                  {
                    x1: w,
                    x2: w,
                    y1: oe,
                    y2: oe + 4,
                    stroke: "var(--text-muted)",
                    strokeWidth: 1,
                    strokeOpacity: 0.6,
                    vectorEffect: "non-scaling-stroke"
                  }
                ),
                /* @__PURE__ */ s("text", { x: w, y: oe + 13, textAnchor: O, className: "fleet-viz__axis-label", children: pr(v, h, _) })
              ] }, `x-${v}`);
            }),
            $.map((v) => {
              const w = v.band;
              if (!w || w.length < 2) return null;
              const O = w.map((W) => `${f(W.t)},${v.yAt(W.max)}`), B = [...w].reverse().map((W) => `${f(W.t)},${v.yAt(W.min)}`);
              return /* @__PURE__ */ s(
                "polygon",
                {
                  points: [...O, ...B].join(" "),
                  fill: v.color,
                  opacity: 0.12
                },
                `band-${v.label}`
              );
            }),
            $.map((v) => /* @__PURE__ */ s(
              "polyline",
              {
                points: v.points.map((w) => `${f(w.t)},${v.yAt(w.v)}`).join(" "),
                fill: "none",
                stroke: v.color,
                strokeWidth: 1.5,
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
              },
              v.label
            )),
            T !== null ? /* @__PURE__ */ s(
              "line",
              {
                x1: T,
                x2: T,
                y1: 0,
                y2: oe,
                stroke: "var(--text-secondary)",
                strokeWidth: 1,
                opacity: 0.5,
                vectorEffect: "non-scaling-stroke"
              }
            ) : null,
            p ? p.map(
              ({ series: v, point: w }) => w ? /* @__PURE__ */ s(
                "circle",
                {
                  cx: f(w.t),
                  cy: v.yAt(w.v),
                  r: 3.5,
                  fill: v.color
                },
                `dot-${v.label}`
              ) : null
            ) : null
          ]
        }
      ),
      p && T !== null ? /* @__PURE__ */ s(cs, { entries: p, x: T, chartWidth: n, spanMs: h, stepMs: _ }) : null
    ] })
  ] });
}
function cs({
  entries: e,
  x: t,
  chartWidth: n,
  spanMs: r,
  stepMs: i
}) {
  var c;
  const o = t + 12 + 200 > n ? Math.max(0, t - 12 - 200) : t + 12, l = ((c = e.find((u) => u.point !== null)) == null ? void 0 : c.point) ?? null;
  return /* @__PURE__ */ d("div", { className: "fleet-viz__hover-pane", role: "tooltip", style: { left: o, width: 200 }, children: [
    l ? /* @__PURE__ */ s("div", { className: "fleet-viz__hover-time", children: pr(l.t, r, i) }) : null,
    e.map(({ series: u, point: h }) => /* @__PURE__ */ d("div", { className: "fleet-viz__hover-row", children: [
      /* @__PURE__ */ d("span", { className: "fleet-viz__hover-label", children: [
        /* @__PURE__ */ s("span", { className: "fleet-viz__legend-swatch", style: { background: u.color } }),
        u.label
      ] }),
      /* @__PURE__ */ s("span", { className: "fleet-viz__hover-value", children: h ? hr(h.v, u.unit) : "—" })
    ] }, u.label))
  ] });
}
function ke(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function Xe(e) {
  return typeof e == "number" && Number.isFinite(e);
}
function st(e) {
  return e.reduce((t, n) => typeof n == "number" ? `${t}[${n}]` : t ? `${t}.${n}` : n, "");
}
function us(e) {
  const t = [];
  for (const n of e.split(".")) {
    const r = /^([^[\]]*)((?:\[\d+\])*)$/.exec(n);
    if (!r) return [];
    r[1] && t.push(r[1]);
    for (const i of (r[2] ?? "").matchAll(/\[(\d+)\]/g)) t.push(Number(i[1]));
  }
  return t;
}
function yn(e, t) {
  let n = e;
  for (const r of t) {
    if (n === null || typeof n != "object") return;
    n = n[String(r)];
  }
  return n;
}
function ds(e) {
  if (!ke(e) || !ke(e.header)) return null;
  const t = e.header, n = ke(t.stamp) ? t.stamp : null, r = n ? n.sec ?? n.secs : void 0, i = n ? n.nanosec ?? n.nsecs ?? 0 : 0;
  return {
    frameId: typeof t.frame_id == "string" && t.frame_id ? t.frame_id : null,
    stamp: Xe(r) ? r + (Xe(i) ? i / 1e9 : 0) : null
  };
}
function fs(e) {
  return e > 1e9 ? new Date(e * 1e3).toISOString().replace("T", " ").slice(0, 23) + "Z" : `${e.toFixed(3)} s (sim clock)`;
}
function wr(e, t) {
  return Object.keys(e).length === t.length && t.every((r) => Xe(e[r]));
}
function kr(e) {
  return ke(e) && wr(e, ["x", "y", "z", "w"]);
}
function _r(e) {
  return ke(e) && wr(e, ["x", "y", "z"]);
}
function hs(e) {
  const t = Math.hypot(e.x, e.y, e.z, e.w) || 1, n = e.x / t, r = e.y / t, i = e.z / t, a = e.w / t, o = Math.atan2(2 * (a * n + r * i), 1 - 2 * (n * n + r * r)), l = Math.asin(Math.max(-1, Math.min(1, 2 * (a * r - i * n)))), c = Math.atan2(2 * (a * i + n * r), 1 - 2 * (r * r + i * i)), u = 180 / Math.PI;
  return [o * u, l * u, c * u];
}
function ms(e, t) {
  return !/covariance/i.test(e) || !t.every(Xe) ? null : t.length === 9 ? 3 : t.length === 36 ? 6 : null;
}
function ps(e) {
  for (const [t, n] of Object.entries(e)) {
    if (!Array.isArray(n) || n.length === 0 || !n.every((i) => typeof i == "string")) continue;
    const r = Object.entries(e).filter(
      ([i, a]) => i !== t && Array.isArray(a) && a.length === n.length && a.every(Xe)
    ).map(([i, a]) => ({ key: i, values: a }));
    if (r.length > 0) return { labelKey: t, labels: n, columns: r };
  }
  return null;
}
function Bt(e) {
  if (e === 0) return "0";
  const t = Math.abs(e);
  return t >= 1e6 || t < 1e-3 ? e.toExponential(2) : Number.isInteger(e) ? String(e) : String(Number(e.toPrecision(4)));
}
const _t = 24, ot = 40;
function Nr({
  samples: e,
  field: t = null,
  compact: n = !1
}) {
  var m;
  const r = (m = e[e.length - 1]) == null ? void 0 : m.value, i = ds(r), a = !n && e.length >= 2, [o, l] = z(() => {
    if (!t) return null;
    const y = us(t);
    return y.length && typeof yn(r, y) == "number" ? y : null;
  }), c = o ? st(o) : null, u = Q(() => {
    if (!a || !o) return null;
    const y = e.map((g, k) => {
      const x = yn(g.value, o);
      return typeof x == "number" && Number.isFinite(x) ? { t: g.t ?? k * 1e3, v: x } : null;
    }).filter((g) => g !== null);
    return y.length >= 2 ? [{ label: st(o), points: y }] : null;
  }, [e, o, a]);
  if (!r) return null;
  const h = {
    selectable: a,
    selected: c,
    toggle: (y) => l(st(y) === c ? null : y)
  }, f = i && ke(r) ? Object.fromEntries(Object.entries(r).filter(([y]) => y !== "header")) : r;
  return /* @__PURE__ */ d("div", { className: n ? "fleet-viz__record is-compact" : "fleet-viz__record", children: [
    !n && (i || e.length > 1) ? /* @__PURE__ */ d("div", { className: "fleet-viz__record-meta", children: [
      i != null && i.frameId ? /* @__PURE__ */ d("span", { className: "fleet-viz__record-chip", children: [
        "frame ",
        /* @__PURE__ */ s("b", { children: i.frameId })
      ] }) : null,
      (i == null ? void 0 : i.stamp) != null ? /* @__PURE__ */ d("span", { className: "fleet-viz__record-chip", children: [
        "stamp ",
        /* @__PURE__ */ s("b", { children: fs(i.stamp) })
      ] }) : null,
      e.length > 1 ? /* @__PURE__ */ d("span", { className: "fleet-viz__record-chip", children: [
        e.length,
        " samples"
      ] }) : null
    ] }) : null,
    /* @__PURE__ */ s(xr, { value: f, path: [], depth: 0, pick: h }),
    u ? /* @__PURE__ */ s("div", { className: "fleet-viz__record-chart", children: /* @__PURE__ */ s(vr, { series: u }) }) : null,
    a ? /* @__PURE__ */ s("div", { className: "fleet-viz__record-hint", children: u ? `Charting ${c} across ${e.length} samples — click another number to switch.` : `Click any number to chart it across the ${e.length} samples.` }) : null,
    n ? null : /* @__PURE__ */ d("details", { className: "fleet-viz__record-raw", children: [
      /* @__PURE__ */ s("summary", { children: "raw JSON" }),
      /* @__PURE__ */ s("pre", { children: JSON.stringify(r, null, 2) })
    ] })
  ] });
}
function xr({
  value: e,
  path: t,
  depth: n,
  pick: r
}) {
  if (Array.isArray(e))
    return /* @__PURE__ */ d("div", { className: "fleet-viz__record-fields", children: [
      e.slice(0, ot).map((o, l) => /* @__PURE__ */ s(bn, { name: `[${l}]`, value: o, path: [...t, l], depth: n, pick: r }, l)),
      e.length > ot ? /* @__PURE__ */ d("div", { className: "fleet-viz__record-more", children: [
        "+",
        e.length - ot,
        " more"
      ] }) : null
    ] });
  if (!ke(e)) return /* @__PURE__ */ s(Sr, { value: e, path: t, pick: r });
  const i = ps(e), a = new Set(i ? [i.labelKey, ...i.columns.map((o) => o.key)] : []);
  return /* @__PURE__ */ d("div", { className: "fleet-viz__record-fields", children: [
    i ? /* @__PURE__ */ s(gs, { table: i, path: t, pick: r }) : null,
    Object.entries(e).filter(([o]) => !a.has(o)).map(([o, l]) => /* @__PURE__ */ s(bn, { name: o, value: l, path: [...t, o], depth: n, pick: r }, o))
  ] });
}
function bn({
  name: e,
  value: t,
  path: n,
  depth: r,
  pick: i
}) {
  if (ke(t) && !kr(t) && !_r(t) || Array.isArray(t) && t.some((o) => o !== null && typeof o == "object")) {
    const o = Array.isArray(t) ? `${t.length} items` : `${Object.keys(t).length} fields`;
    return /* @__PURE__ */ d("details", { className: "fleet-viz__record-group", open: r < 2, children: [
      /* @__PURE__ */ d("summary", { children: [
        /* @__PURE__ */ s("span", { className: "fleet-viz__record-key", children: e }),
        /* @__PURE__ */ s("span", { className: "fleet-viz__record-dim", children: o })
      ] }),
      /* @__PURE__ */ s(xr, { value: t, path: n, depth: r + 1, pick: i })
    ] });
  }
  return /* @__PURE__ */ d("div", { className: "fleet-viz__record-row", children: [
    /* @__PURE__ */ s("span", { className: "fleet-viz__record-key", children: e }),
    /* @__PURE__ */ s("span", { className: "fleet-viz__record-value", children: /* @__PURE__ */ s(Sr, { value: t, path: n, pick: i, name: e }) })
  ] });
}
function Sr({
  value: e,
  path: t,
  pick: n,
  name: r = ""
}) {
  if (typeof e == "number") return /* @__PURE__ */ s(ze, { v: e, path: t, pick: n });
  if (typeof e == "boolean")
    return /* @__PURE__ */ s("span", { className: e ? "fleet-viz__record-on" : "fleet-viz__record-off", children: e ? "true" : "false" });
  if (typeof e == "string")
    return e ? /* @__PURE__ */ s("span", { className: "fleet-viz__record-str", children: e }) : /* @__PURE__ */ s("span", { className: "fleet-viz__record-dim", children: "empty" });
  if (e == null)
    return /* @__PURE__ */ s("span", { className: "fleet-viz__record-dim", children: "null" });
  if (kr(e)) {
    const [i, a, o] = hs(e);
    return /* @__PURE__ */ d("span", { className: "fleet-viz__record-inline", children: [
      ["x", "y", "z", "w"].map((l) => /* @__PURE__ */ s(ze, { label: l, v: e[l], path: [...t, l], pick: n }, l)),
      /* @__PURE__ */ d("span", { className: "fleet-viz__record-derived", children: [
        "roll ",
        i.toFixed(1),
        "° · pitch ",
        a.toFixed(1),
        "° · yaw ",
        o.toFixed(1),
        "°"
      ] })
    ] });
  }
  if (_r(e))
    return /* @__PURE__ */ d("span", { className: "fleet-viz__record-inline", children: [
      ["x", "y", "z"].map((i) => /* @__PURE__ */ s(ze, { label: i, v: e[i], path: [...t, i], pick: n }, i)),
      /* @__PURE__ */ d("span", { className: "fleet-viz__record-derived", children: [
        "|v| ",
        Bt(Math.hypot(e.x, e.y, e.z))
      ] })
    ] });
  if (Array.isArray(e)) {
    if (e.length === 0) return /* @__PURE__ */ s("span", { className: "fleet-viz__record-dim", children: "empty" });
    const i = ms(r, e);
    return i ? /* @__PURE__ */ s(ys, { values: e, size: i, path: t, pick: n }) : /* @__PURE__ */ d("span", { className: "fleet-viz__record-inline", children: [
      e.slice(0, _t).map(
        (a, o) => typeof a == "number" ? /* @__PURE__ */ s(ze, { v: a, path: [...t, o], pick: n }, o) : /* @__PURE__ */ s("span", { className: "fleet-viz__record-chip", children: String(a) }, o)
      ),
      e.length > _t ? /* @__PURE__ */ d("span", { className: "fleet-viz__record-dim", children: [
        "+",
        e.length - _t,
        " more"
      ] }) : null
    ] });
  }
  return /* @__PURE__ */ s("span", { className: "fleet-viz__record-str", children: JSON.stringify(e) });
}
function ze({
  v: e,
  path: t,
  pick: n,
  label: r
}) {
  const i = /* @__PURE__ */ d(re, { children: [
    r ? /* @__PURE__ */ s("i", { children: r }) : null,
    Bt(e)
  ] });
  if (!n.selectable) return /* @__PURE__ */ s("span", { className: "fleet-viz__record-num", children: i });
  const a = st(t);
  return /* @__PURE__ */ s(
    "button",
    {
      type: "button",
      className: n.selected === a ? "fleet-viz__record-num is-active" : "fleet-viz__record-num",
      title: `Chart ${a}`,
      onClick: () => n.toggle(t),
      children: i
    }
  );
}
function gs({
  table: e,
  path: t,
  pick: n
}) {
  return /* @__PURE__ */ d("table", { className: "fleet-viz__record-table", children: [
    /* @__PURE__ */ s("thead", { children: /* @__PURE__ */ d("tr", { children: [
      /* @__PURE__ */ s("th", { children: e.labelKey }),
      e.columns.map((r) => /* @__PURE__ */ s("th", { children: r.key }, r.key))
    ] }) }),
    /* @__PURE__ */ s("tbody", { children: e.labels.slice(0, ot).map((r, i) => /* @__PURE__ */ d("tr", { children: [
      /* @__PURE__ */ s("td", { className: "fleet-viz__record-rowlabel", children: r }),
      e.columns.map((a) => /* @__PURE__ */ s("td", { children: /* @__PURE__ */ s(ze, { v: a.values[i] ?? 0, path: [...t, a.key, i], pick: n }) }, a.key))
    ] }, `${r}-${i}`)) })
  ] });
}
function ys({
  values: e,
  size: t,
  path: n,
  pick: r
}) {
  const [i, a] = z(!1), o = Array.from({ length: t }, (c, u) => e[u * t + u] ?? 0), l = e.every((c) => c === 0) ? "all zero" : `diag ${o.map(Bt).join(" · ")}`;
  return /* @__PURE__ */ d("span", { className: "fleet-viz__record-cov", children: [
    /* @__PURE__ */ d("button", { type: "button", className: "fleet-viz__record-toggle", onClick: () => a(!i), children: [
      t,
      "×",
      t,
      " · ",
      l,
      " ",
      i ? "▾" : "▸"
    ] }),
    i ? /* @__PURE__ */ s(
      "span",
      {
        className: "fleet-viz__record-matrix",
        style: { gridTemplateColumns: `repeat(${t}, auto)` },
        children: e.map((c, u) => /* @__PURE__ */ s(ze, { v: c, path: [...n, u], pick: r }, u))
      }
    ) : null
  ] });
}
const Ae = 260, bs = 560, he = 256, $t = 3, Cr = 18;
function Tt(e, t) {
  return (e + 180) / 360 * 2 ** t * he;
}
function It(e, t) {
  const r = Math.max(Math.min(e, 85.051), -85.051) * Math.PI / 180;
  return (1 - Math.log(Math.tan(r) + 1 / Math.cos(r)) / Math.PI) / 2 * 2 ** t * he;
}
function vs(e, t) {
  if (e.length <= 1) return 16;
  for (let n = Cr; n >= $t; n -= 1) {
    const r = e.map((l) => Tt(l.longitude, n)), i = e.map((l) => It(l.latitude, n)), a = Math.max(...r) - Math.min(...r), o = Math.max(...i) - Math.min(...i);
    if (a <= t * 0.8 && o <= Ae * 0.8) return n;
  }
  return $t;
}
function Mr({
  points: e,
  variant: t = "trail"
}) {
  const n = P(null), [r, i] = z(bs), [a, o] = z(0);
  if (K(() => {
    const p = n.current;
    if (!p) return;
    const T = new ResizeObserver((R) => {
      var w;
      const v = (w = R[0]) == null ? void 0 : w.contentRect.width;
      v && v > 0 && i(Math.round(v));
    });
    return T.observe(p), () => T.disconnect();
  }, []), e.length === 0) return null;
  const l = Math.max($t, Math.min(Cr, vs(e, r) + a)), c = e.reduce((p, T) => p + T.latitude, 0) / e.length, u = e.reduce((p, T) => p + T.longitude, 0) / e.length, h = Tt(u, l), f = It(c, l), m = h - r / 2, y = f - Ae / 2, g = 2 ** l, k = [], x = Math.floor(m / he), b = Math.floor(y / he), M = Math.floor((m + r) / he), $ = Math.floor((y + Ae) / he), N = 48;
  e: for (let p = x; p <= M; p += 1)
    for (let T = b; T <= $; T += 1) {
      if (k.length >= N) break e;
      if (T < 0 || T >= g) continue;
      const R = (p % g + g) % g;
      k.push({
        key: `${l}/${p}/${T}`,
        url: `https://tile.openstreetmap.org/${l}/${R}/${T}.png`,
        left: p * he - m,
        top: T * he - y
      });
    }
  const E = (p) => ({
    x: Tt(p.longitude, l) - m,
    y: It(p.latitude, l) - y
  }), j = e.map(E), S = j[j.length - 1], _ = e.filter((p) => p.label), I = e.length === 1 && e[0] ? `https://www.openstreetmap.org/?mlat=${e[0].latitude}&mlon=${e[0].longitude}#map=${l}/${e[0].latitude}/${e[0].longitude}` : `https://www.openstreetmap.org/#map=${l}/${c}/${u}`;
  return /* @__PURE__ */ d("div", { className: "fleet-viz__map", ref: n, children: [
    /* @__PURE__ */ d("div", { className: "fleet-viz__map-canvas", style: { height: Ae }, children: [
      k.map((p) => /* @__PURE__ */ s(
        "img",
        {
          src: p.url,
          alt: "",
          width: he,
          height: he,
          loading: "lazy",
          draggable: !1,
          className: "fleet-viz__map-tile",
          style: { left: p.left, top: p.top }
        },
        p.key
      )),
      /* @__PURE__ */ d(
        "svg",
        {
          className: "fleet-viz__map-overlay",
          width: r,
          height: Ae,
          viewBox: `0 0 ${r} ${Ae}`,
          role: "img",
          "aria-label": `Map with ${e.length} device position${e.length === 1 ? "" : "s"}`,
          children: [
            t === "trail" && _.length <= 1 && j.length > 1 ? /* @__PURE__ */ s(
              "polyline",
              {
                points: j.map((p) => `${p.x},${p.y}`).join(" "),
                fill: "none",
                stroke: "var(--interface-iris)",
                strokeWidth: 2,
                strokeLinejoin: "round",
                strokeOpacity: 0.75
              }
            ) : null,
            t === "markers" || _.length > 1 ? (
              // Multi-device map: every labelled point is a current position.
              e.map((p, T) => {
                const R = E(p);
                return /* @__PURE__ */ d("g", { children: [
                  /* @__PURE__ */ s(
                    "circle",
                    {
                      cx: R.x,
                      cy: R.y,
                      r: 6,
                      fill: "var(--interface-iris)",
                      stroke: "white",
                      strokeWidth: 2
                    }
                  ),
                  p.label ? /* @__PURE__ */ s("text", { x: R.x + 9, y: R.y + 4, className: "fleet-viz__map-label", children: p.label }) : null
                ] }, `${p.label ?? "pt"}-${T}`);
              })
            ) : S ? /* @__PURE__ */ d("g", { children: [
              /* @__PURE__ */ s(
                "circle",
                {
                  cx: S.x,
                  cy: S.y,
                  r: 7,
                  fill: "var(--interface-iris)",
                  fillOpacity: 0.25
                }
              ),
              /* @__PURE__ */ s(
                "circle",
                {
                  cx: S.x,
                  cy: S.y,
                  r: 5,
                  fill: "var(--interface-iris)",
                  stroke: "white",
                  strokeWidth: 2
                }
              )
            ] }) : null
          ]
        }
      ),
      /* @__PURE__ */ d("div", { className: "fleet-viz__map-controls", children: [
        /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            "aria-label": "Zoom in",
            onClick: () => o((p) => Math.min(p + 1, 6)),
            children: "+"
          }
        ),
        /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            "aria-label": "Zoom out",
            onClick: () => o((p) => Math.max(p - 1, -6)),
            children: "−"
          }
        )
      ] }),
      /* @__PURE__ */ s("div", { className: "fleet-viz__map-attribution", children: /* @__PURE__ */ s("a", { href: "https://www.openstreetmap.org/copyright", target: "_blank", rel: "noreferrer", children: "© OpenStreetMap" }) })
    ] }),
    /* @__PURE__ */ d("div", { className: "fleet-viz__map-footer", children: [
      /* @__PURE__ */ s("span", { className: "fleet-viz__map-coords", children: e.length === 1 && e[0] ? `${e[0].latitude.toFixed(5)}, ${e[0].longitude.toFixed(5)}` : `${e.length} positions` }),
      /* @__PURE__ */ s("a", { href: I, target: "_blank", rel: "noreferrer", children: "Open map ↗" })
    ] })
  ] });
}
function ws({ tiles: e }) {
  return /* @__PURE__ */ s("div", { className: "fleet-viz__tiles", children: e.map((t, n) => /* @__PURE__ */ d("div", { className: "fleet-viz__tile", children: [
    /* @__PURE__ */ d("div", { className: "fleet-viz__tile-head", children: [
      /* @__PURE__ */ s("span", { className: "fleet-viz__tile-label", title: t.label, children: t.label }),
      t.sublabel ? /* @__PURE__ */ s("span", { className: "fleet-viz__tile-sub", children: t.sublabel }) : null
    ] }),
    /* @__PURE__ */ s(ks, { value: t.value }),
    t.t ? /* @__PURE__ */ s("div", { className: "fleet-viz__tile-time", children: new Date(t.t).toLocaleString() }) : null
  ] }, `${t.label}-${t.sublabel ?? ""}-${n}`)) });
}
function ks({ value: e }) {
  switch (e.type) {
    case "numeric":
      return /* @__PURE__ */ d("div", { className: "fleet-viz__tile-stat", children: [
        Nt(e.value),
        e.unit ? /* @__PURE__ */ s("span", { className: "fleet-viz__tile-unit", children: e.unit }) : null
      ] });
    case "battery": {
      const t = Math.max(0, Math.min(100, e.percentage));
      return /* @__PURE__ */ d("div", { children: [
        /* @__PURE__ */ d("div", { className: "fleet-viz__tile-stat", children: [
          Nt(e.percentage),
          /* @__PURE__ */ s("span", { className: "fleet-viz__tile-unit", children: "%" })
        ] }),
        /* @__PURE__ */ s("div", { className: "fleet-viz__battery-track", children: /* @__PURE__ */ s(
          "div",
          {
            className: `fleet-viz__battery-fill ${t <= 20 ? "is-low" : ""}`,
            style: { width: `${t}%` }
          }
        ) })
      ] });
    }
    case "health":
      return /* @__PURE__ */ d("div", { className: `fleet-viz__health is-${e.status}`, children: [
        /* @__PURE__ */ s("span", { className: "fleet-viz__health-dot" }),
        e.status
      ] });
    case "bitset":
      return /* @__PURE__ */ s("div", { className: "fleet-viz__bitset", children: e.entries.map((t, n) => /* @__PURE__ */ s(
        "span",
        {
          className: `fleet-viz__flag ${t.value ? "is-on" : "is-off"}`,
          children: Ns(t.key)
        },
        `${t.key}-${n}`
      )) });
    case "numeric-set":
      return /* @__PURE__ */ d("div", { className: "fleet-viz__setlist", children: [
        e.entries.slice(0, 6).map((t, n) => /* @__PURE__ */ d("div", { className: "fleet-viz__setrow", children: [
          /* @__PURE__ */ s("span", { className: "fleet-viz__setlabel", title: t.label, children: t.label }),
          /* @__PURE__ */ d("span", { className: "fleet-viz__setvalue", children: [
            Nt(t.value),
            t.unit ? ` ${t.unit}` : ""
          ] })
        ] }, `${t.label}-${n}`)),
        e.entries.length > 6 ? /* @__PURE__ */ d("div", { className: "fleet-viz__setrow fleet-viz__setrow--more", children: [
          "+",
          e.entries.length - 6,
          " more"
        ] }) : null
      ] });
    case "location":
      return /* @__PURE__ */ s("div", { className: "fleet-viz__tile-map", children: /* @__PURE__ */ s(Mr, { points: [{ latitude: e.latitude, longitude: e.longitude, t: null }] }) });
    case "image":
      return /* @__PURE__ */ s(_s, { url: e.url });
    case "video":
      return /* @__PURE__ */ s("figure", { className: "fleet-viz__video fleet-viz__video--tile", children: /* @__PURE__ */ s("video", { controls: !0, preload: "metadata", src: e.url }) });
    case "text":
      return /* @__PURE__ */ s("div", { className: "fleet-viz__tile-text", title: e.value, children: e.value });
    case "json":
      return /* @__PURE__ */ s(Nr, { samples: [{ t: null, value: e.value }], compact: !0 });
    default:
      return null;
  }
}
function _s({ url: e }) {
  const [t, n] = z(!1);
  return /* @__PURE__ */ d(re, { children: [
    /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        className: "fleet-viz__image-thumb",
        onClick: () => n((r) => !r),
        children: /* @__PURE__ */ s("img", { src: e, alt: "Latest camera frame", loading: "lazy" })
      }
    ),
    t ? /* @__PURE__ */ s("a", { href: e, target: "_blank", rel: "noreferrer", className: "fleet-viz__tile-open", children: "Open original ↗" }) : null
  ] });
}
function Nt(e) {
  const t = Math.abs(e);
  return t >= 1e3 ? e.toLocaleString(void 0, { maximumFractionDigits: 0 }) : t >= 100 ? e.toFixed(0) : t >= 1 ? e.toFixed(1) : e.toFixed(3);
}
function Ns(e) {
  return e.split("/").filter(Boolean).pop() ?? e;
}
function xs({ items: e }) {
  const t = [...e].sort((n, r) => (r.t ?? 0) - (n.t ?? 0));
  return /* @__PURE__ */ s("div", { className: "fleet-viz__videos", children: t.map((n, r) => /* @__PURE__ */ d("figure", { className: "fleet-viz__video", children: [
    /* @__PURE__ */ s("video", { controls: !0, preload: "metadata", src: n.url }),
    /* @__PURE__ */ d("figcaption", { children: [
      n.t ? /* @__PURE__ */ s("span", { children: new Date(n.t).toLocaleString() }) : null,
      n.durationMs !== null ? /* @__PURE__ */ d("span", { children: [
        (n.durationMs / 1e3).toFixed(1),
        "s"
      ] }) : null,
      /* @__PURE__ */ s("a", { href: n.url, target: "_blank", rel: "noreferrer", children: "Open original ↗" })
    ] })
  ] }, `${n.url}-${r}`)) });
}
function $r({ model: e }) {
  return /* @__PURE__ */ d("div", { className: "fleet-viz", children: [
    e.title ? /* @__PURE__ */ s("div", { className: "fleet-viz__title", children: e.title }) : null,
    /* @__PURE__ */ s(Ss, { model: e })
  ] });
}
function Ss({ model: e }) {
  switch (e.kind) {
    case "timeseries":
      return /* @__PURE__ */ s(vr, { series: e.series });
    case "bars":
      return /* @__PURE__ */ s(Fa, { model: e });
    case "images":
      return /* @__PURE__ */ s(rs, { items: e.items });
    case "videos":
      return /* @__PURE__ */ s(xs, { items: e.items });
    case "map":
      return /* @__PURE__ */ s(Mr, { points: e.points, variant: e.variant });
    case "values":
      return /* @__PURE__ */ s(ws, { tiles: e.tiles });
    case "geometry":
      return /* @__PURE__ */ s(Va, { geometry: e.geometry });
    case "record":
      return /* @__PURE__ */ s(Nr, { samples: e.samples, field: e.field });
    default:
      return null;
  }
}
const Cs = /^img-[0-9a-f-]{36}\.[a-z0-9]{2,5}$/;
function Ue(e, t = [], n = 0) {
  if (n > 12 || e == null) return t;
  if (typeof e == "string") {
    const a = Ms(e);
    return a !== void 0 && Ue(a, t, n + 1), t;
  }
  if (Array.isArray(e)) {
    for (const a of e) Ue(a, t, n + 1);
    return t;
  }
  if (typeof e != "object") return t;
  const r = e, i = r.image_refs;
  if (Array.isArray(i))
    for (const a of i) {
      if (a === null || typeof a != "object" || !("ref" in a)) continue;
      const o = a.ref;
      typeof o != "string" || !Cs.test(o) || t.includes(o) || t.push(o);
    }
  for (const a of Object.values(r))
    (typeof a == "string" || typeof a == "object" && a !== null) && Ue(a, t, n + 1);
  return t;
}
function Ms(e) {
  const t = e.trim(), n = t.startsWith("{") && t.endsWith("}"), r = t.startsWith("[") && t.endsWith("]");
  if (!(!n && !r))
    try {
      return JSON.parse(t);
    } catch {
      return;
    }
}
const Tr = je({}), $s = Tr.Provider;
function Kt() {
  return Ee(Tr);
}
function Ts({ calls: e, live: t }) {
  const { renderToolCall: n } = Kt(), { customCards: r, otherCalls: i } = Q(() => {
    const a = [], o = [];
    for (const l of e) {
      const c = n ? n(l) : null;
      if (c) {
        a.push({ call: l, node: c });
        continue;
      }
      const u = Sa(l);
      if (u) {
        a.push({ call: l, node: /* @__PURE__ */ s(za, { ...u }) });
        continue;
      }
      o.push(l);
    }
    return { customCards: a, otherCalls: o };
  }, [e, n]);
  return /* @__PURE__ */ d(re, { children: [
    r.map(({ call: a, node: o }) => /* @__PURE__ */ s(Jr, { children: o }, a.toolCallId)),
    i.length > 0 ? /* @__PURE__ */ s(Is, { calls: i, live: t }) : null
  ] });
}
function Is({ calls: e, live: t }) {
  const [n, r] = z(!1), i = P(t);
  lt(() => {
    i.current && !t && r(!0), i.current = t;
  }, [t]);
  const a = e[0];
  if (e.length === 1 && a)
    return /* @__PURE__ */ s("div", { className: "pa-chat-tools", children: /* @__PURE__ */ s(vn, { call: a, live: t }) });
  const o = e.reduce((f, m) => f + (m.durationMs ?? 0), 0), l = [...new Set(e.map((f) => f.name))], c = l.slice(0, 3).join(", ") + (l.length > 3 ? " +" : ""), u = e.filter((f) => !f.hasResult).length, h = t || n;
  return /* @__PURE__ */ d("div", { className: "pa-chat-tools", children: [
    t ? null : /* @__PURE__ */ d(
      "button",
      {
        type: "button",
        className: "pa-chat-tools-summary",
        onClick: () => r((f) => !f),
        "aria-expanded": n,
        children: [
          /* @__PURE__ */ s("span", { children: n ? "▾" : "▸" }),
          /* @__PURE__ */ d("span", { children: [
            "⚙ ",
            e.length,
            " tool call",
            e.length === 1 ? "" : "s",
            o > 0 ? ` · ${jt(o)}` : ""
          ] }),
          /* @__PURE__ */ d("span", { className: "t-muted", children: [
            "· ",
            c
          ] }),
          u > 0 && /* @__PURE__ */ d("span", { className: "t-muted", children: [
            "· ",
            u,
            " interrupted"
          ] })
        ]
      }
    ),
    h ? e.map((f) => /* @__PURE__ */ s(vn, { call: f, live: t }, f.toolCallId)) : (
      // Even with the per-call rows collapsed, media results (camera
      // frames, charts, fleet viz) stay visible — an operator should never
      // have to expand a tool group to see an image the agent fetched.
      e.map((f) => /* @__PURE__ */ s(Ir, { call: f }, f.toolCallId))
    )
  ] });
}
function vn({ call: e, live: t }) {
  const [n, r] = z(!1), i = !e.hasResult && !t;
  return /* @__PURE__ */ d(re, { children: [
    /* @__PURE__ */ d("div", { className: "pa-chat-tool-row", onClick: () => r((a) => !a), children: [
      e.hasResult ? /* @__PURE__ */ s("span", { className: "pa-chat-tool-ok", children: "✓" }) : t ? /* @__PURE__ */ s("span", { className: "pa-chat-spinner-dot" }) : /* @__PURE__ */ s("span", { className: "pa-chat-tool-stopped", children: "✕" }),
      /* @__PURE__ */ s("span", { className: "pa-chat-tool-name", children: e.name }),
      e.mcpName ? /* @__PURE__ */ s("span", { className: "pa-chat-tool-mcp", children: e.mcpName }) : null,
      /* @__PURE__ */ s("span", { className: "pa-chat-tool-args", children: As(e.args) }),
      /* @__PURE__ */ s("span", { className: "pa-chat-tool-status", children: e.hasResult ? typeof e.durationMs == "number" && jt(e.durationMs) : t ? "running…" : "interrupted" })
    ] }),
    n && /* @__PURE__ */ d("div", { className: "pa-chat-tool-detail", children: [
      e.mcpName ? /* @__PURE__ */ d("div", { className: "pa-chat-tool-pane-label", children: [
        "via MCP: ",
        /* @__PURE__ */ s("span", { className: "pa-chat-tool-mcp", children: e.mcpName })
      ] }) : null,
      /* @__PURE__ */ d("div", { children: [
        /* @__PURE__ */ s("div", { className: "pa-chat-tool-pane-label", children: "args" }),
        /* @__PURE__ */ s(He, { value: e.args })
      ] }),
      e.hasResult && /* @__PURE__ */ d("div", { children: [
        /* @__PURE__ */ s("div", { className: "pa-chat-tool-pane-label", children: "result" }),
        /* @__PURE__ */ s(He, { value: e.result, toolName: e.name })
      ] }),
      i && /* @__PURE__ */ s("div", { className: "pa-chat-tool-pane-label", style: { color: "var(--text-muted)" }, children: "no result — run was interrupted" })
    ] }),
    !n && /* @__PURE__ */ s(Ir, { call: e })
  ] });
}
function Ir({ call: e }) {
  const { renderToolValueExtra: t } = Kt(), n = Q(
    () => e.hasResult ? Ue(e.result) : [],
    [e.hasResult, e.result]
  ), r = Q(
    () => e.hasResult && n.length === 0 ? Se(e.result) : [],
    [e.hasResult, e.result, n.length]
  ), i = Q(() => {
    if (!e.hasResult) return null;
    const a = t == null ? void 0 : t(e.result);
    if (a) return a;
    const o = ir(e.result, { toolName: e.name });
    return o ? /* @__PURE__ */ s($r, { model: o }) : null;
  }, [e.hasResult, e.result, e.name, t]);
  return !e.hasResult || !i && r.length === 0 && n.length === 0 ? null : /* @__PURE__ */ d("div", { className: "pa-chat-tool-inline-media", children: [
    i,
    /* @__PURE__ */ s(Lt, { images: r }),
    /* @__PURE__ */ s(fr, { refs: n })
  ] });
}
function He({ value: e, toolName: t }) {
  const { renderToolValueExtra: n } = Kt(), r = (n == null ? void 0 : n(e)) ?? null, i = r ? null : ir(e, { toolName: t }), a = r ?? (i ? /* @__PURE__ */ s($r, { model: i }) : null), o = Ue(e), l = o.length === 0 ? Se(e) : [], c = Rt(e, {
    redactImages: l.length > 0 || !!a
  }), u = c !== "(image)" && c.trim().length > 0;
  return /* @__PURE__ */ d("div", { className: "pa-chat-tool-value", children: [
    a,
    /* @__PURE__ */ s(Lt, { images: l }),
    /* @__PURE__ */ s(fr, { refs: o }),
    u ? /* @__PURE__ */ s(Rs, { text: c }) : null
  ] });
}
function Rs({ text: e }) {
  const [t, n] = z(!1), [r, i] = z(!1), a = P(null);
  return lt(() => {
    const o = a.current;
    if (!o) return;
    const c = t ? o.scrollHeight > 320 + 1 : o.scrollHeight > o.clientHeight + 1;
    i(c);
  }, [e, t]), /* @__PURE__ */ d("div", { className: "pa-chat-tool-json", children: [
    /* @__PURE__ */ s(
      "pre",
      {
        ref: a,
        className: t ? "pa-chat-tool-pane is-expanded" : "pa-chat-tool-pane",
        children: e
      }
    ),
    r ? /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        className: "pa-chat-tool-expand",
        "aria-expanded": t,
        onClick: (o) => {
          o.stopPropagation(), n((l) => !l);
        },
        children: t ? "Show less" : "Show more"
      }
    ) : null
  ] });
}
function As(e) {
  if (e == null) return "";
  if (typeof e != "object") return nt(String(e), 60);
  if (!Me(e)) return nt(Rt(e), 60);
  for (const t of ["command", "path", "name", "query", "url", "prompt", "message"]) {
    const n = e[t];
    if (typeof n == "string") return nt(`${t}: ${n}`, 60);
  }
  return nt(Rt(e), 60);
}
function Rt(e, t) {
  if (e === void 0) return "(none)";
  const n = t != null && t.redactImages ? At(Ge(e)) : Ge(e);
  if (typeof n == "string")
    return n === "[image]" ? "(image)" : n;
  try {
    return JSON.stringify(n, null, 2);
  } catch {
    return String(e);
  }
}
function At(e, t = 0) {
  if (t > 10) return e;
  if (typeof e == "string")
    return se(e) ? "[image]" : e.length > 200 && Pe(e) ? "[image data]" : e;
  if (Array.isArray(e))
    return e.map((r) => At(r, t + 1));
  if (!Me(e)) return e;
  const n = {};
  for (const [r, i] of Object.entries(e)) {
    const a = r.toLowerCase();
    if (typeof i == "string" && (a === "data" || a === "base64" || a === "b64" || a === "image_base64" || a === "image" || a.endsWith("_base64")) && (i.length > 80 || se(i))) {
      n[r] = se(i) ? "[image]" : "[image data]";
      continue;
    }
    if (a === "image_url" && typeof i == "string" && se(i)) {
      n[r] = "[image]";
      continue;
    }
    n[r] = At(i, t + 1);
  }
  return n;
}
function Pe(e) {
  if (e.length < 200) return !1;
  const t = e.slice(0, 400).replace(/\s+/g, "");
  return /^[A-Za-z0-9+/]+=*$/.test(t);
}
function Ge(e, t = 0) {
  if (t > 8) return e;
  if (typeof e == "string") {
    const n = Ut(e);
    return n === void 0 ? e : Ge(n, t + 1);
  }
  if (Array.isArray(e))
    return e.map((n) => Ge(n, t + 1));
  if (Me(e)) {
    const n = {};
    for (const [r, i] of Object.entries(e))
      n[r] = Ge(i, t + 1);
    return n;
  }
  return e;
}
function Ut(e) {
  const t = e.trim();
  if (t.length < 2) return;
  if (t.startsWith('"') && t.endsWith('"'))
    try {
      const i = JSON.parse(t);
      if (typeof i == "string") return Ut(i);
    } catch {
    }
  const n = t.startsWith("{") && t.endsWith("}"), r = t.startsWith("[") && t.endsWith("]");
  if (!(!n && !r))
    try {
      return JSON.parse(t);
    } catch {
      return;
    }
}
function Me(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
function Se(e, t = [], n = 0) {
  if (n > 12 || e == null) return t;
  if (typeof e == "string") {
    const l = Ut(e);
    return l !== void 0 ? Se(l, t, n + 1) : (se(e) || we(e) ? xe(t, e) : e.length > 200 && Pe(e) && xe(t, `data:image/png;base64,${De(e)}`), t);
  }
  if (Array.isArray(e)) {
    for (const l of e) Se(l, t, n + 1);
    return t;
  }
  if (!Me(e)) return t;
  const r = typeof e.type == "string" ? e.type.toLowerCase() : "", i = r === "image" || r === "image_url" || r === "input_image" || r === "media" || r === "file" || r === "blob";
  if (i) {
    const l = zs(e);
    l && xe(t, l);
  }
  if (Me(e.source)) {
    const l = Rr(e.source);
    l && xe(t, l);
  }
  const a = ge(e, [
    "mimeType",
    "media_type",
    "mediaType",
    "mime",
    "contentType",
    "content_type"
  ]), o = ge(e, [
    "data",
    "base64",
    "image_base64",
    "b64",
    "imageData",
    "image_data",
    "bytes"
  ]);
  if (o && (a != null && a.startsWith("image/") || i || Pe(o)))
    if (se(o))
      xe(t, o);
    else if (we(o))
      xe(t, o);
    else {
      const l = a != null && a.startsWith("image/") ? a : "image/png";
      xe(t, `data:${l};base64,${De(o)}`);
    }
  for (const l of [
    "content",
    "parts",
    "messages",
    "message",
    "result",
    "output",
    "outputs",
    "image",
    "images",
    "image_url",
    "thumbnail",
    "preview",
    "file",
    "files",
    "resource",
    "resources",
    "artifacts"
  ])
    l in e && Se(e[l], t, n + 1);
  if (n < 6)
    for (const [l, c] of Object.entries(e))
      (typeof c == "string" && /image|thumb|preview|photo|frame|snapshot/i.test(l) || typeof c == "object" && c !== null) && Se(c, t, n + 1);
  return t;
}
function xe(e, t) {
  e.includes(t) || e.push(t);
}
function zs(e) {
  if ("image_url" in e) {
    const r = e.image_url;
    if (typeof r == "string") {
      if (we(r) || se(r)) return r;
      if (Pe(r)) return `data:image/png;base64,${De(r)}`;
    }
    if (Me(r)) {
      const i = ge(r, ["url", "image_url"]);
      if (i) {
        if (we(i) || se(i)) return i;
        if (Pe(i)) return `data:image/png;base64,${De(i)}`;
      }
    }
  }
  if ("url" in e && typeof e.url == "string" && (we(e.url) || se(e.url)))
    return e.url;
  if ("source" in e && Me(e.source))
    return Rr(e.source);
  const t = ge(e, [
    "mimeType",
    "media_type",
    "mediaType",
    "mime",
    "contentType"
  ]), n = ge(e, ["data", "base64", "image_base64", "b64", "imageData"]);
  if (n) {
    if (se(n) || we(n)) return n;
    const r = t != null && t.startsWith("image/") ? t : "image/png";
    if (t != null && t.startsWith("image/") || Pe(n) || n.length > 80)
      return `data:${r};base64,${De(n)}`;
  }
  return null;
}
function Rr(e) {
  const t = typeof e.type == "string" ? e.type.toLowerCase() : "";
  if (t === "url" || t === "image_url") {
    const r = ge(e, ["url", "image_url"]);
    if (r && (we(r) || se(r))) return r;
  }
  if (t === "base64" || t === "base64_image" || t === "image" || t === "") {
    const r = ge(e, ["media_type", "mediaType", "mimeType", "mime", "contentType"]) ?? "image/png", i = ge(e, ["data", "base64", "image_base64", "b64"]);
    if (i)
      return se(i) ? i : `data:${r.startsWith("image/") ? r : "image/png"};base64,${De(i)}`;
  }
  const n = ge(e, ["url"]);
  return n && (we(n) || se(n)) ? n : null;
}
function ge(e, t) {
  for (const n of t) {
    const r = e[n];
    if (typeof r == "string" && r.length > 0) return r;
  }
  return null;
}
function se(e) {
  return /^data:image\/[a-z0-9.+-]+;base64,/i.test(e.trim());
}
function we(e) {
  return /^https?:\/\//i.test(e) ? !!(/\.(png|jpe?g|gif|webp|bmp|svg)(\?|#|$)/i.test(e) || /[?&](format|fm)=(png|jpe?g|gif|webp)\b/i.test(e) || /\/(image|images|img|media|photo|thumbnail|thumb|snapshot|frame)\b/i.test(e)) : !1;
}
function De(e) {
  const t = e.trim(), n = /^data:image\/[a-z0-9.+-]+;base64,(.+)$/i.exec(t);
  return (n == null ? void 0 : n[1]) ?? t.replace(/\s+/g, "");
}
function nt(e, t) {
  return e.length > t ? `${e.slice(0, t - 1)}…` : e;
}
const Ps = Ye(
  function({ item: t }) {
    var a;
    const n = [];
    for (const o of t.blocks)
      o.type === "tools" || n.length === 0 ? n.push([o]) : (a = n[n.length - 1]) == null || a.push(o);
    const r = t.blocks.length;
    let i = 0;
    return /* @__PURE__ */ d("div", { className: `pa-chat-turn${t.streaming ? " is-streaming" : ""}`, children: [
      /* @__PURE__ */ s("div", { className: "pa-chat-turn-rail", children: /* @__PURE__ */ s("span", { className: "pa-chat-turn-dot" }) }),
      /* @__PURE__ */ d("div", { className: "pa-chat-turn-blocks", children: [
        t.at && /* @__PURE__ */ s("div", { className: "pa-chat-turn-meta", children: /* @__PURE__ */ s("span", { className: "pa-chat-turn-time", children: nr(t.at) }) }),
        n.map((o, l) => /* @__PURE__ */ d("div", { className: "pa-chat-turn-step", children: [
          l > 0 && /* @__PURE__ */ s("div", { className: "pa-chat-turn-step-sep", "aria-hidden": "true" }),
          o.map((c) => {
            const u = i++;
            return /* @__PURE__ */ s(
              Es,
              {
                block: c,
                live: t.streaming && u === r - 1
              },
              u
            );
          })
        ] }, l))
      ] })
    ] });
  },
  (e, t) => Ze(e.item, t.item)
), Ds = {
  img({ src: e, alt: t }) {
    return typeof e != "string" || !e ? null : /* @__PURE__ */ s(Pi, { src: e, alt: t, className: "md-prose-img" });
  },
  // A markdown image can be wrapped in a link — `[![alt](img)](href)`. Since our
  // `img` renders a <button> (the lightbox trigger), a naive render nests a
  // <button> inside the <a>: invalid HTML (interactive content inside
  // interactive content) and two competing click targets. When an anchor wraps
  // an image, drop the anchor and let the image open the in-app lightbox;
  // otherwise render a normal link unchanged.
  a({
    href: e,
    title: t,
    children: n,
    node: r
  }) {
    var a;
    return ((a = r == null ? void 0 : r.children) == null ? void 0 : a.some((o) => o.type === "element" && o.tagName === "img")) ? /* @__PURE__ */ s(re, { children: n }) : /* @__PURE__ */ s("a", { href: e, title: t, children: n });
  }
};
function Es({ block: e, live: t }) {
  switch (e.type) {
    case "text":
      return /* @__PURE__ */ d("div", { className: "pa-chat-text", children: [
        /* @__PURE__ */ s("div", { className: "md-prose", children: /* @__PURE__ */ s(Pn, { remarkPlugins: [Dn], components: Ds, children: e.text }) }),
        t && /* @__PURE__ */ s("span", { className: "pa-chat-caret" })
      ] });
    case "reasoning":
      return /* @__PURE__ */ s(js, { text: e.text, live: t });
    case "tools":
      return /* @__PURE__ */ s(Ts, { calls: e.calls, live: t });
    default:
      return null;
  }
}
function js({ text: e, live: t }) {
  const [n, r] = z(!1);
  return /* @__PURE__ */ d("div", { children: [
    /* @__PURE__ */ d(
      "button",
      {
        type: "button",
        className: `pa-chat-reasoning-toggle${t ? " is-shimmer" : ""}`,
        onClick: () => r((i) => !i),
        children: [
          /* @__PURE__ */ s("span", { children: n ? "▾" : "▸" }),
          /* @__PURE__ */ s("span", { children: t ? "Thinking…" : "Thought process" })
        ]
      }
    ),
    n && /* @__PURE__ */ s("div", { className: "pa-chat-reasoning-body", children: e })
  ] });
}
const Ls = Ye(
  function({ item: t }) {
    const [n, r] = z(!1), i = Math.max(0, t.msgCount - t.summarizedCount);
    return /* @__PURE__ */ d("div", { className: "pa-chat-compaction", children: [
      /* @__PURE__ */ d(
        "button",
        {
          type: "button",
          className: "pa-chat-compaction__bar",
          "aria-expanded": n,
          onClick: () => r((a) => !a),
          title: t.forced ? "An operator compacted this thread here — click to see the summary the agent carries" : "The thread passed its message threshold and compacted here — click to see the summary the agent carries",
          children: [
            /* @__PURE__ */ d("span", { className: "pa-chat-compaction__label", children: [
              "Context compacted",
              t.forced ? /* @__PURE__ */ s("span", { className: "pa-chat-compaction__forced", children: " · manual" }) : null
            ] }),
            /* @__PURE__ */ d("span", { className: "pa-chat-compaction__meta", children: [
              "v",
              t.version,
              " · ",
              t.summarizedCount,
              " of ",
              t.msgCount,
              " messages summarized",
              i > 0 ? `, ${i} kept verbatim` : ""
            ] }),
            /* @__PURE__ */ s("span", { className: "pa-chat-compaction__chevron", "aria-hidden": "true", children: n ? "▴" : "▾" })
          ]
        }
      ),
      n && /* @__PURE__ */ d("div", { className: "pa-chat-compaction__body", children: [
        /* @__PURE__ */ s("p", { className: "pa-chat-compaction__note", children: "Everything above this point is what the agent now remembers as the summary below — the messages are still here, but its working context holds this instead." }),
        /* @__PURE__ */ s("pre", { className: "pa-chat-compaction__summary", children: t.summary })
      ] })
    ] });
  },
  (e, t) => Ze(e.item, t.item)
), Os = /\b(out of credits?|insufficient[_ ]?(quota|funds|balance|credits?)|credit(?:s)? (?:exhausted|depleted|limit)|billing|payment[_ ]required|spend(?:ing)?[_ -]?limit|prepaid|top[- ]?up|add credits?|personal-team-blocked|need a grok subscription|run out of (?:available )?credits?|quota[_ ]?exceeded)\b/i, Fs = /\b(invalid[_ ]?(api[_ ]?)?key|incorrect[_ ]api[_ ]key|unauthorized|authentication[_ ]?(failed|error)|api key (?:is )?invalid|invalid_api_key)\b/i, Ws = /\b(rate[_ ]?limit(?:ed)?|too many requests|retry[- ]after)\b/i, Bs = /\b(xai|x\.ai|grok)\b/i;
function Ks(e, t) {
  const n = t ?? Us(e), r = Bs.test(e);
  switch (n) {
    case "billing":
      return {
        kind: "billing",
        title: r ? "Grok / xAI credits exhausted" : "Provider credits exhausted",
        remediation: r ? "Add credits or raise the spend limit at console.x.ai, then retry. Updating the API key alone will not fix this." : "Top up the provider account or raise the spend/quota limit, then retry.",
        tone: "billing"
      };
    case "auth":
      return {
        kind: "auth",
        title: "API key rejected",
        remediation: "Update the model config with a valid API key and re-test.",
        tone: "auth"
      };
    case "rate_limit":
      return {
        kind: "rate_limit",
        title: "Provider rate limit",
        remediation: "The provider throttled this account. Wait a moment and retry.",
        tone: "rate"
      };
    case "provider_unavailable":
      return {
        kind: "provider_unavailable",
        title: "Provider temporarily unavailable",
        remediation: "Retry shortly; if it persists, check the provider status page.",
        tone: "danger"
      };
    case "bad_request":
      return {
        kind: "bad_request",
        title: "Provider rejected the request",
        remediation: "Check prompts, tools, and multimodal payloads for this model.",
        tone: "danger"
      };
    case "provider_error":
    default:
      return {
        kind: "provider_error",
        title: "Provider error",
        remediation: "See details below. Verify the model config if this keeps happening.",
        tone: "danger"
      };
  }
}
function Us(e) {
  return Os.test(e) || /\b402\b/.test(e) ? "billing" : Fs.test(e) || /\b401\b/.test(e) ? "auth" : Ws.test(e) || /\b429\b/.test(e) ? "rate_limit" : "provider_error";
}
const Hs = Ye(
  function({ item: t }) {
    const n = t.passed, r = n === !0 ? "badge badge--success" : n === !1 ? "badge badge--warning" : "badge badge--neutral", i = n === !0 ? "passed" : n === !1 ? "not completed" : "pending";
    return /* @__PURE__ */ d("div", { className: `pa-chat-goal${n === !0 ? " is-passed" : ""}`, children: [
      /* @__PURE__ */ d("div", { style: { display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }, children: [
        /* @__PURE__ */ s(
          "span",
          {
            className: "badge badge--outline",
            style: { fontSize: 9, fontFamily: "var(--font-mono)", textTransform: "uppercase" },
            children: t.status ?? "evaluating"
          }
        ),
        /* @__PURE__ */ s("span", { className: r, style: { fontSize: 9 }, children: i }),
        (typeof t.iteration == "number" || typeof t.maxRuns == "number") && /* @__PURE__ */ d(
          "span",
          {
            className: "t-xs t-muted",
            style: { marginLeft: "auto", fontFamily: "var(--font-mono)" },
            children: [
              t.iteration ?? "?",
              "/",
              t.maxRuns ?? "?"
            ]
          }
        )
      ] }),
      t.objective && /* @__PURE__ */ s(
        "div",
        {
          style: {
            fontSize: "var(--fs-xs)",
            lineHeight: 1.6,
            color: "var(--text-primary)",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word"
          },
          children: t.objective
        }
      ),
      t.reason && /* @__PURE__ */ s(
        "div",
        {
          style: {
            fontSize: 12,
            lineHeight: 1.5,
            color: "var(--text-secondary)",
            marginTop: 6,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word"
          },
          children: t.reason
        }
      )
    ] });
  },
  (e, t) => Ze(e.item, t.item)
), Gs = Ye(
  function({ item: t }) {
    const n = Ks(
      t.message,
      t.kindCode ?? null
    ), r = n.tone === "billing" ? "is-billing" : n.tone === "auth" ? "is-auth" : n.tone === "rate" ? "is-rate" : "";
    return /* @__PURE__ */ d("div", { className: `pa-chat-error ${r}`.trim(), children: [
      /* @__PURE__ */ s("div", { className: "pa-chat-error__title", children: n.title }),
      /* @__PURE__ */ s("div", { className: "pa-chat-error__remediation", children: n.remediation }),
      /* @__PURE__ */ d("details", { className: "pa-chat-error__details", children: [
        /* @__PURE__ */ s("summary", { children: "Technical details" }),
        /* @__PURE__ */ s("pre", { children: t.message })
      ] })
    ] });
  },
  (e, t) => Ze(e.item, t.item)
);
function qs(e, t) {
  const [n, r] = e.split(/:(.+)/);
  switch (n) {
    case "user":
      return r ?? "";
    case "slack":
      return `${r ?? ""} (Slack)`;
    case "system":
      return `system · ${r ?? ""}`;
    case "timer":
      return r === "heartbeat" ? "♥ heartbeat" : "⏰ timer";
    case "agent":
      return `agent: ${Vs(r ?? "", t)}`;
    case "webhook":
      return `webhook · ${r ?? ""}`;
    default:
      return e;
  }
}
function Vs(e, t) {
  const n = t == null ? void 0 : t[e];
  return n ? `${n.name ?? e.slice(0, 8)} (${n.agentName})` : e.slice(0, 8);
}
function _l(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    if (n != null && n.startsWith("agent:")) {
      const r = n.slice(6);
      r && t.add(r);
    }
  return [...t].sort();
}
const Js = {
  interrupt: { label: "⚡ STEER", className: "pa-chat-chip--steer" },
  now: null,
  "next-turn": { label: "NEXT TURN", className: "" },
  "when-idle": { label: "WHEN IDLE", className: "" },
  inbox: { label: "INBOX", className: "pa-chat-chip--muted" }
}, Xs = Ye(
  function({
    item: t,
    onRetry: n,
    agentNames: r,
    minimalChrome: i
  }) {
    const a = t.source.startsWith("slack:"), o = t.source.startsWith("user:") || a, l = !i && t.delivery ? Js[t.delivery] : null, c = t.state === "failed";
    return /* @__PURE__ */ d("div", { className: `pa-chat-user${o ? "" : " pa-chat-user--other"}`, children: [
      t.interrupted && /* @__PURE__ */ s("div", { className: "pa-chat-interrupt-divider", children: "interrupted previous run" }),
      /* @__PURE__ */ s(
        "div",
        {
          className: `pa-chat-user-bubble${c ? " is-failed" : ""}`,
          onClick: c && n ? () => n(t.key) : void 0,
          title: c ? "Tap to retry" : void 0,
          children: t.text
        }
      ),
      /* @__PURE__ */ d("div", { className: "pa-chat-user-meta", children: [
        (!o || a) && t.source && /* @__PURE__ */ s("span", { className: "pa-chat-chip", title: t.source, children: qs(t.source, r) }),
        l && /* @__PURE__ */ s("span", { className: `pa-chat-chip ${l.className}`, children: l.label }),
        t.at && /* @__PURE__ */ s("span", { children: nr(t.at) }),
        t.state === "pending" && /* @__PURE__ */ d("span", { className: "pa-chat-user-sending pa-chat-pending-text", children: [
          /* @__PURE__ */ s(Qn, { tone: "user" }),
          " Sending…"
        ] }),
        c && /* @__PURE__ */ s(
          "span",
          {
            className: "pa-chat-chip pa-chat-chip--failed",
            onClick: n ? () => n(t.key) : void 0,
            children: "failed — tap to retry"
          }
        )
      ] })
    ] });
  },
  (e, t) => e.onRetry === t.onRetry && e.agentNames === t.agentNames && e.minimalChrome === t.minimalChrome && Ze(e.item, t.item)
), Ht = 6e4, zt = 60 * Ht, wn = 24 * zt, Ys = 10 * Ht;
function Qs(e, t) {
  if (!e || !t) return null;
  const n = Date.parse(e), r = Date.parse(t);
  if (Number.isNaN(n) || Number.isNaN(r)) return null;
  const i = r - n;
  return i < Ys ? null : i < zt ? `${Math.round(i / Ht)}m` : i < wn ? `${Math.round(i / zt)}h` : `${Math.round(i / wn)}d`;
}
const Zs = 96, kn = [
  "Thinking…",
  "Working…",
  "Computing…",
  "Reasoning…",
  "Planning…",
  "Analyzing…",
  "Routing…",
  "Invoking…",
  "Calibrating…",
  "Processing…",
  "Perceiving…",
  "Pathfinding…"
], _n = 80, eo = 6e3, to = 6, no = 1e4;
function rt(e) {
  return e.scrollHeight - e.scrollTop - e.clientHeight <= Zs;
}
function ro(e, t) {
  return e || t;
}
function io(e) {
  const t = e.querySelectorAll("img");
  for (let n = 0; n < t.length; n += 1) {
    const r = t[n];
    if (r && !r.complete) return !0;
  }
  return !1;
}
function ao({
  items: e,
  status: t,
  activity: n,
  connection: r,
  loading: i,
  leadingSlot: a,
  onRetry: o,
  renderIncident: l,
  agentNames: c,
  minimalChrome: u
}) {
  var Ne;
  const h = Yr() ?? !1, f = P(null), m = P(null), y = P(null), g = P(!0), [k, x] = z(!0), [b, M] = z(0), $ = P(0), [N, E] = z(0), j = P(0), S = P(!1), _ = P(!0), I = P(null), p = P(0), T = P(!1), R = P(null), v = P(null), w = v.current ?? new Set(e.map((C) => C.key));
  v.current === null && (v.current = w);
  const O = () => {
    const C = f.current;
    if (!C) return;
    const A = Math.max(C.scrollHeight, C.offsetHeight, 0);
    C.scrollTop = A, requestAnimationFrame(() => {
      const U = f.current;
      U && (_.current || g.current) && (U.scrollTop = Math.max(U.scrollHeight, U.offsetHeight, 0));
    });
  }, B = () => {
    _.current && (_.current = !1, I.current = null, p.current = 0, O(), g.current = !0, x(!0));
  }, W = () => {
    _.current = !1, I.current = null, p.current = 0, T.current = !0, g.current && (g.current = !1, x(!1));
  }, G = () => {
    const C = f.current;
    if (!C || _.current) return;
    const A = rt(C);
    if (T.current)
      if (!A) T.current = !1;
      else return;
    A !== g.current && (g.current = A, x(A)), A && M(0);
  }, D = (C) => {
    if (C.deltaY < 0) {
      W();
      return;
    }
    if (C.deltaY > 0 && T.current) {
      const A = f.current;
      A && rt(A) && (T.current = !1);
    }
  }, F = e.some((C) => C.kind === "turn" && C.streaming), J = t === "WORKING" && !F;
  J && !S.current && (j.current = (j.current + 1) % kn.length), S.current = J;
  const ie = kn[j.current] ?? "Working…", ee = Math.max(0, e.length - _n - N), me = Q(() => e.slice(ee), [e, ee]), le = ee, ye = e.length > 0 ? ((Ne = e[e.length - 1]) == null ? void 0 : Ne.key) ?? null : null;
  let ce;
  for (let C = Math.max(0, ee - 1); C < ee; C += 1) {
    const A = e[C];
    A != null && A.at && (ce = A.at);
  }
  const ae = me.map((C) => {
    const A = C.at ? Qs(ce, C.at) : null;
    return C.at && (ce = C.at), A;
  });
  lt(() => {
    const C = f.current;
    if (!C) return;
    const A = R.current;
    if (A) {
      R.current = null;
      const ue = C.scrollHeight - A.prevScrollHeight;
      ue > 0 && (C.scrollTop = A.prevScrollTop + ue), $.current = e.length;
      return;
    }
    const U = e[e.length - 1], Z = (U == null ? void 0 : U.kind) === "user" && U.state === "pending", te = e.length > $.current;
    _.current && e.length > 0 && I.current === null && (I.current = performance.now(), p.current = 0), ro(_.current, Z) && (g.current = !0, x(!0), Z && M(0)), g.current || _.current ? O() : te && M((ue) => ue + (e.length - $.current)), $.current = e.length;
  }, [e, N, ye, J]), lt(() => {
    const C = f.current;
    if (!C) return;
    let A = 0, U = !1;
    const Z = performance.now();
    let te = -1, ue = -1, Fe = 0;
    const pe = () => {
      U || A || (A = requestAnimationFrame(() => {
        A = 0, gt();
      }));
    }, gt = () => {
      if (U) return;
      const de = f.current;
      if (!de) return;
      const L = de.scrollHeight, H = e.length, Y = io(de), X = L === te, q = H === ue;
      if (te = L, ue = H, _.current) {
        if (H === 0) {
          pe();
          return;
        }
        O(), Fe = rt(de) && X && q && !Y && L > 0 ? Fe + 1 : 0;
        const Vt = performance.now();
        I.current === null && (I.current = Vt);
        const Br = I.current, Kr = Vt - Br >= eo;
        if (Fe >= to || Kr) {
          de.scrollTop = de.scrollHeight, B(), (!X || !q || Y) && pe();
          return;
        }
        pe();
        return;
      }
      if (g.current) {
        const fe = !X || !q || Y;
        (!rt(de) || fe) && O();
        const qt = performance.now() - Z >= no;
        fe && !qt && pe();
      }
    }, yt = () => {
      U || (_.current || g.current) && (O(), pe());
    }, Te = () => {
      U || (_.current || g.current) && (O(), pe());
    };
    (_.current || g.current) && O(), pe();
    const ne = typeof ResizeObserver < "u" ? new ResizeObserver(yt) : null;
    return ne == null || ne.observe(C), m.current && (ne == null || ne.observe(m.current)), y.current && (ne == null || ne.observe(y.current)), C.addEventListener("load", Te, !0), C.addEventListener("error", Te, !0), () => {
      U = !0, A && cancelAnimationFrame(A), ne == null || ne.disconnect(), C.removeEventListener("load", Te, !0), C.removeEventListener("error", Te, !0);
    };
  }, [e.length, N, J]);
  const be = () => {
    T.current = !1, g.current = !0, x(!0), M(0), O(), _.current && B();
  }, Oe = () => {
    const C = f.current;
    C && (R.current = {
      prevScrollHeight: C.scrollHeight,
      prevScrollTop: C.scrollTop
    }), g.current = !1, x(!1), E((A) => A + _n);
  };
  return /* @__PURE__ */ d("div", { className: "pa-chat-scroller-wrap", children: [
    r === "reconnecting" && /* @__PURE__ */ d("div", { className: "pa-chat-reconnect", children: [
      /* @__PURE__ */ s(dt, { inline: !0 }),
      " Reconnecting to live stream…"
    ] }),
    /* @__PURE__ */ s(
      "div",
      {
        className: "pa-chat-scroller",
        ref: f,
        onScroll: G,
        onWheel: D,
        children: e.length === 0 && !J && !a ? (
          // While the initial replay is still in flight, show a spinner rather
          // than the "empty thread" copy — otherwise opening a thread with
          // history flashes "Send a message to get started" for the replay
          // window before the transcript lands. (A fully blank slot here read
          // as the transcript vanishing on slow cold-start connects.)
          i ? /* @__PURE__ */ s("div", { className: "pa-chat-empty", "aria-busy": "true", children: /* @__PURE__ */ s(dt, { inline: !0 }) }) : /* @__PURE__ */ s("div", { className: "pa-chat-empty", children: "Send a message to get started." })
        ) : /* @__PURE__ */ d("div", { className: "pa-chat-content", ref: m, children: [
          a,
          le > 0 && /* @__PURE__ */ d("button", { type: "button", className: "pa-chat-load-older", onClick: Oe, children: [
            "Show earlier messages (",
            le,
            " hidden)"
          ] }),
          me.map((C, A) => {
            const U = !w.has(C.key);
            return U && w.add(C.key), /* @__PURE__ */ s("div", { className: "pa-chat-row", children: U && !h ? /* @__PURE__ */ d(
              Xt.div,
              {
                initial: { opacity: 0 },
                animate: { opacity: 1 },
                transition: { duration: 0.1 },
                children: [
                  ae[A] && /* @__PURE__ */ d("div", { className: "pa-chat-idle-gap", children: [
                    "idle ",
                    ae[A]
                  ] }),
                  /* @__PURE__ */ s(
                    Nn,
                    {
                      item: C,
                      onRetry: o,
                      renderIncident: l,
                      agentNames: c,
                      minimalChrome: u
                    }
                  )
                ]
              }
            ) : /* @__PURE__ */ d(re, { children: [
              ae[A] && /* @__PURE__ */ d("div", { className: "pa-chat-idle-gap", children: [
                "idle ",
                ae[A]
              ] }),
              /* @__PURE__ */ s(
                Nn,
                {
                  item: C,
                  onRetry: o,
                  renderIncident: l,
                  agentNames: c,
                  minimalChrome: u
                }
              )
            ] }) }, C.key);
          }),
          J && /* @__PURE__ */ d("div", { className: "pa-chat-working pa-chat-pending-text", children: [
            /* @__PURE__ */ s(Qn, { tone: "agent" }),
            (n == null ? void 0 : n.text) ?? ie
          ] }),
          /* @__PURE__ */ s("div", { ref: y, className: "pa-chat-bottom-anchor", "aria-hidden": "true" })
        ] })
      }
    ),
    /* @__PURE__ */ s(Qr, { children: !k && /* @__PURE__ */ d(
      Xt.button,
      {
        type: "button",
        className: "pa-chat-fab",
        onClick: be,
        initial: h ? !1 : { opacity: 0, y: 8 },
        animate: { opacity: 1, y: 0 },
        exit: h ? void 0 : { opacity: 0, y: 8 },
        transition: { duration: 0.15 },
        children: [
          "↓",
          b > 0 ? ` ${b} new` : ""
        ]
      }
    ) })
  ] });
}
function Nn({
  item: e,
  onRetry: t,
  renderIncident: n,
  agentNames: r,
  minimalChrome: i
}) {
  switch (e.kind) {
    case "user":
      return /* @__PURE__ */ s(
        Xs,
        {
          item: e,
          onRetry: t,
          agentNames: r,
          minimalChrome: i
        }
      );
    case "turn":
      return /* @__PURE__ */ s(Ps, { item: e });
    case "goal":
      return /* @__PURE__ */ s(Hs, { item: e });
    case "error":
      return /* @__PURE__ */ s(Gs, { item: e });
    case "incident":
      return n ? /* @__PURE__ */ s(re, { children: n(e.runId) }) : null;
    case "compaction":
      return /* @__PURE__ */ s(Ls, { item: e });
    default:
      return null;
  }
}
const Re = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center"
};
function so({
  onSend: e,
  onInterrupt: t,
  disabled: n,
  busy: r,
  busyReason: i,
  autosendOnDictation: a,
  pushToDictateKey: o,
  hideDictation: l,
  autoReadAloud: c,
  onAutoReadAloudChange: u,
  thinking: h,
  onThinkingChange: f,
  audioPlaying: m,
  onStopAudio: y,
  onDictationStart: g
}) {
  const [k, x] = z(""), [b, M] = z(!1), $ = P(null), N = P(!1), E = P(!1), j = P(g);
  K(() => {
    j.current = g;
  }, [g]);
  const S = mi(
    (w) => {
      var O;
      x((B) => B ? `${B} ${w}` : w), a && (N.current = !0), (O = $.current) == null || O.focus();
    },
    () => {
      var w;
      return (w = j.current) == null ? void 0 : w.call(j);
    }
  );
  K(() => {
    const w = $.current;
    if (!w) return;
    const O = () => {
      w.style.height = "auto", w.style.height = `${Math.min(w.scrollHeight, Math.round(window.innerHeight * 0.4))}px`;
    };
    return O(), window.addEventListener("resize", O), () => window.removeEventListener("resize", O);
  }, [k]), K(() => {
    var w;
    !n && !r && ((w = $.current) == null || w.focus());
  }, []);
  const _ = P(n);
  K(() => {
    var w;
    _.current && !n && !r && ((w = $.current) == null || w.focus()), _.current = n;
  }, [n, r]);
  function I() {
    const w = k.trim();
    if (!(!w || n)) {
      if (r) {
        M(!0);
        return;
      }
      e(w), x("");
    }
  }
  K(() => {
    if (!b || r || n) return;
    M(!1);
    const w = k.trim();
    w && (e(w), x(""));
  }, [b, r, n, k, e]), K(() => {
    if (!N.current || S.state !== "idle") return;
    const w = k.trim();
    if (N.current = !1, !(!w || n)) {
      if (r) {
        M(!0);
        return;
      }
      e(w), x("");
    }
  }, [k, S.state, n, r, e]), K(() => {
    if (!o) return;
    const w = o.toLowerCase();
    function O(W) {
      W.repeat || (W.ctrlKey || W.metaKey) && W.key.toLowerCase() === w && (n || r || (W.preventDefault(), S.state === "idle" && (E.current = !0, S.toggle())));
    }
    function B(W) {
      const G = W.key.toLowerCase();
      G !== w && G !== "control" && G !== "meta" || E.current && (S.state === "recording" ? (E.current = !1, S.toggle()) : E.current = !1);
    }
    return window.addEventListener("keydown", O), window.addEventListener("keyup", B), () => {
      window.removeEventListener("keydown", O), window.removeEventListener("keyup", B);
    };
  }, [o, S, n, r]);
  let p = "", T = "";
  b && r ? (p = "Queued — sends when the agent finishes (Esc to cancel)", T = "is-queued") : r && i ? p = i : S.state === "recording" ? (p = E.current ? "Release to send" : "Recording — click to stop", T = "is-recording") : S.state === "transcribing" ? (p = "Transcribing", T = "is-transcribing") : S.error && (p = S.error, T = "is-error");
  const R = o ? `Dictate (or hold Ctrl+${o.toUpperCase()})` : "Dictate";
  return /* @__PURE__ */ d("div", { className: "refinement-composer", children: [
    /* @__PURE__ */ d("div", { className: `refinement-input-well${n ? " is-locked" : ""}`, children: [
      /* @__PURE__ */ s(
        "textarea",
        {
          ref: $,
          className: "refinement-composer__textarea",
          placeholder: "Write a message...",
          value: k,
          onChange: (w) => x(w.target.value),
          onKeyDown: (w) => {
            w.key === "Enter" && !w.shiftKey ? (w.preventDefault(), I()) : w.key === "Escape" && b && M(!1);
          },
          disabled: n,
          rows: 1
        }
      ),
      /* @__PURE__ */ d("div", { className: "refinement-well-toolbar", children: [
        f ? /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            className: `refinement-mode__icon ${h ? "is-thinking" : "is-fast"}`,
            "aria-label": h ? "Switch to Fast mode" : "Switch to Thinking mode",
            "aria-pressed": !!h,
            onClick: () => f(!h),
            title: h ? "Thinking mode — click for Fast" : "Fast mode — click for Thinking",
            children: /* @__PURE__ */ s("span", { style: Re, "aria-hidden": "true", children: h ? /* @__PURE__ */ s(oo, {}) : /* @__PURE__ */ s(lo, {}) })
          }
        ) : /* @__PURE__ */ s("span", {}),
        /* @__PURE__ */ d("div", { className: "refinement-well-actions", children: [
          l ? null : /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              className: `refinement-well-btn refinement-mic is-${S.state}`,
              "aria-label": S.state === "recording" ? "Stop recording" : "Start dictation",
              onClick: () => S.toggle(),
              disabled: n || S.state === "transcribing",
              title: S.state === "recording" ? "Stop recording" : R,
              children: /* @__PURE__ */ s("span", { style: Re, "aria-hidden": "true", children: S.state === "recording" ? /* @__PURE__ */ s(Sn, {}) : /* @__PURE__ */ s(co, {}) })
            }
          ),
          u ? m && y ? /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              className: "refinement-well-btn refinement-auto-read is-stop",
              "aria-label": "Stop reading aloud",
              onClick: y,
              title: "Stop reading aloud",
              children: /* @__PURE__ */ s("span", { style: Re, "aria-hidden": "true", children: /* @__PURE__ */ s(mo, {}) })
            }
          ) : /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              className: `refinement-well-btn refinement-auto-read${c ? " is-on" : ""}`,
              "aria-label": c ? "Disable auto read-aloud" : "Enable auto read-aloud",
              "aria-pressed": !!c,
              onClick: () => u(!c),
              title: c ? "Auto read-aloud is ON — assistant replies will be spoken" : "Auto read-aloud is OFF — click to have assistant replies spoken automatically",
              children: /* @__PURE__ */ s("span", { style: Re, "aria-hidden": "true", children: c ? /* @__PURE__ */ s(uo, {}) : /* @__PURE__ */ s(fo, {}) })
            }
          ) : null,
          r && t && !n ? /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              className: "refinement-send-btn refinement-stop-turn is-active",
              onClick: t,
              "aria-label": "Stop the agent's current turn",
              title: "Stop the agent's current turn",
              children: /* @__PURE__ */ s("span", { style: Re, "aria-hidden": "true", children: /* @__PURE__ */ s(Sn, {}) })
            }
          ) : /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              className: `refinement-send-btn${k.trim() ? " is-active" : ""}`,
              onClick: I,
              disabled: n || !k.trim(),
              title: r ? "Queue — sends when the agent finishes" : "Send (Enter — Shift+Enter for newline)",
              children: /* @__PURE__ */ s("span", { style: Re, "aria-hidden": "true", children: /* @__PURE__ */ s(ho, {}) })
            }
          )
        ] })
      ] })
    ] }),
    p ? /* @__PURE__ */ s("div", { className: `refinement-composer__hint ${T}`, children: p }) : null
  ] });
}
const xn = 16, _e = {
  width: xn,
  height: xn,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": !0
};
function oo() {
  return /* @__PURE__ */ d("svg", { ..._e, children: [
    /* @__PURE__ */ s("path", { d: "M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44A2.5 2.5 0 0 1 4.5 17.5 2.5 2.5 0 0 1 3 13a2.5 2.5 0 0 1 .23-4A2.5 2.5 0 0 1 5 4.72 2.5 2.5 0 0 1 9.5 2Z" }),
    /* @__PURE__ */ s("path", { d: "M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.54-2.44 2.5 2.5 0 0 0 1.5-4.5 2.5 2.5 0 0 0-.23-4A2.5 2.5 0 0 0 19 4.72 2.5 2.5 0 0 0 14.5 2Z" })
  ] });
}
function lo() {
  return /* @__PURE__ */ s("svg", { ..._e, fill: "currentColor", stroke: "none", children: /* @__PURE__ */ s("path", { d: "M13 2 4.09 12.69a.5.5 0 0 0 .38.81H11l-1 8.5 8.91-10.69a.5.5 0 0 0-.38-.81H13l1-8.5Z" }) });
}
function co() {
  return /* @__PURE__ */ d("svg", { ..._e, children: [
    /* @__PURE__ */ s("rect", { x: "9", y: "3", width: "6", height: "11", rx: "3" }),
    /* @__PURE__ */ s("path", { d: "M5 11a7 7 0 0 0 14 0" }),
    /* @__PURE__ */ s("line", { x1: "12", y1: "18", x2: "12", y2: "22" }),
    /* @__PURE__ */ s("line", { x1: "8", y1: "22", x2: "16", y2: "22" })
  ] });
}
function Sn() {
  return /* @__PURE__ */ s("svg", { ..._e, fill: "currentColor", stroke: "none", children: /* @__PURE__ */ s("rect", { x: "6", y: "6", width: "12", height: "12", rx: "1.5" }) });
}
function uo() {
  return /* @__PURE__ */ d("svg", { ..._e, children: [
    /* @__PURE__ */ s("path", { d: "M11 5 6 9H3v6h3l5 4z" }),
    /* @__PURE__ */ s("path", { d: "M19.07 4.93a10 10 0 0 1 0 14.14" }),
    /* @__PURE__ */ s("path", { d: "M15.54 8.46a5 5 0 0 1 0 7.07" })
  ] });
}
function fo() {
  return /* @__PURE__ */ d("svg", { ..._e, children: [
    /* @__PURE__ */ s("path", { d: "M11 5 6 9H3v6h3l5 4z" }),
    /* @__PURE__ */ s("line", { x1: "17", y1: "9", x2: "22", y2: "14" }),
    /* @__PURE__ */ s("line", { x1: "22", y1: "9", x2: "17", y2: "14" })
  ] });
}
function ho() {
  return /* @__PURE__ */ d("svg", { ..._e, strokeWidth: 2.5, children: [
    /* @__PURE__ */ s("path", { d: "M12 19V5" }),
    /* @__PURE__ */ s("path", { d: "M5 12l7-7 7 7" })
  ] });
}
function mo() {
  return /* @__PURE__ */ d("svg", { ..._e, children: [
    /* @__PURE__ */ s("circle", { cx: "12", cy: "12", r: "9" }),
    /* @__PURE__ */ s("rect", { x: "9", y: "9", width: "6", height: "6", rx: "1", fill: "currentColor", stroke: "none" })
  ] });
}
function po(e) {
  return [...e].sort((t, n) => {
    const r = t.startedAt ? new Date(t.startedAt).getTime() : 0, i = n.startedAt ? new Date(n.startedAt).getTime() : 0;
    if (r !== i) return r - i;
    const a = t.createdAt ? new Date(t.createdAt).getTime() : 0, o = n.createdAt ? new Date(n.createdAt).getTime() : 0;
    return a - o;
  });
}
const go = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "var(--sp-1)",
  padding: "var(--sp-2) 0"
}, Ar = {
  display: "inline-flex",
  alignItems: "center",
  gap: "var(--sp-2)",
  padding: "5px 10px",
  borderRadius: "var(--radius-pill)",
  border: "1px solid var(--border)",
  background: "var(--surface)",
  color: "var(--text-primary)",
  cursor: "pointer",
  fontSize: "var(--fs-xs)",
  fontFamily: "var(--font-mono, monospace)",
  lineHeight: 1.2
}, yo = {
  ...Ar,
  borderColor: "var(--horizon-glow)",
  background: "color-mix(in oklab, var(--horizon-glow) 10%, var(--surface))"
}, bo = {
  width: 8,
  height: 8,
  borderRadius: "50%",
  flex: "0 0 auto"
}, vo = {
  color: "var(--text-muted)",
  fontSize: "var(--fs-sm)",
  padding: "0 2px"
}, wo = {
  marginTop: "var(--sp-2)",
  border: "1px solid var(--border-subtle)",
  borderRadius: "var(--radius)",
  background: "var(--surface)",
  overflow: "hidden"
}, ko = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "var(--sp-2)",
  padding: "var(--sp-2) var(--sp-3)",
  borderBottom: "1px solid var(--border-subtle)",
  fontSize: "var(--fs-xs)",
  color: "var(--text-secondary)"
}, _o = {
  maxHeight: 340,
  overflowY: "auto"
};
function No({ executions: e }) {
  const t = po(e), [n, r] = z(null), i = t.find((a) => a.id === n) ?? null;
  return t.length === 0 ? /* @__PURE__ */ s("div", { style: { fontSize: "var(--fs-xs)", color: "var(--text-muted)", fontStyle: "italic" }, children: "No steps were recorded for this incident." }) : /* @__PURE__ */ d("div", { children: [
    /* @__PURE__ */ s("div", { style: go, role: "list", "aria-label": "Steps that ran", children: t.map((a, o) => {
      const l = a.id === n, c = a.nodeKey ?? `${a.nodeId.slice(0, 6)}…`;
      return /* @__PURE__ */ d(
        "span",
        {
          style: { display: "inline-flex", alignItems: "center" },
          role: "listitem",
          children: [
            o > 0 ? /* @__PURE__ */ s("span", { style: vo, "aria-hidden": "true", children: "→" }) : null,
            /* @__PURE__ */ d(
              "button",
              {
                type: "button",
                style: l ? yo : Ar,
                onClick: () => r(l ? null : a.id),
                "aria-expanded": l,
                title: `${c} — ${a.status.toLowerCase()}`,
                children: [
                  /* @__PURE__ */ s("span", { style: { ...bo, background: So(a.status) }, "aria-hidden": "true" }),
                  c
                ]
              }
            )
          ]
        },
        a.id
      );
    }) }),
    i ? /* @__PURE__ */ d("div", { style: wo, children: [
      /* @__PURE__ */ d("div", { style: ko, children: [
        /* @__PURE__ */ s("span", { className: "t-mono", style: { color: "var(--text-primary)" }, children: i.nodeKey ?? `${i.nodeId.slice(0, 8)}…` }),
        /* @__PURE__ */ d("span", { style: { display: "inline-flex", gap: "var(--sp-2)", alignItems: "center" }, children: [
          /* @__PURE__ */ s("span", { className: `badge ${Co(i.status)}`, children: i.status }),
          /* @__PURE__ */ s("span", { children: jt(i.startedAt ?? null, i.finishedAt ?? null) })
        ] })
      ] }),
      /* @__PURE__ */ s("div", { style: _o, children: /* @__PURE__ */ s(xo, { node: i }) })
    ] }) : /* @__PURE__ */ s("div", { style: { fontSize: "var(--fs-xs)", color: "var(--text-muted)", paddingTop: 2 }, children: "Select a step to read what happened." })
  ] });
}
function xo({ node: e }) {
  const t = e.input != null, n = e.output != null, r = e.error != null;
  return !t && !n && !r ? /* @__PURE__ */ s(
    "div",
    {
      className: "pa-chat-tool-detail",
      style: { fontSize: "var(--fs-xs)", color: "var(--text-muted)" },
      children: "No input or output was recorded for this step."
    }
  ) : /* @__PURE__ */ d("div", { className: "pa-chat-tool-detail", children: [
    t ? /* @__PURE__ */ s(xt, { label: "input", children: /* @__PURE__ */ s(He, { value: e.input }) }) : null,
    n ? /* @__PURE__ */ s(xt, { label: "output", children: /* @__PURE__ */ s(He, { value: e.output }) }) : null,
    r ? /* @__PURE__ */ s(xt, { label: "error", danger: !0, children: /* @__PURE__ */ s(He, { value: e.error }) }) : null
  ] });
}
function xt({
  label: e,
  danger: t,
  defaultOpen: n = !0,
  children: r
}) {
  const [i, a] = z(n);
  return /* @__PURE__ */ d("div", { children: [
    /* @__PURE__ */ d(
      "button",
      {
        type: "button",
        className: "pa-chat-tool-pane-label",
        onClick: () => a((o) => !o),
        "aria-expanded": i,
        style: {
          display: "inline-flex",
          alignItems: "center",
          gap: 4,
          background: "transparent",
          border: 0,
          padding: 0,
          cursor: "pointer",
          ...t ? { color: "var(--status-danger)" } : {}
        },
        children: [
          /* @__PURE__ */ s("span", { "aria-hidden": "true", children: i ? "▾" : "▸" }),
          e
        ]
      }
    ),
    i ? r : null
  ] });
}
function So(e) {
  return e === "COMPLETED" ? "var(--status-completed)" : e === "FAILED" ? "var(--status-failed)" : e === "RUNNING" ? "var(--status-running)" : e === "PAUSED" ? "var(--status-input-required)" : e === "SKIPPED" ? "var(--status-neutral)" : "var(--status-pending)";
}
function Co(e) {
  return e === "COMPLETED" ? "badge--success" : e === "FAILED" ? "badge--danger" : e === "RUNNING" || e === "PAUSED" ? "badge--warning" : "badge--neutral";
}
const Mo = {
  COMPLETED: { label: "Fixed automatically", tone: "ok" },
  PAUSED: { label: "Needs a decision", tone: "warn" },
  FAILED: { label: "Didn’t finish", tone: "bad" },
  RUNNING: { label: "Working on it", tone: "info" },
  PENDING: { label: "Working on it", tone: "info" },
  CANCELLED: { label: "Stopped", tone: "neutral" },
  ABORTED: { label: "Stopped", tone: "neutral" }
};
function Gt(e) {
  return Mo[e] ?? { label: e, tone: "neutral" };
}
const $o = {
  ok: { fg: "var(--status-completed)", bg: "var(--status-completed-bg)" },
  warn: { fg: "var(--status-input-required)", bg: "var(--status-input-required-bg)" },
  bad: { fg: "var(--status-failed)", bg: "var(--status-failed-bg)" },
  info: { fg: "var(--status-running)", bg: "var(--status-running-bg)" },
  neutral: { fg: "var(--status-neutral)", bg: "var(--status-neutral-bg)" }
};
function zr(e) {
  return $o[e];
}
const To = {
  ok: "success",
  warn: "warning",
  bad: "danger",
  info: "info",
  neutral: "neutral"
};
function Pr(e) {
  return `badge badge--${To[e]}`;
}
const Io = ["device", "deviceId", "device_id", "robot", "robotId", "agv", "unit"], Ro = ["message", "summary", "description", "alarm", "text", "title"];
function Dr(e, t) {
  if (!e) return null;
  for (const n of t) {
    const r = e[n];
    if (typeof r == "string" && r.trim().length > 0) return r.trim();
  }
  return null;
}
function Er(e) {
  return Dr(e.input, Io);
}
function jr(e, t) {
  const n = Dr(e.input, Ro);
  return n ? Ao(n, 72) : t && t.trim().length > 0 ? t.trim() : `Run ${e.id.slice(0, 8)}…`;
}
function Ao(e, t) {
  const r = (e.split(new RegExp("(?<=[.!?])\\s"))[0] ?? e).replace(/\s+/g, " ").trim();
  return r.length <= t ? r.replace(/\.$/, "") : `${r.slice(0, t - 1).trimEnd()}…`;
}
function zo({
  runId: e,
  adapter: t,
  onDismiss: n
}) {
  const r = t.useIncidentRun(e), i = t.useIncidentNodeExecutions(e), a = r.data;
  if (r.isLoading || !a)
    return /* @__PURE__ */ s("div", { className: "injected-incident injected-incident--loading", children: /* @__PURE__ */ s(dt, {}) });
  const o = Gt(a.status), l = zr(o.tone), c = Er(a), u = jr(a, null), h = i.data ?? [];
  return /* @__PURE__ */ d(
    "div",
    {
      className: "injected-incident",
      style: { "--incident-tone": l.fg },
      "aria-label": `Incident: ${u}`,
      children: [
        /* @__PURE__ */ d("div", { className: "injected-incident__head", children: [
          /* @__PURE__ */ s("span", { className: "injected-incident__title", title: u, children: u }),
          /* @__PURE__ */ s("span", { className: Pr(o.tone), children: o.label }),
          n ? /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              className: "injected-incident__dismiss",
              onClick: n,
              "aria-label": "Remove incident from chat",
              title: "Remove from chat",
              children: "✕"
            }
          ) : null
        ] }),
        /* @__PURE__ */ d("div", { className: "injected-incident__meta", children: [
          c ? /* @__PURE__ */ d(re, { children: [
            /* @__PURE__ */ s("span", { className: "t-mono", children: c }),
            /* @__PURE__ */ s("span", { "aria-hidden": "true", children: "·" })
          ] }) : null,
          /* @__PURE__ */ s("span", { children: tr(a.startedAt ?? a.createdAt) }),
          /* @__PURE__ */ s("span", { "aria-hidden": "true", children: "·" }),
          /* @__PURE__ */ d("span", { children: [
            h.length,
            " step",
            h.length === 1 ? "" : "s"
          ] })
        ] }),
        i.isLoading ? /* @__PURE__ */ s(dt, {}) : /* @__PURE__ */ s(No, { executions: h })
      ]
    }
  );
}
function Po(e, t, n) {
  const r = new Set(n), i = /* @__PURE__ */ new Set(), a = [];
  for (const o of e)
    !i.has(o.runId) && !r.has(o.runId) && (i.add(o.runId), a.push(o));
  for (const o of t)
    !i.has(o) && !r.has(o) && (i.add(o), a.push({ runId: o }));
  return a;
}
const Do = 6e4, Cn = "Stop — I interrupted this turn. Acknowledge briefly and wait.";
function Eo({
  groupId: e,
  threadId: t,
  thinking: n,
  onThinkingChange: r,
  onNavigate: i,
  onTurnComplete: a,
  autoReadAloud: o,
  onAutoReadAloudChange: l,
  initialMessage: c,
  renderLeadingSlot: u,
  renderToolCall: h,
  renderToolValueExtra: f,
  renderAboveComposer: m
}) {
  var de;
  const y = mt(), { token: g, pageCatalog: k, voiceEnabled: x, incidentsAdapter: b } = Qe(), M = Dt(), $ = Ri(e, t), N = $.status ?? "STARTING", E = N === "STOPPED" || N === "FAILED", j = c != null && c.trim() ? c.trim() : null, [S, _] = z(
    () => j ? [
      {
        localId: "pa-initial",
        text: j,
        delivery: "now",
        kind: "instruction",
        wasWorking: !1
      }
    ] : []
  ), I = P(0), p = P(j), T = P("STARTING"), R = P(-1), v = P(/* @__PURE__ */ new Map()), [w, O] = z(0), [B, W] = z(null), G = P(null), D = P(0), F = V(() => {
    const L = G.current;
    if (L) {
      try {
        L.pause(), L.src = "";
      } catch {
      }
      G.current = null;
    }
    W(null);
  }, []), J = V(
    async (L) => {
      if (!L.trim())
        return;
      F();
      const H = ++D.current;
      W({ loading: !0 });
      try {
        const Y = await di(L, g);
        if (D.current !== H)
          return;
        const X = new Audio(Y);
        G.current = X;
        const q = () => {
          G.current === X && (G.current = null, W(null));
        };
        X.addEventListener("ended", q), X.addEventListener("error", q), W({ loading: !1 }), await X.play();
      } catch (Y) {
        console.error("PaChatView: TTS playback failed", Y), W(null), G.current = null;
      }
    },
    [F, g]
  );
  K(() => F, [F]);
  const ie = Q(() => {
    const L = [];
    for (const H of $.events)
      H.runId && L.push({ runId: H.runId, at: H.at });
    return L.reverse();
  }, [$.events]), ee = Q(
    () => b ? Po(
      ie,
      M.injectionsFor(t),
      M.detachedFor(t)
    ) : [],
    [b, ie, M, t]
  ), me = Q(
    () => Ei({
      transcript: $.transcript,
      optimistic: S,
      events: $.events,
      incidents: ee,
      status: N
    }),
    [$.transcript, $.events, S, ee, N]
  ), le = qe({
    // `delivery` is almost always 'now'; the Stop button sends 'interrupt',
    // which makes the host abort the in-flight run before delivering the turn
    // (see the PA host's delivery plan — steering).
    mutationFn: ({ content: L, delivery: H }) => y.http.post(`v1/persistent-agent-groups/${e}/agents/${t}/events`, {
      json: {
        kind: "instruction",
        delivery: H,
        content: L,
        turnOptions: { thinking: n, pageCatalog: k }
      }
    }).json()
  }), ye = N === "IDLE" || N === "WAITING_FOR_INPUT";
  K(() => {
    const L = T.current;
    T.current = N, !(L !== "WORKING" || !ye) && (a == null || a(p.current));
  }, [N]), K(() => {
    var X;
    if (!o || !x || !ye) return;
    const L = $.transcript;
    let H = -1;
    for (let q = L.length - 1; q >= 0; q--)
      if (((X = L[q]) == null ? void 0 : X.type) === "user") {
        H = q;
        break;
      }
    if (H <= R.current) return;
    R.current = H;
    const Y = L.slice(H + 1).filter(
      (q) => q.type === "text"
    ).map((q) => q.text).join("");
    Y.trim() && (J(Y), void 0);
  }, [N, ye, $.transcript, o, x, J]);
  const ce = le.mutate, ae = V(
    (L, H, Y = "now") => {
      v.current.set(L, Date.now()), ce(
        { content: H, delivery: Y },
        {
          // Keep the optimistic bubble but mark it settled once the echo will
          // arrive (so it keeps a stable key), or failed so the user can retry.
          onSuccess: () => _(
            (X) => X.map((q) => q.localId === L ? { ...q, settled: !0 } : q)
          ),
          onError: () => _(
            (X) => X.map((q) => q.localId === L ? { ...q, failed: !0 } : q)
          )
        }
      );
    },
    [ce]
  ), be = V(
    (L) => {
      const H = L.trim();
      if (!H)
        return;
      I.current += 1;
      const Y = `pa-${I.current}`;
      p.current === null && (p.current = H);
      const X = N === "WORKING";
      _((q) => [
        ...q,
        { localId: Y, text: H, delivery: "now", kind: "instruction", wasWorking: X }
      ]), ae(Y, H);
    },
    [ae, N]
  ), Oe = V(() => {
    I.current += 1;
    const L = `pa-${I.current}`;
    _((H) => [
      ...H,
      {
        localId: L,
        text: Cn,
        delivery: "now",
        kind: "instruction",
        wasWorking: !0
      }
    ]), ae(L, Cn, "interrupt");
  }, [ae]);
  K(() => {
    const L = /* @__PURE__ */ new Set();
    for (const fe of $.transcript)
      fe.type === "user" && L.add(fe.text.trim());
    const { changed: H, next: Y, nextDeadlineMs: X } = Bi(
      S,
      L,
      v.current,
      Date.now(),
      Do
    );
    if (H) {
      _(Y);
      return;
    }
    if (X == null) return;
    const q = setTimeout(() => O((fe) => fe + 1), X + 50);
    return () => clearTimeout(q);
  }, [S, $.transcript, w]);
  const Ne = P([]);
  K(() => {
    Ne.current = S;
  }, [S]);
  const C = V(
    (L) => {
      const H = "optimistic-";
      if (!L.startsWith(H))
        return;
      const Y = L.slice(H.length), X = Ne.current.find((q) => q.localId === Y && q.failed);
      X && (_((q) => q.filter((fe) => fe.localId !== Y)), be(X.text));
    },
    [be]
  ), A = P(/* @__PURE__ */ new Set()), U = P(/* @__PURE__ */ new Set()), Z = P(null);
  K(() => {
    j && Z.current !== t && (Z.current = t, ae("pa-initial", j));
  }, [j, t, ae]);
  const te = P(/* @__PURE__ */ new Set()), ue = P(!1);
  K(() => {
    for (const L of $.transcript) {
      if (Lo(L)) {
        U.current.has(L.toolCallId) || (U.current.add(L.toolCallId), ct.publishResult({
          toolCallId: L.toolCallId,
          result: L.result,
          durationMs: L.durationMs
        }));
        continue;
      }
      if (!jo(L) || (A.current.has(L.toolCallId) || (A.current.add(L.toolCallId), ct.publishCall({
        toolCallId: L.toolCallId,
        name: L.name,
        args: L.args,
        threadId: t
      })), L.name !== "navigate_to_page") || te.current.has(L.toolCallId))
        continue;
      const H = L.args, Y = typeof (H == null ? void 0 : H.url) == "string" ? H.url : null;
      if (Y) {
        if (!i) {
          ue.current || (ue.current = !0, console.warn(
            "@formant/chat: the agent issued a `navigate_to_page` tool call, but no `onNavigate` handler is configured on <ChatProvider>. Navigation was not performed."
          ));
          continue;
        }
        te.current.add(L.toolCallId), i(Y);
      }
    }
  }, [$.transcript, t, i]);
  const Fe = Q(() => ie.map((L) => L.runId), [ie]), pe = V(
    (L) => b ? /* @__PURE__ */ s(
      zo,
      {
        runId: L,
        adapter: b,
        onDismiss: () => {
          M.detach(t, L), b.detachIncident(t, L);
        }
      }
    ) : null,
    [b, M, t]
  ), gt = (u == null ? void 0 : u({ threadId: t, feedRunIds: Fe })) ?? null, yt = Q(() => ({ groupId: e, threadId: t }), [e, t]), Te = Q(
    () => ({ renderToolCall: h, renderToolValueExtra: f }),
    [h, f]
  ), ne = Q(
    () => ({
      persistentAgentId: t,
      fetchImage: async (L) => {
        try {
          return await y.http.get(`v1/persistent-agents/${t}/images/${L}`).blob();
        } catch {
          return null;
        }
      }
    }),
    [y, t]
  );
  return /* @__PURE__ */ d("div", { className: "pa-chat-view", children: [
    /* @__PURE__ */ s("div", { className: "pa-chat-view__scroll", children: /* @__PURE__ */ s($s, { value: Te, children: /* @__PURE__ */ s(wa, { value: yt, children: /* @__PURE__ */ s(Pa, { value: ne, children: /* @__PURE__ */ s(
      ao,
      {
        items: me,
        status: N,
        activity: $.activity,
        connection: $.connection,
        onRetry: C,
        loading: !$.hasLoaded,
        leadingSlot: gt,
        renderIncident: b ? pe : void 0,
        minimalChrome: !0
      },
      t
    ) }) }) }) }),
    le.isError && /* @__PURE__ */ s("div", { className: "chat-launcher__error", children: String(((de = le.error) == null ? void 0 : de.message) ?? "Failed to send message") }),
    (m == null ? void 0 : m({ threadId: t, transcript: $.transcript })) ?? null,
    /* @__PURE__ */ s(
      so,
      {
        onSend: be,
        onInterrupt: Oe,
        disabled: E,
        busy: N === "WORKING",
        autosendOnDictation: x,
        pushToDictateKey: x ? "d" : void 0,
        hideDictation: !x,
        thinking: n,
        onThinkingChange: r,
        autoReadAloud: x ? o : void 0,
        onAutoReadAloudChange: x ? l : void 0,
        audioPlaying: B !== null,
        onStopAudio: F,
        onDictationStart: F
      }
    )
  ] });
}
function jo(e) {
  return e.type === "tool-call";
}
function Lo(e) {
  return e.type === "tool-result";
}
const Oo = `
@keyframes skeleton-pulse {
  0%, 100% { opacity: 0.4; }
  50% { opacity: 0.8; }
}
`, Mn = {
  background: "var(--surface-2)",
  borderRadius: "var(--radius-sm)",
  animation: "skeleton-pulse 1.5s ease-in-out infinite"
};
function Fo() {
  return /* @__PURE__ */ s("style", { children: Oo });
}
function Lr({ rows: e = 6 }) {
  return /* @__PURE__ */ d(re, { children: [
    /* @__PURE__ */ s(Fo, {}),
    /* @__PURE__ */ s(
      "div",
      {
        style: { display: "flex", flexDirection: "column", gap: 2, padding: "var(--sp-2, 8px)" },
        "aria-hidden": "true",
        children: Array.from({ length: e }, (t, n) => /* @__PURE__ */ d(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 6,
              padding: "var(--sp-2, 8px) var(--sp-3, 12px)"
            },
            children: [
              /* @__PURE__ */ s("div", { style: { ...Mn, width: `${72 - n % 3 * 14}%`, height: 12 } }),
              /* @__PURE__ */ s("div", { style: { ...Mn, width: "34%", height: 9 } })
            ]
          },
          n
        ))
      }
    )
  ] });
}
function Wo(e, t) {
  const n = `v1/persistent-agent-groups/${e}/agents`;
  return t === "me" ? `${n}?owner=me` : n;
}
function Bo(e) {
  return e === "all" ? "all" : "me";
}
function Ko(e) {
  const { groupId: t, activePaThreadId: n, onSelectThread: r, onNewChat: i, newChatBusy: a, onPaArchived: o } = e, l = e.extraThreadRows ?? Uo, c = mt(), u = An(), { ready: h, token: f, identityKey: m } = Qe(), [y, g] = z(() => {
    try {
      return Bo(localStorage.getItem($n));
    } catch {
      return "me";
    }
  }), k = (_) => {
    g(_);
    try {
      localStorage.setItem($n, _);
    } catch {
    }
  }, x = zn({
    // `owner` is part of the key so switching Mine/All refetches the right set.
    // `identityKey` scopes the cache per tenant so one org's list never leaks
    // into another after a sign-out / org-switch.
    queryKey: ["persistent-agents", "chat-threads", m, t, y],
    queryFn: () => c.http.get(Wo(t, y)).json(),
    enabled: h && !!f
  }), b = qe({
    mutationFn: (_) => c.http.delete(`v1/persistent-agent-groups/${t}/agents/${_}`).json(),
    // Optimistic: drop the row from every cached list under this group (all the
    // owner-scoped sidebar keys AND the hook's owner-less resolution key) so the
    // sidebar row and — via the shared list feeding active-thread resolution —
    // the open transcript both clear in the same tick, instead of lingering for
    // the DELETE round-trip plus the follow-up refetch. Roll back on error;
    // reconcile on settle.
    onMutate: async (_) => {
      const I = ["persistent-agents", "chat-threads", m, t];
      await u.cancelQueries({ queryKey: I });
      const p = u.getQueriesData({ queryKey: I });
      return u.setQueriesData(
        { queryKey: I },
        (T) => T && {
          ...T,
          items: T.items.filter((R) => R.id !== _),
          total: Math.max(0, T.total - 1)
        }
      ), { prev: p };
    },
    onError: (_, I, p) => {
      for (const [T, R] of (p == null ? void 0 : p.prev) ?? []) u.setQueryData(T, R);
    },
    onSettled: () => (u.invalidateQueries({
      queryKey: ["persistent-agents", "chat-threads", m, t]
    }), void 0)
  }), M = qe({
    mutationFn: ({ id: _, name: I }) => c.http.patch(`v1/persistent-agent-groups/${t}/agents/${_}`, { json: { name: I } }).json(),
    onMutate: async ({ id: _, name: I }) => {
      const p = ["persistent-agents", "chat-threads", m, t];
      await u.cancelQueries({ queryKey: p });
      const T = u.getQueriesData({ queryKey: p });
      return u.setQueriesData(
        { queryKey: p },
        (R) => R && { ...R, items: R.items.map((v) => v.id === _ ? { ...v, name: I } : v) }
      ), { prev: T };
    },
    onError: (_, I, p) => {
      for (const [T, R] of (p == null ? void 0 : p.prev) ?? []) u.setQueryData(T, R);
    },
    onSettled: () => (u.invalidateQueries({
      queryKey: ["persistent-agents", "chat-threads", m, t]
    }), void 0)
  }), [$, N] = z(null), E = (_, I) => {
    var R, v;
    const p = I.trim();
    N(null);
    const T = _.kind === "pa" ? _.title : _.row.title;
    !p || p === T || (_.kind === "pa" ? M.mutate({ id: _.id, name: p }) : (v = (R = _.row).onRename) == null || v.call(R, p));
  }, j = Q(
    () => {
      var _;
      return Ho({ paItems: ((_ = x.data) == null ? void 0 : _.items) ?? [], extraRows: l });
    },
    [x.data, l]
  ), S = x.isLoading;
  return /* @__PURE__ */ d("div", { className: "thread-list", role: "navigation", "aria-label": "Chat history", children: [
    /* @__PURE__ */ d("div", { className: "thread-list__filter", role: "group", "aria-label": "Filter chats by owner", children: [
      /* @__PURE__ */ s(
        "button",
        {
          type: "button",
          className: y === "all" ? "thread-list__filter-btn thread-list__filter-btn--active" : "thread-list__filter-btn",
          "aria-pressed": y === "all",
          onClick: () => k("all"),
          children: "All"
        }
      ),
      /* @__PURE__ */ s(
        "button",
        {
          type: "button",
          className: y === "me" ? "thread-list__filter-btn thread-list__filter-btn--active" : "thread-list__filter-btn",
          "aria-pressed": y === "me",
          onClick: () => k("me"),
          children: "Mine"
        }
      )
    ] }),
    /* @__PURE__ */ d(
      "button",
      {
        type: "button",
        className: "thread-list__new",
        onClick: i,
        disabled: a,
        title: "Start a new chat",
        children: [
          /* @__PURE__ */ s(Jo, {}),
          /* @__PURE__ */ s("span", { children: "New chat" })
        ]
      }
    ),
    S ? /* @__PURE__ */ s(Lr, { rows: 6 }) : x.error ? /* @__PURE__ */ d("div", { className: "thread-list__state thread-list__state--error", children: [
      "Failed to load: ",
      x.error.message
    ] }) : j.length === 0 ? /* @__PURE__ */ s("div", { className: "thread-list__state", children: "No prior chats." }) : /* @__PURE__ */ s("ul", { className: "thread-list__rows", children: j.map((_) => {
      const I = _.kind === "pa" ? _.id === n : _.row.active, p = _.kind === "pa" ? _.title : _.row.title, T = _.kind === "pa" ? _.iso : _.row.iso, R = _.kind === "pa" || !!_.row.onArchive, v = _.kind === "pa" ? "Remove chat" : _.row.archiveLabel ?? "Archive chat", w = `${_.kind}:${_.id}`, O = _.kind === "pa" || !!_.row.onRename, B = ($ == null ? void 0 : $.key) === w;
      return /* @__PURE__ */ d("li", { className: "thread-list__item", children: [
        B ? /* @__PURE__ */ s("div", { className: "thread-list__row thread-list__row--editing", children: /* @__PURE__ */ s(
          "input",
          {
            autoFocus: !0,
            className: "thread-list__title-input",
            value: $.value,
            "aria-label": "Rename chat",
            onChange: (W) => N({ key: w, value: W.target.value }),
            onKeyDown: (W) => {
              W.key === "Enter" ? E(_, $.value) : W.key === "Escape" && N(null);
            },
            onBlur: () => E(_, $.value)
          }
        ) }) : /* @__PURE__ */ d(
          "button",
          {
            type: "button",
            className: I ? "thread-list__row thread-list__row--active" : "thread-list__row",
            onClick: () => _.kind === "pa" ? r(_.data) : _.row.onSelect(),
            onDoubleClick: O ? () => N({ key: w, value: p }) : void 0,
            title: p,
            children: [
              /* @__PURE__ */ s("span", { className: "thread-list__title", children: p }),
              /* @__PURE__ */ s("span", { className: "thread-list__meta", children: zi(T) })
            ]
          }
        ),
        O && !B ? /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            className: "thread-list__rename",
            title: "Rename chat",
            "aria-label": "Rename chat",
            onClick: (W) => {
              W.stopPropagation(), N({ key: w, value: p });
            },
            children: /* @__PURE__ */ s(Xo, {})
          }
        ) : null,
        R && !B ? /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            className: "thread-list__archive",
            title: v,
            "aria-label": v,
            onClick: (W) => {
              var G, D;
              W.stopPropagation(), _.kind === "pa" ? (o == null || o(_.id), b.mutate(_.id)) : (D = (G = _.row).onArchive) == null || D.call(G);
            },
            children: "×"
          }
        ) : null
      ] }, w);
    }) })
  ] });
}
const $n = "console.chatOwnerFilter", Uo = [];
function Ho(e) {
  const { paItems: t, extraRows: n } = e, r = t.map((a) => ({
    kind: "pa",
    id: a.id,
    title: a.name ?? "Untitled chat",
    ts: qo(a),
    iso: Vo(a),
    data: a
  })), i = n.map((a) => ({
    kind: "extra",
    id: a.id,
    ts: a.ts,
    row: a
  }));
  return [...r, ...i].sort((a, o) => o.ts - a.ts);
}
function Nl(e) {
  const { id: t, paItems: n, extraIds: r, loading: i } = e;
  return r.includes(t) ? "extra" : n.some((a) => a.id === t) ? "pa" : i ? "loading" : "pa";
}
function Go(e) {
  const t = e instanceof Date ? e.toISOString() : String(e), n = new Date(t).getTime();
  return Number.isNaN(n) ? 0 : n;
}
function Or(e) {
  return e.lastMessageAt ?? e.startedAt;
}
function qo(e) {
  return Go(Or(e));
}
function Vo(e) {
  const t = Or(e);
  return t instanceof Date ? t.toISOString() : String(t);
}
function Jo() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      children: /* @__PURE__ */ s("path", { d: "M12 5v14M5 12h14" })
    }
  );
}
function Xo() {
  return /* @__PURE__ */ d(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ s("path", { d: "M12 20h9" }),
        /* @__PURE__ */ s("path", { d: "M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z" })
      ]
    }
  );
}
function ht({ open: e, side: t }) {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      style: {
        transform: t === "left" === e ? void 0 : "rotate(180deg)",
        transition: "transform var(--dur-fast, 120ms) var(--ease-out, ease)"
      },
      children: /* @__PURE__ */ s("path", { d: "M15 18l-6-6 6-6" })
    }
  );
}
const Yo = 60;
function Fr({
  initial: e,
  min: t,
  max: n,
  handleSide: r,
  onCommit: i,
  onCollapse: a
}) {
  const o = V((b) => Math.min(n, Math.max(t, b)), [t, n]), [l, c] = z(() => o(e)), u = P(l);
  u.current = l;
  const h = P(null), f = P(!1), [m, y] = z(!1), g = V((b) => {
    b.preventDefault(), b.stopPropagation(), b.currentTarget.setPointerCapture(b.pointerId), h.current = { x: b.clientX, w: u.current }, f.current = !1, y(!0);
  }, []), k = V(
    (b) => {
      var j, S;
      const M = h.current;
      if (!M) return;
      const $ = b.clientX - M.x, N = M.w + (r === "right" ? $ : -$);
      if (a && N <= t - Yo) {
        f.current = !0, h.current = null, y(!1);
        try {
          (S = (j = b.currentTarget).releasePointerCapture) == null || S.call(j, b.pointerId);
        } catch {
        }
        a();
        return;
      }
      const E = o(N);
      c(E), u.current = E;
    },
    [o, r, t, a]
  ), x = V(
    (b) => {
      var M, $;
      h.current && (h.current = null, y(!1), ($ = (M = b.currentTarget).releasePointerCapture) == null || $.call(M, b.pointerId), i == null || i(u.current));
    },
    [i]
  );
  return {
    width: l,
    dragging: m,
    handleProps: { onPointerDown: g, onPointerMove: k, onPointerUp: x }
  };
}
function Wr({
  side: e,
  dragging: t,
  handleProps: n
}) {
  return /* @__PURE__ */ s(
    "div",
    {
      className: `chat-resize-handle chat-resize-handle--${e}${t ? " is-dragging" : ""}`,
      role: "separator",
      "aria-orientation": "vertical",
      "aria-label": "Drag to resize",
      ...n
    }
  );
}
function Qo({
  onClose: e,
  onNewChat: t,
  newChatBusy: n,
  title: r,
  sidebar: i,
  incidents: a,
  children: o,
  variant: l = "floating"
}) {
  const c = l === "docked", u = () => ({ w: window.innerWidth, h: window.innerHeight }), [h, f] = z(null), [m, y] = z(!1), [g, k] = z(() => yi(u())), [x, b] = z(!1), [M, $] = z(ki), [N, E] = z(!1), [j] = z(() => Gn("launcherSidebarWidth", 200)), S = Fr({
    initial: j,
    min: 160,
    max: 360,
    handleSide: "right",
    onCommit: (D) => qn("launcherSidebarWidth", D),
    onCollapse: () => {
      $(!0), an(!0);
    }
  }), _ = P(g), I = P(h);
  K(() => {
    _.current = g;
  }, [g]), K(() => {
    I.current = h;
  }, [h]), K(() => {
    if (c || h) return;
    const D = u(), F = vi();
    if (F) {
      f(rn(F, g, D));
      return;
    }
    f({
      x: Math.max(12, Math.round((D.w - g.w) / 2)),
      y: Math.max(12, Math.round((D.h - g.h) / 2))
    });
  }, [h, g]), K(() => {
    function D() {
      const F = u();
      k((J) => St(J, F)), f((J) => J && rn(J, _.current, F));
    }
    return window.addEventListener("resize", D), () => window.removeEventListener("resize", D);
  }, []);
  const p = P(null);
  K(() => {
    if (!m || N) return;
    function D(J) {
      if (!p.current) return;
      const ie = u(), ee = Tn(J.clientX - p.current.dx, 0, ie.w - _.current.w), me = Tn(J.clientY - p.current.dy, 0, ie.h - _.current.h);
      f({ x: ee, y: me });
    }
    function F() {
      y(!1), p.current = null, I.current && wi(I.current);
    }
    return window.addEventListener("pointermove", D), window.addEventListener("pointerup", F), () => {
      window.removeEventListener("pointermove", D), window.removeEventListener("pointerup", F);
    };
  }, [m, N]);
  const T = P(null), R = (D) => (F) => {
    N || (F.preventDefault(), F.stopPropagation(), F.currentTarget.setPointerCapture(F.pointerId), T.current = {
      startX: F.clientX,
      startY: F.clientY,
      startW: g.w,
      startH: g.h,
      axis: D
    }, b(!0));
  }, v = (D) => {
    const F = T.current;
    if (!F) return;
    const J = D.clientX - F.startX, ie = D.clientY - F.startY, ee = St(
      {
        w: F.axis === "s" ? F.startW : F.startW + J,
        h: F.axis === "e" ? F.startH : F.startH + ie
      },
      u()
    );
    k(ee), _.current = ee;
  }, w = (D) => {
    var F, J;
    T.current && (T.current = null, b(!1), (J = (F = D.currentTarget).releasePointerCapture) == null || J.call(F, D.pointerId), bi(_.current));
  }, O = () => $((D) => {
    const F = !D;
    return an(F), F;
  });
  if (K(() => {
    function D(F) {
      F.key === "Escape" && (N ? E(!1) : e());
    }
    return document.addEventListener("keydown", D), () => document.removeEventListener("keydown", D);
  }, [e, N]), !c && !h) return null;
  const B = c || N || !h ? {} : { left: h.x, top: h.y, width: g.w, height: g.h }, W = !!i, G = /* @__PURE__ */ d(
    "div",
    {
      className: `chat-launcher__panel ${c ? "chat-launcher__panel--docked" : ""} ${N ? "is-fullscreen" : ""} ${x ? "is-resizing" : ""}`,
      style: B,
      role: c ? "complementary" : "dialog",
      "aria-label": "Chat",
      children: [
        /* @__PURE__ */ d(
          "div",
          {
            className: `chat-launcher__drag-handle ${m ? "is-dragging" : ""} ${c || N ? "is-locked" : ""}`,
            onPointerDown: (D) => {
              c || N || D.target.closest(
                ".chat-launcher__close, .chat-launcher__new-chat, .chat-launcher__fullscreen"
              ) || h && (p.current = { dx: D.clientX - h.x, dy: D.clientY - h.y }, y(!0));
            },
            children: [
              /* @__PURE__ */ d("div", { className: "chat-launcher__title", children: [
                /* @__PURE__ */ s(rl, {}),
                /* @__PURE__ */ s("span", { children: r })
              ] }),
              /* @__PURE__ */ d("div", { className: "chat-launcher__actions", children: [
                /* @__PURE__ */ d(
                  "button",
                  {
                    type: "button",
                    className: `chat-launcher__new-chat${W && !M ? " chat-launcher__new-chat--rail-open" : ""}`,
                    "aria-label": "Start a new chat",
                    title: "Start a new chat",
                    onClick: t,
                    disabled: n,
                    children: [
                      /* @__PURE__ */ s(el, {}),
                      /* @__PURE__ */ s("span", { children: "New chat" })
                    ]
                  }
                ),
                c ? null : /* @__PURE__ */ s(
                  "button",
                  {
                    type: "button",
                    className: "chat-launcher__fullscreen",
                    "aria-label": N ? "Exit fullscreen" : "Enter fullscreen",
                    "aria-pressed": N,
                    title: N ? "Exit fullscreen" : "Enter fullscreen",
                    onClick: () => E((D) => !D),
                    children: N ? /* @__PURE__ */ s(nl, {}) : /* @__PURE__ */ s(tl, {})
                  }
                ),
                /* @__PURE__ */ s(
                  "button",
                  {
                    type: "button",
                    className: "chat-launcher__close",
                    "aria-label": "Close chat",
                    onClick: e,
                    children: "✕"
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ d("div", { className: "chat-launcher__body", children: [
          W && M ? /* @__PURE__ */ s("aside", { className: "chat-launcher__sidebar chat-launcher__sidebar--collapsed", children: /* @__PURE__ */ d(
            "button",
            {
              type: "button",
              className: "chat-launcher__sidebar-strip",
              onClick: O,
              "aria-label": "Show conversations",
              title: "Show conversations",
              children: [
                /* @__PURE__ */ s(ht, { open: !1, side: "left" }),
                /* @__PURE__ */ s("span", { className: "chat-launcher__vlabel", children: "Chats" })
              ]
            }
          ) }) : null,
          W && !M ? /* @__PURE__ */ d("aside", { className: "chat-launcher__sidebar", style: { flex: `0 0 ${S.width}px` }, children: [
            /* @__PURE__ */ d("div", { className: "chat-launcher__sidebar-head", children: [
              /* @__PURE__ */ s("span", { className: "chat-launcher__sidebar-title", children: "Chats" }),
              /* @__PURE__ */ s(
                "button",
                {
                  type: "button",
                  className: "chat-launcher__sidebar-toggle",
                  onClick: O,
                  "aria-label": "Hide conversations",
                  "aria-expanded": !0,
                  title: "Hide conversations",
                  children: /* @__PURE__ */ s(ht, { open: !0, side: "left" })
                }
              )
            ] }),
            i,
            /* @__PURE__ */ s(Wr, { side: "right", dragging: S.dragging, handleProps: S.handleProps })
          ] }) : null,
          /* @__PURE__ */ s("div", { className: "chat-launcher__main", children: o }),
          a
        ] }),
        !c && !N ? /* @__PURE__ */ d(re, { children: [
          /* @__PURE__ */ s(
            "div",
            {
              className: "chat-launcher__resize-grip chat-launcher__resize-grip--e",
              role: "separator",
              "aria-orientation": "vertical",
              "aria-label": "Resize chat width",
              onPointerDown: R("e"),
              onPointerMove: v,
              onPointerUp: w,
              onPointerCancel: w
            }
          ),
          /* @__PURE__ */ s(
            "div",
            {
              className: "chat-launcher__resize-grip chat-launcher__resize-grip--s",
              role: "separator",
              "aria-orientation": "horizontal",
              "aria-label": "Resize chat height",
              onPointerDown: R("s"),
              onPointerMove: v,
              onPointerUp: w,
              onPointerCancel: w
            }
          ),
          /* @__PURE__ */ s(
            "div",
            {
              className: "chat-launcher__resize-grip chat-launcher__resize-grip--se",
              role: "separator",
              "aria-label": "Resize chat",
              onPointerDown: R("se"),
              onPointerMove: v,
              onPointerUp: w,
              onPointerCancel: w
            }
          )
        ] }) : null
      ]
    }
  );
  return c ? G : Pt(G, document.body);
}
function Zo({ open: e, onToggle: t }) {
  return /* @__PURE__ */ s(
    "button",
    {
      type: "button",
      className: `chat-launcher__button fk-topbar__util fk-topbar__util--ai fk-tip fk-tip--below ${e ? "is-open" : ""}`,
      "data-tip": "Formant AI",
      "aria-pressed": e,
      "aria-label": e ? "Close chat" : "Open chat",
      onClick: t,
      style: { marginRight: "var(--sp-3)" },
      children: /* @__PURE__ */ d(
        "svg",
        {
          className: "icon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: 1.6,
          strokeLinejoin: "round",
          "aria-hidden": "true",
          children: [
            /* @__PURE__ */ s("path", { d: "M11 4l1.6 4.4L17 10l-4.4 1.6L11 16l-1.6-4.4L5 10l4.4-1.6Z" }),
            /* @__PURE__ */ s("path", { d: "M18.5 14.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8Z" })
          ]
        }
      )
    }
  );
}
function Tn(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function el() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      children: /* @__PURE__ */ s("path", { d: "M12 5v14M5 12h14" })
    }
  );
}
function tl() {
  return /* @__PURE__ */ d(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ s("polyline", { points: "15 3 21 3 21 9" }),
        /* @__PURE__ */ s("polyline", { points: "9 21 3 21 3 15" }),
        /* @__PURE__ */ s("line", { x1: "21", y1: "3", x2: "14", y2: "10" }),
        /* @__PURE__ */ s("line", { x1: "3", y1: "21", x2: "10", y2: "14" })
      ]
    }
  );
}
function nl() {
  return /* @__PURE__ */ d(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ s("polyline", { points: "4 14 10 14 10 20" }),
        /* @__PURE__ */ s("polyline", { points: "20 10 14 10 14 4" }),
        /* @__PURE__ */ s("line", { x1: "14", y1: "10", x2: "21", y2: "3" }),
        /* @__PURE__ */ s("line", { x1: "3", y1: "21", x2: "10", y2: "14" })
      ]
    }
  );
}
function rl() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 1.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      children: /* @__PURE__ */ s("path", { d: "M21 11.5a8.38 8.38 0 0 1-8.5 8.5 8.5 8.5 0 0 1-3.7-.84L3 20l1.34-4.07A8.5 8.5 0 1 1 21 11.5z" })
    }
  );
}
const il = 1440 * 60 * 1e3;
function al({
  adapter: e,
  open: t,
  onToggle: n,
  onAddToChat: r,
  onAddToNewThread: i,
  minWidth: a = 300,
  maxWidth: o = 600
}) {
  const { items: l, isLoading: c, error: u } = e.useIncidentRuns(), { seenIds: h } = Dt(), [f, m] = z("all"), [y, g] = z("any"), [k, x] = z(null), [b] = z(() => Gn("incidentsRailWidth", 380)), { width: M, dragging: $, handleProps: N } = Fr({
    initial: b,
    min: a,
    max: o,
    handleSide: "left",
    onCommit: (S) => qn("incidentsRailWidth", S),
    onCollapse: n
  }), E = Q(() => ol(l, f, y), [l, f, y]), j = Q(
    () => l.reduce((S, { run: _ }) => Yt(_, h) ? S + 1 : S, 0),
    [l, h]
  );
  return t ? /* @__PURE__ */ d(
    "aside",
    {
      className: "incidents-rail incidents-rail--open",
      "aria-label": "Incidents",
      style: { "--incidents-rail-w": `${M}px` },
      children: [
        /* @__PURE__ */ s(Wr, { side: "left", dragging: $, handleProps: N }),
        /* @__PURE__ */ d("div", { className: "incidents-rail__head", children: [
          /* @__PURE__ */ d("div", { className: "incidents-rail__title-row", children: [
            /* @__PURE__ */ s("span", { className: "incidents-rail__title", children: "Incidents" }),
            j > 0 ? /* @__PURE__ */ d("span", { className: "incidents-rail__new-badge", children: [
              j,
              " new"
            ] }) : null,
            /* @__PURE__ */ s("span", { className: "incidents-rail__count", children: c ? "" : `${E.length} shown` }),
            /* @__PURE__ */ s(
              "button",
              {
                type: "button",
                className: "incidents-rail__collapse",
                onClick: n,
                "aria-label": "Hide incidents",
                "aria-expanded": !0,
                title: "Hide incidents",
                children: /* @__PURE__ */ s(ht, { open: !0, side: "right" })
              }
            )
          ] }),
          /* @__PURE__ */ d("div", { className: "incidents-rail__filters", children: [
            /* @__PURE__ */ s(
              In,
              {
                label: "Time",
                value: f,
                onChange: (S) => m(S),
                options: [
                  { value: "all", label: "All time" },
                  { value: "day", label: "Last 24 hours" }
                ]
              }
            ),
            /* @__PURE__ */ s(
              In,
              {
                label: "Outcome",
                value: y,
                onChange: (S) => g(S),
                options: [
                  { value: "any", label: "Any outcome" },
                  { value: "bad", label: "Didn’t finish" },
                  { value: "warn", label: "Needs a decision" },
                  { value: "info", label: "Working on it" },
                  { value: "ok", label: "Fixed automatically" },
                  { value: "neutral", label: "Stopped" }
                ]
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ s("div", { className: "incidents-rail__rows", children: c ? /* @__PURE__ */ s(Lr, { rows: 6 }) : u ? /* @__PURE__ */ d("div", { className: "alert alert--danger", style: { margin: "var(--sp-3)" }, children: [
          "Failed to load incidents: ",
          u.message
        ] }) : E.length === 0 ? /* @__PURE__ */ d("div", { className: "incidents-rail__empty", children: [
          /* @__PURE__ */ s("div", { className: "incidents-rail__empty-title", children: "No incidents" }),
          /* @__PURE__ */ s("div", { className: "incidents-rail__empty-desc", children: "Nothing matches these filters yet. Incidents appear here as workflows run." })
        ] }) : E.map((S) => /* @__PURE__ */ s(
          sl,
          {
            item: S,
            unseen: Yt(S.run, h),
            selected: k === S.run.id,
            onSelect: () => x((_) => _ === S.run.id ? null : S.run.id),
            onAddToChat: () => r(S.run.id),
            onAddToNewThread: (_) => i(S.run.id, _)
          },
          S.run.id
        )) })
      ]
    }
  ) : /* @__PURE__ */ s(
    "aside",
    {
      className: "incidents-rail incidents-rail--collapsed",
      "aria-label": "Incidents (collapsed)",
      children: /* @__PURE__ */ d(
        "button",
        {
          type: "button",
          className: "incidents-rail__expand",
          onClick: n,
          "aria-label": j > 0 ? `Show incidents — ${j} new` : "Show incidents",
          "aria-expanded": !1,
          title: j > 0 ? `${j} new` : "Show incidents",
          children: [
            /* @__PURE__ */ s(ht, { open: !1, side: "right" }),
            /* @__PURE__ */ s("span", { className: "incidents-rail__vlabel", children: "Incidents" }),
            j > 0 ? /* @__PURE__ */ s("span", { className: "incidents-rail__strip-badge", children: j }) : null
          ]
        }
      )
    }
  );
}
function sl({
  item: e,
  unseen: t,
  selected: n,
  onSelect: r,
  onAddToChat: i,
  onAddToNewThread: a
}) {
  const { run: o, workflowName: l } = e, c = Gt(o.status), u = zr(c.tone), h = Er(o), f = jr(o, l), m = [
    "incident-row",
    t ? "incident-row--unseen" : "",
    n ? "incident-row--selected" : ""
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ d("div", { className: m, children: [
    /* @__PURE__ */ d(
      "button",
      {
        type: "button",
        className: "incident-row__hit",
        onClick: r,
        "aria-expanded": n,
        "aria-label": `Incident “${f}” — ${c.label}. Select for actions.`,
        children: [
          /* @__PURE__ */ s("span", { className: "incident-row__dot", style: { background: u.fg }, "aria-hidden": "true" }),
          /* @__PURE__ */ d("span", { className: "incident-row__main", children: [
            /* @__PURE__ */ s("span", { className: "incident-row__title", title: f, children: f }),
            /* @__PURE__ */ d("span", { className: "incident-row__meta", children: [
              h ? /* @__PURE__ */ d(re, { children: [
                /* @__PURE__ */ s("span", { className: "incident-row__device t-mono", children: h }),
                /* @__PURE__ */ s("span", { "aria-hidden": "true", children: "·" })
              ] }) : null,
              /* @__PURE__ */ s("span", { children: tr(o.startedAt ?? o.createdAt) }),
              /* @__PURE__ */ s("span", { className: Pr(c.tone), children: c.label })
            ] })
          ] })
        ]
      }
    ),
    n ? /* @__PURE__ */ d("div", { className: "incident-row__actions", children: [
      /* @__PURE__ */ s(
        "button",
        {
          type: "button",
          className: "btn btn--primary btn--sm",
          onClick: i,
          title: "Attach this incident to the current chat thread",
          children: "Add to chat"
        }
      ),
      /* @__PURE__ */ s(
        "button",
        {
          type: "button",
          className: "btn btn--secondary btn--sm",
          onClick: () => a(f),
          title: "Open in a new thread scoped to this incident",
          children: "New thread"
        }
      )
    ] }) : null
  ] });
}
function In({
  label: e,
  value: t,
  onChange: n,
  options: r
}) {
  return /* @__PURE__ */ s("div", { className: "incidents-rail__filter", children: /* @__PURE__ */ s("select", { "aria-label": e, value: t, onChange: (i) => n(i.target.value), children: r.map((i) => /* @__PURE__ */ s("option", { value: i.value, children: i.label }, i.value)) }) });
}
function ol(e, t, n) {
  const r = t === "day" ? Date.now() - il : 0;
  return e.filter(({ run: i }) => !(r > 0 && (i.startedAt ? new Date(i.startedAt).getTime() : new Date(i.createdAt).getTime()) < r || n !== "any" && Gt(i.status).tone !== n));
}
const Rn = "console.chatThinking";
function ll({
  open: e,
  onOpenChange: t,
  renderTrigger: n = !0,
  renderLeadingSlot: r,
  renderToolCall: i,
  renderToolValueExtra: a,
  variant: o = "floating"
} = {}) {
  const l = mt(), c = An(), {
    ready: u,
    token: h,
    groupId: f,
    identityKey: m,
    onNavigate: y,
    incidentsAdapter: g,
    onNotify: k
  } = Qe(), x = Dt(), [b, M] = z(!1), [$, N] = z(_i), E = V(() => {
    N((C) => {
      const A = !C;
      return Ni(A), A;
    });
  }, []), j = e !== void 0, S = j ? e : b, _ = V(
    (C) => {
      j || M(C), t == null || t(C);
    },
    [j, t]
  ), [I, p] = z(null), [T, R] = z(!1), [v, w] = z(() => localStorage.getItem(Rn) !== "0"), O = V((C) => {
    localStorage.setItem(Rn, C ? "1" : "0"), w(C);
  }, []), [B, W] = z(!1), G = zn({
    queryKey: ["persistent-agents", "chat-threads", m, f],
    queryFn: () => l.http.get(`v1/persistent-agent-groups/${f}/agents`).json(),
    enabled: u && !!h
  }), D = qe({
    mutationFn: () => l.http.post(`v1/persistent-agent-groups/${f}/agents`, { json: { initialFacts: [] } }).json(),
    onSuccess: (C) => {
      p({ id: C.id, name: C.name ?? null }), c.invalidateQueries({
        queryKey: ["persistent-agents", "chat-threads", m, f]
      });
    }
  }), F = qe({
    mutationFn: ({ id: C, name: A }) => l.http.patch(`v1/persistent-agent-groups/${f}/agents/${C}`, { json: { name: A } }).json(),
    onSuccess: (C) => {
      p((A) => (A == null ? void 0 : A.id) === C.id ? { id: C.id, name: C.name ?? null } : A), c.invalidateQueries({
        queryKey: ["persistent-agents", "chat-threads", m, f]
      });
    }
  }), J = V(
    (C) => {
      var U;
      if ((I == null ? void 0 : I.id) !== C)
        return;
      const A = (((U = G.data) == null ? void 0 : U.items) ?? []).filter((Z) => Z.id !== C).sort(
        (Z, te) => new Date(String(te.lastActivityAt ?? te.startedAt)).getTime() - new Date(String(Z.lastActivityAt ?? Z.startedAt)).getTime()
      );
      if (A[0]) {
        p({ id: A[0].id, name: A[0].name ?? null });
        return;
      }
      p(null), D.isPending || D.mutate();
    },
    [I, G.data, D]
  ), ie = (I == null ? void 0 : I.name) ?? "Chat", ee = V(() => {
    D.isPending || (p(null), D.mutate());
  }, [D]), me = V(() => {
    var U;
    if (I || D.isPending)
      return;
    if (G.isLoading) {
      R(!0);
      return;
    }
    const A = [...((U = G.data) == null ? void 0 : U.items) ?? []].sort(
      (Z, te) => new Date(String(te.lastActivityAt ?? te.startedAt)).getTime() - new Date(String(Z.lastActivityAt ?? Z.startedAt)).getTime()
    )[0];
    if (A) {
      p({ id: A.id, name: A.name ?? null });
      return;
    }
    u && h ? D.mutate() : R(!0);
  }, [I, D, G.data, G.isLoading, u, h]), le = V(() => _(!S), [S, _]), ye = P(!1);
  K(() => {
    const C = ye.current;
    ye.current = S, S && !C && me();
  }, [S, me]), K(() => {
    function C(A) {
      A.repeat || (A.ctrlKey || A.metaKey) && A.key.toLowerCase() === "d" && (S || (A.preventDefault(), le()));
    }
    return window.addEventListener("keydown", C), () => window.removeEventListener("keydown", C);
  }, [S, le]), K(() => {
    var U;
    if (!T || !u || !h || I || D.isPending || G.isLoading)
      return;
    R(!1);
    const A = [...((U = G.data) == null ? void 0 : U.items) ?? []].sort(
      (Z, te) => new Date(String(te.lastActivityAt ?? te.startedAt)).getTime() - new Date(String(Z.lastActivityAt ?? Z.startedAt)).getTime()
    )[0];
    if (A) {
      p({ id: A.id, name: A.name ?? null });
      return;
    }
    D.mutate();
  }, [T, u, h, I, D, G.isLoading, G.data]);
  const ce = P(!1), ae = V(
    (C) => {
      if (ce.current || !I || I.name !== null || !C)
        return;
      ce.current = !0;
      const A = C.length > 60 ? `${C.slice(0, 57)}…` : C;
      F.mutate({ id: I.id, name: A });
    },
    [I, F]
  ), be = P(null);
  K(() => {
    I && be.current !== I.id && (be.current = I.id, ce.current = I.name !== null);
  }, [I]);
  const Oe = V(
    (C) => {
      if (!g) return;
      const A = () => k == null ? void 0 : k({ kind: "success", text: "Incident added to this chat" });
      if (I) {
        x.inject(I.id, C), g.attachIncident(I.id, C), A();
        return;
      }
      D.mutateAsync().then((U) => (x.inject(U.id, C), A(), g.attachIncident(U.id, C)));
    },
    [g, I, x, D, k]
  ), Ne = V(
    (C, A) => {
      g && (D.mutateAsync().then((U) => (F.mutate({ id: U.id, name: A }), x.inject(U.id, C), g.attachIncident(U.id, C))), void 0);
    },
    [g, x, D, F]
  );
  return /* @__PURE__ */ d(re, { children: [
    n ? /* @__PURE__ */ s(Zo, { open: S, onToggle: le }) : null,
    S ? /* @__PURE__ */ s(
      Qo,
      {
        variant: o,
        onClose: () => _(!1),
        onNewChat: ee,
        newChatBusy: D.isPending,
        title: ie,
        incidents: g ? /* @__PURE__ */ s(
          al,
          {
            adapter: g,
            open: $,
            onToggle: E,
            onAddToChat: Oe,
            onAddToNewThread: Ne,
            minWidth: 240,
            maxWidth: 560
          }
        ) : null,
        sidebar: /* @__PURE__ */ s(
          Ko,
          {
            groupId: f,
            activePaThreadId: (I == null ? void 0 : I.id) ?? null,
            onSelectThread: (C) => p({ id: C.id, name: C.name ?? null }),
            onNewChat: ee,
            newChatBusy: D.isPending,
            onPaArchived: J
          }
        ),
        children: D.error ? /* @__PURE__ */ d("div", { className: "chat-launcher__error", children: [
          "Failed to start chat: ",
          D.error.message
        ] }) : !u || !h ? /* @__PURE__ */ s("div", { className: "chat-launcher__loading", children: "Waiting for sign-in…" }) : I ? /* @__PURE__ */ s(
          Eo,
          {
            groupId: f,
            threadId: I.id,
            thinking: v,
            onThinkingChange: O,
            onNavigate: y,
            onTurnComplete: ae,
            autoReadAloud: B,
            onAutoReadAloudChange: W,
            renderLeadingSlot: r,
            renderToolCall: i,
            renderToolValueExtra: a
          },
          I.id
        ) : /* @__PURE__ */ s("div", { className: "chat-launcher__loading", children: "Starting chat…" })
      }
    ) : null
  ] });
}
const xl = ll;
export {
  ao as AgentChat,
  Pa as AgentImageSourceProvider,
  xl as ChatLauncher,
  vl as ChatProvider,
  ht as CollapseChevron,
  so as Composer,
  za as ElicitationCard,
  wa as ElicitationScopeProvider,
  $r as FleetDataView,
  ii as IncidentInjectionProvider,
  al as IncidentsRail,
  ll as PaChatLauncher,
  Eo as PaChatView,
  Ko as PaThreadList,
  Wr as ResizeHandle,
  $s as ToolRenderProvider,
  He as ToolValue,
  Vo as activityIso,
  qo as activityMs,
  Vs as agentDisplayName,
  Ho as buildThreadRows,
  Ei as buildTimeline,
  _l as collectAgentSourceIds,
  ir as detectFleetData,
  va as elicitationQuickActions,
  wl as loadIncidentsRailOpen,
  Gn as loadPanelWidth,
  Po as mergeIncidents,
  Wo as paAgentsPath,
  Sa as parseRequestHumanInputCall,
  Nl as resolveThreadKind,
  kl as saveIncidentsRailOpen,
  qn as savePanelWidth,
  ci as setTheopolisBaseUrl,
  qs as sourceLabel,
  bl as theopolisBaseUrl,
  Qe as useChatConfig,
  mi as useDictation,
  Dt as useIncidentInjections,
  Fr as useResizableWidth
};
//# sourceMappingURL=index.es.js.map
